export default {
  d20: [
    { roll: 1, probability: 0.05 },
    { roll: 2, probability: 0.05 },
    { roll: 3, probability: 0.05 },
    { roll: 4, probability: 0.05 },
    { roll: 5, probability: 0.05 },
    { roll: 6, probability: 0.05 },
    { roll: 7, probability: 0.05 },
    { roll: 8, probability: 0.05 },
    { roll: 9, probability: 0.05 },
    { roll: 10, probability: 0.05 },
    { roll: 11, probability: 0.05 },
    { roll: 12, probability: 0.05 },
    { roll: 13, probability: 0.05 },
    { roll: 14, probability: 0.05 },
    { roll: 15, probability: 0.05 },
    { roll: 16, probability: 0.05 },
    { roll: 17, probability: 0.05 },
    { roll: 18, probability: 0.05 },
    { roll: 19, probability: 0.05 },
    { roll: 20, probability: 0.05 },
  ],
  d6: [
    { roll: 1, probability: 0.16666666666666666 },
    { roll: 2, probability: 0.16666666666666666 },
    { roll: 3, probability: 0.16666666666666666 },
    { roll: 4, probability: 0.16666666666666666 },
    { roll: 5, probability: 0.16666666666666666 },
    { roll: 6, probability: 0.16666666666666666 },
  ],
  d4: [
    { roll: 1, probability: 0.25 },
    { roll: 2, probability: 0.25 },
    { roll: 3, probability: 0.25 },
    { roll: 4, probability: 0.25 },
  ],
  d6plusd4: [
    { roll: 2, probability: 0.041666666666666664 },
    { roll: 3, probability: 0.08333333333333333 },
    { roll: 4, probability: 0.125 },
    { roll: 5, probability: 0.16666666666666666 },
    { roll: 6, probability: 0.20833333333333334 },
    { roll: 7, probability: 0.16666666666666666 },
    { roll: 8, probability: 0.125 },
    { roll: 9, probability: 0.08333333333333333 },
    { roll: 10, probability: 0.041666666666666664 },
  ],
  d6plusd6: [
    { roll: 2, probability: 0.027777777777777776 },
    { roll: 3, probability: 0.05555555555555555 },
    { roll: 4, probability: 0.08333333333333333 },
    { roll: 5, probability: 0.1111111111111111 },
    { roll: 6, probability: 0.1388888888888889 },
    { roll: 7, probability: 0.16666666666666666 },
    { roll: 8, probability: 0.1388888888888889 },
    { roll: 9, probability: 0.1111111111111111 },
    { roll: 10, probability: 0.08333333333333333 },
    { roll: 11, probability: 0.05555555555555555 },
    { roll: 12, probability: 0.027777777777777776 },
  ],
  d6minusd4: [
    { roll: -3, probability: 0.041666666666666664 },
    { roll: -2, probability: 0.08333333333333333 },
    { roll: -1, probability: 0.125 },
    { roll: 0, probability: 0.16666666666666666 },
    { roll: 1, probability: 0.20833333333333334 },
    { roll: 2, probability: 0.16666666666666666 },
    { roll: 3, probability: 0.125 },
    { roll: 4, probability: 0.08333333333333333 },
    { roll: 5, probability: 0.041666666666666664 },
  ],
  d20plusd4: [
    { roll: 2, probability: 0.0125 },
    { roll: 3, probability: 0.0250 },
    { roll: 4, probability: 0.0375 },
    { roll: 5, probability: 0.0500 },
    { roll: 6, probability: 0.0500 },
    { roll: 7, probability: 0.0500 },
    { roll: 8, probability: 0.0500 },
    { roll: 9, probability: 0.0500 },
    { roll: 10, probability: 0.0500 },
    { roll: 11, probability: 0.0500 },
    { roll: 12, probability: 0.0500 },
    { roll: 13, probability: 0.0500 },
    { roll: 14, probability: 0.0500 },
    { roll: 15, probability: 0.0500 },
    { roll: 16, probability: 0.0500 },
    { roll: 17, probability: 0.0500 },
    { roll: 18, probability: 0.0500 },
    { roll: 19, probability: 0.0500 },
    { roll: 20, probability: 0.0500 },
    { roll: 21, probability: 0.0500 },
    { roll: 22, probability: 0.0375 },
    { roll: 23, probability: 0.0250 },
    { roll: 24, probability: 0.0125 },
  ],
  d20minusd4: [
    { roll: -3, probability: 0.0125 },
    { roll: -2, probability: 0.0250 },
    { roll: -1, probability: 0.0375 },
    { roll: 0, probability: 0.0500 },
    { roll: 1, probability: 0.0500 },
    { roll: 2, probability: 0.0500 },
    { roll: 3, probability: 0.0500 },
    { roll: 4, probability: 0.0500 },
    { roll: 5, probability: 0.0500 },
    { roll: 6, probability: 0.0500 },
    { roll: 7, probability: 0.0500 },
    { roll: 8, probability: 0.0500 },
    { roll: 9, probability: 0.0500 },
    { roll: 10, probability: 0.0500 },
    { roll: 11, probability: 0.0500 },
    { roll: 12, probability: 0.0500 },
    { roll: 13, probability: 0.0500 },
    { roll: 14, probability: 0.0500 },
    { roll: 15, probability: 0.0500 },
    { roll: 16, probability: 0.0500 },
    { roll: 17, probability: 0.0375 },
    { roll: 18, probability: 0.0250 },
    { roll: 19, probability: 0.0125 },
  ],
  npcRaces: [
    "Human",
    "Half-Elf",
    "Half-Orc",
    "Orc",
    "High Elf",
    "Wood Elf",
    "Dark Elf",
    "Dwarf",
    "Duergar",
    "Gnome",
    "Halfling",
    "Tiefling",
    "Dragonborn",
  ],
  shopLocations: [
    "Shop",
    "House",
    "Market stall",
    "Workshop",
    "Laboratory",
    "Smithy",
    "Mansion",
    "Inn",
    "Tavern",
    "Temple",
    "Tower",
    "Castle",
    "Garden",
    "Ship",
    "Cave",
    "Carriage",
    "Hut",
    "Treehouse",
    "Gallery",
    "Ruins",
  ],
  shop_images: [
{ image: "alchemistlab_1", tags: ["shop"] },
{ image: "alchemistlab_2", tags: ["shop"] },
{ image: "alchemistlab_3", tags: ["shop"] },
{ image: "blacksmith_1", tags: ["smithy"] },
{ image: "blacksmith_2", tags: ["smithy", "shop"] },
{ image: "blacksmith_3", tags: ["smithy", "shop", "armory"] },
{ image: "blacksmith_4", tags: ["smithy", "shop", "armory"] },
{ image: "blacksmith_5", tags: ["smithy", "shop", "armory"] },
{ image: "blacksmith_6", tags: ["smithy", "shop"] },
{ image: "blacksmith_7", tags: ["smithy", "shop", "armory"] },
{ image: "castle_1", tags: ["castle", "city", "shop"] },
{ image: "castle_2", tags: ["castle", "city"] },
{ image: "castle_3", tags: ["castle", "city",  "shop"] },
{ image: "city_1", tags: ["city",  "market"] },
{ image: "city_2", tags: ["city",  "market"] },
{ image: "city_3", tags: ["city",  "shop", "market"] },
{ image: "city_4", tags: ["city",  "market"] },
{ image: "city_5", tags: ["city",  "market"] },
{ image: "forest_1", tags: ["forest"] },
{ image: "garden_1", tags: ["hut",  "shop", "garden"] },
{ image: "garden_2", tags: ["hut",  "shop", "garden"] },
{ image: "garden_3", tags: ["hut",  "shop", "garden"] },
{ image: "garden_4", tags: ["hut",  "shop", "garden"] },
{ image: "garden_5", tags: ["hut",  "garden"] },
{ image: "garden_6", tags: [ "garden",  "garden"] },
{ image: "garden_7", tags: [ "garden",  "garden"] },
{ image: "garden_8", tags: [ "garden",  "market", "garden"]},
{ image: "garden_9", tags: [ "garden",  "hut"] },
{ image: "guildhall_1", tags: [ "guild"] },
{ image: "guildhall_2", tags: [ "guild", "shop"] },
{ image: "house_6", tags: ["shop", "city"] },
{ image: "house_7", tags: ["shop", "city"] },
{ image: "house_8", tags: ["shop", "city"] },
{ image: "house_9", tags: ["shop",  "city"] },
{ image: "house_1", tags: ["shop", ] },
{ image: "house_2", tags: ["shop",  "city"] },
{ image: "house_3", tags: ["shop", "city", "market"] },
{ image: "house_4", tags: ["shop", "city", "guild"] },
{ image: "house_5", tags: ["shop",  "city"] },
{ image: "hut_1", tags: ["hut", "shop","exterior"] },
{ image: "market_3", tags: ["market",  "city"] },
{ image: "market_4", tags: ["market",  "city"] },
{ image: "market_5", tags: ["market",  "city"] },
{ image: "market_6", tags: ["market",  "city"] },
{ image: "market_1", tags: ["market",  "city"] },
{ image: "market_2", tags: ["market",  "city"] },
{ image: "placeholder", tags: [ "city", "market"] },
{ image: "ship_2", tags: [ "ship", "ship", "merchant"] },
{ image: "ship_3", tags: [ "ship", "ship", "merchant"] },
{ image: "ship_4", tags: [ "ship", "ship", "merchant"] },
{ image: "ship_5", tags: [ "ship",  "ship", "merchant"] },
{ image: "ship_6", tags: [ "ship", "city", "market"] },
{ image: "ship_7", tags: [ "ship", "ship", "merchant"] },
{ image: "ship_8", tags: [ "ship", "ship", "merchant"] },
{ image: "ship_1", tags: [ "ship", "ship"] },
{ image: "shop_1", tags: ["market", "city", "market"] },
{ image: "shop_2", tags: ["market", "city", "market"] },
{ image: "shop_3", tags: ["market", "city", "market"] },
{ image: "shop_4", tags: ["market",  "city", "market"] },
{ image: "shop_5", tags: [ "shop"] },
{ image: "temple_1", tags: ["temple",  "smithy", "shop"] },
{ image: "temple_2", tags: ["temple",  "merchant"] },
{ image: "tower_1", tags: [ "tower",  "castle"] },
{ image: "tower_2", tags: [ "tower",  "castle"] },
{ image: "tower_3", tags: [ "tower",  "castle"] },
{ image: "treehouse_6", tags: ["hut", "shop"] },
{ image: "treehouse_7", tags: ["hut", "shop"] },
{ image: "treehouse_8", tags: ["hut", "shop"] },
{ image: "treehouse_1", tags: ["hut", "shop"] },
{ image: "treehouse_2", tags: ["hut",  "shop", "market"] },
{ image: "treehouse_3", tags: ["hut",   "shop"] },
{ image: "treehouse_4", tags: ["hut",  "shop"] },
{ image: "treehouse_5", tags: ["hut",  "shop"] },
{ image: "vault_1", tags: [ "merchant", "shop"] },
{ image: "vault_2", tags: [ "merchant", "shop"] },
{ image: "wagon_1", tags: ["wagon", "merchant", "market"] },
{ image: "wagon_2", tags: ["wagon", "merchant", "market"] }
  ],
  npc_images: [
    { image: "dragonborn_1", tags: ["dragonborn", "female"] },
    { image: "dragonborn_2", tags: ["dragonborn", "male"] },
    { image: "dwarf_1", tags: ["dwarf", "male"] },
    { image: "dwarf_2", tags: ["dwarf", "male"] },
    { image: "dwarf_3", tags: ["dwarf", "male"] },
    { image: "dwarf_4", tags: ["dwarf", "male"] },
    { image: "dwarf_5", tags: ["dwarf", "male"] },
    { image: "dwarf_6", tags: ["dwarf", "male"] },
    { image: "dwarf_7", tags: ["dwarf", "male"] },
    { image: "dwarf_8", tags: ["dwarf", "male"] },
    { image: "dwarf_9", tags: ["dwarf", "male"] },
    { image: "dwarf_10", tags: ["dwarf", "male"] },
    { image: "dwarf_11", tags: ["dwarf", "human", "male"] },
    { image: "dwarf_12", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_13", tags: ["dwarf", "male"] },
    { image: "dwarf_14", tags: ["dwarf", "male"] },
    { image: "dwarf_15", tags: ["dwarf", "male"] },
    { image: "dwarf_16", tags: ["dwarf", "male"] },
    { image: "dwarf_17", tags: ["dwarf", "male"] },
    { image: "dwarf_18", tags: ["dwarf", "male"] },
    { image: "dwarf_19", tags: ["dwarf", "human", "male"] },
    { image: "dwarf_20", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_21", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_22", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_23", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_24", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_25", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_26", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_27", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_28", tags: ["dwarf", "human",  "male"] },
    { image: "dwarf_29", tags: ["dwarf", "male"] },
    { image: "elemental_1", tags: ["genasi", "male"] },
    { image: "elemental_2", tags: ["genasi", "male"] },
    { image: "elemental_3", tags: ["genasi", "female"] },
    { image: "elemental_4", tags: ["genasi", "male"] },
    { image: "elf_1", tags: ["elf", "human", "female"] },
    { image: "elf_2", tags: ["elf", "human", "female"] },
    { image: "elf_3", tags: ["elf", "female"] },
    { image: "elf_4", tags: ["elf", "female"] },
    { image: "elf_5", tags: ["elf", "female"] },
    { image: "elf_6", tags: ["elf", "female"] },
    { image: "elf_7", tags: ["elf", "human", "female"] },
    { image: "elf_8", tags: ["elf", "female"] },
    { image: "elf_9", tags: ["elf", "human", "female"] },
    { image: "elf_10", tags: ["elf", "male"] },
    { image: "elf_11", tags: ["elf", "female"] },
    { image: "elf_12", tags: ["dark elf", "elf", "male"] },
    { image: "elf_13", tags: ["dark elf", "elf", "male"] },
    { image: "elf_14", tags: ["dark elf", "elf", "male"] },
    { image: "elf_15", tags: ["dark elf", "elf", "male"] },
    { image: "elf_16", tags: ["elf", "female"] },
    { image: "elf_17", tags: ["elf", "female"] },
    { image: "elf_18", tags: ["elf", "female"] },
    { image: "elf_19", tags: ["elf", "female"] },
    { image: "elf_20", tags: ["dark elf", "elf", "female"] },
    { image: "elf_21", tags: ["dark elf", "elf", "female"] },
    { image: "elf_22", tags: ["elf", "female"] },
    { image: "elf_23", tags: ["dark elf", "elf", "male"] },
    { image: "elf_24", tags: ["dark elf", "elf", "female"] },
    { image: "elf_25", tags: ["dark elf", "elf", "female"] },
    { image: "elf_26", tags: ["dark elf", "elf", "male"] },
    { image: "elf_27", tags: ["dark elf", "elf", "male", "female"] },
    { image: "elf_28", tags: ["elf", "female"] },
    { image: "elf_29", tags: ["dark elf", "elf", "male"] },
    { image: "elf_30", tags: ["dark elf", "elf", "male", "female"] },
    { image: "elf_31", tags: ["dark elf", "elf", "male"] },
    { image: "gnome_1", tags: ["gnome", "male"] },
    { image: "gnome_2", tags: ["gnome", "male"] },
    { image: "gnome_3", tags: ["gnome", "male"] },
    { image: "gnome_4", tags: ["gnome", "male"] },
    { image: "gnome_5", tags: ["gnome", "male"] },
    { image: "gnome_6", tags: ["gnome", "male"] },
    { image: "gnome_7", tags: ["gnome", "male"] },
    { image: "gnome_8", tags: ["gnome", "male"] },
    { image: "goblin_1", tags: ["goblin", "male"] },
    { image: "goblin_2", tags: ["goblin", "female"] },
    { image: "goblin_3", tags: ["goblin", "female"] },
    { image: "goblin_4", tags: ["goblin", "female"] },
    { image: "goblin_5", tags: ["goblin", "male"] },
    { image: "goblin_6", tags: ["goblin", "female"] },
    { image: "human_1", tags: ["human", "male"] },
    { image: "human_2", tags: ["human", "male"] },
    { image: "human_3", tags: ["human", "male"] },
    { image: "human_4", tags: ["human", "male"] },
    { image: "human_5", tags: ["human", "elf", "female"] },
    { image: "human_6", tags: ["human", "male"] },
    { image: "human_7", tags: ["human", "male"] },
    { image: "human_8", tags: ["human", "male"] },
    { image: "human_9", tags: ["human", "elf", "female"] },
    { image: "human_10", tags: ["human", "male"] },
    { image: "human_11", tags: ["human", "elf", "female"] },
    { image: "human_12", tags: ["human", "male"] },
    { image: "human_13", tags: ["human", "elf", "female"] },
    { image: "human_14", tags: ["human", "elf", "female"] },
    { image: "human_15", tags: ["human", "elf", "female"] },
    { image: "human_16", tags: ["human", "elf", "female"] },
    { image: "human_18", tags: ["human", "elf", "female"] },
    { image: "human_19", tags: ["human", "elf", "male"] },
    { image: "human_20", tags: ["human", "male"] },
    { image: "human_21", tags: ["human", "elf", "female"] },
    { image: "human_22", tags: ["human", "elf", "female"] },
    { image: "human_23", tags: ["human", "elf", "female"] },
    { image: "human_24", tags: ["human", "female"] },
    { image: "human_25", tags: ["human", "elf", "female"] },
    { image: "human_26", tags: ["human", "elf", "female"] },
    { image: "human_27", tags: ["human", "elf", "female"] },
    { image: "human_28", tags: ["human", "elf", "female"] },
    { image: "human_29", tags: ["human", "male"] },
    { image: "human_30", tags: ["human", "female"] },
    { image: "human_31", tags: ["human", "male"] },
    { image: "human_32", tags: ["human", "male"] },
    { image: "human_33", tags: ["human", "male"] },
    { image: "human_34", tags: ["human", "male"] },
    { image: "human_35", tags: ["human", "male"] },
    { image: "human_36", tags: ["human", "male"] },
    { image: "human_37", tags: ["human", "male"] },
    { image: "human_38", tags: ["human", "male"] },
    { image: "human_39", tags: ["human", "male"] },
    { image: "human_40", tags: ["human", "male"] },
    { image: "human_41", tags: ["human", "male"] },
    { image: "human_42", tags: ["human", "male"] },
    { image: "human_43", tags: ["human", "male"] },
    { image: "human_44", tags: ["human", "male"] },
    { image: "human_45", tags: ["human", "male"] },
    { image: "human_46", tags: ["human", "female"] },
    { image: "human_47", tags: ["human", "male"] },
    { image: "human_48", tags: ["human", "male"] },
    { image: "human_49", tags: ["human", "male"] },
    { image: "human_50", tags: ["human", "male"] },
    { image: "human_51", tags: ["human", "female"] },
    { image: "human_52", tags: ["human", "male"] },
    { image: "human_53", tags: ["human", "male"] },
    { image: "human_54", tags: ["human", "male"] },
    { image: "human_55", tags: ["human", "female"] },
    { image: "human_56", tags: ["human", "female"] },
    { image: "human_57", tags: ["human", "female"] },
    { image: "human_58", tags: ["human", "male"] },
    { image: "human_59", tags: ["human", "male"] },
    { image: "human_60", tags: ["human", "male"] },
    { image: "human_61", tags: ["human", "male"] },
    { image: "human_62", tags: ["human", "male"] },
    { image: "human_63", tags: ["human", "male"] },
    { image: "human_64", tags: ["human", "male"] },
    { image: "human_65", tags: ["human", "male"] },
    { image: "human_66", tags: ["human", "male"] },
    { image: "human_67", tags: ["human", "female"] },
    { image: "human_68", tags: ["human", "male"] },
    { image: "human_69", tags: ["human", "male"] },
    { image: "human_70", tags: ["human", "female"] },
    { image: "human_71", tags: ["human", "female"] },
    { image: "human_72", tags: ["human", "female"] },
    { image: "human_73", tags: ["human", "male"] },
    { image: "human_74", tags: ["human", "male"] },
    { image: "human_75", tags: ["human", "female"] },
    { image: "human_76", tags: ["human", "female"] },
    { image: "human_77", tags: ["human", "female"] },
    { image: "human_78", tags: ["human", "female"] },
    { image: "human_79", tags: ["human", "female"] },
    { image: "human_80", tags: ["human", "male"] },
    { image: "human_81", tags: ["human", "male"] },
    { image: "human_82", tags: ["human", "female"] },
    { image: "human_83", tags: ["human", "male"] },
    { image: "halfling_1", tags: ["halfling", "male"] },
    { image: "halfling_2", tags: ["halfling", "human", "male"] },
    { image: "halfling_3", tags: ["halfling", "male"] },
    { image: "halfling_4", tags: ["halfling", "male"] },
    { image: "halfling_5", tags: ["halfling", "male"] },
    { image: "halfling_6", tags: ["halfling", "human", "female"] },
    { image: "halfling_7", tags: ["halfling", "female"] },
    { image: "halfling_8", tags: ["halfling", "human", "female"] },
    { image: "halfling_9", tags: ["halfling", "female"] },
    { image: "halfling_10", tags: ["halfling", "female"] },
    { image: "halfling_13", tags: ["halfling", "human", "female"] },
    { image: "halfling_14", tags: ["halfling", "human", "female"] },
    { image: "halfling_15", tags: ["halfling", "human", "female"] },
    { image: "halfling_16", tags: ["halfling", "human", "female"] },
    { image: "halfling_17", tags: ["halfling", "female"] },
    { image: "halfling_18", tags: ["halfling", "female"] },
    { image: "halfling_19", tags: ["halfling", "human", "male"] },
    { image: "halfling_20", tags: ["halfling", "human", "male"] },
    { image: "halfling_21", tags: ["halfling", "human", "male"] },
    { image: "halfling_22", tags: ["halfling", "human", "male"] },
    { image: "M1", tags: ["yuanti", "human", "female", "male"] },
    { image: "M2", tags: ["human", "male", "female"] },
    { image: "M3", tags: ["yuanti", "human", "female"] },
    { image: "minotaur_1", tags: ["minotaur", "male"] },
    { image: "minotaur_2", tags: ["minotaur", "male"] },
    { image: "minotaur_3", tags: ["minotaur", "female"] },
    { image: "ogre_1", tags: ["ogre", "human", "male"] },
    { image: "orc_1", tags: ["orc", "human", "male"] },
    { image: "orc_2", tags: ["orc", "human", "male"] },
    { image: "orc_3", tags: ["orc", "human", "male"] },
    { image: "orc_4", tags: ["orc", "human", "female"] },
    { image: "orc_5", tags: ["orc", "human", "female"] },
    { image: "orc_6", tags: ["orc", "human", "female"] },
    { image: "orc_7", tags: ["orc", "human", "female"] },
    { image: "orc_8", tags: ["orc", "human", "female"] },
    { image: "orc_9", tags: ["orc", "human", "male"] },
    { image: "orc_10", tags: ["orc", "human", "male"] },
    { image: "orc_11", tags: ["orc", "human", "male"] },
    { image: "orc_12", tags: ["orc", "human", "male"] },
    { image: "tiefling_1", tags: ["tiefling", "elf", "male"] },
    { image: "tiefling_2", tags: ["tiefling", "human", "elf", "male"] },
    { image: "tiefling_3", tags: ["tiefling", "human", "elf", "female"] },
    { image: "tiefling_4", tags: ["tiefling", "human", "elf", "female"] },
    { image: "tiefling_6", tags: ["tiefling", "female"] },
  ],
  artCredit: [
    { image: "heavy_armor_1", artist: "Bob Greyvenstein" },
    { image: "heavy_armor_2", artist: "Bob Greyvenstein" },
    { image: "heavy_armor_3", artist: "Bob Greyvenstein" },
    { image: "heavy_armor_4", artist: "Bob Greyvenstein" },
    { image: "heavy_armor_5", artist: "Bob Greyvenstein" },
    { image: "heavy_armor_6", artist: "Mariana Livraes" },
    { image: "medium_armor_1", artist: "Bob Greyvenstein" },
    { image: "medium_armor_2", artist: "Bob Greyvenstein" },
    { image: "medium_armor_3", artist: "Bob Greyvenstein" },
    { image: "medium_armor_4", artist: "Bob Greyvenstein" },
    { image: "medium_armor_5", artist: "Bob Greyvenstein" },
    { image: "medium_armor_6", artist: "Bob Greyvenstein" },
    { image: "medium_armor_7", artist: "Nana Landholt" },
    { image: "light_armor_1", artist: "Bob Greyvenstein" },
    { image: "light_armor_2", artist: "Bob Greyvenstein" },
    { image: "light_armor_3", artist: "Bob Greyvenstein" },
    { image: "light_armor_4", artist: "Bob Greyvenstein" },
    { image: "light_armor_5", artist: "Bob Greyvenstein" },
    { image: "light_armor_6", artist: "Bob Greyvenstein" },
    { image: "light_armor_7", artist: "Nana Landholt" },
    { image: "shield_1", artist: "Bob Greyvenstein" },
    { image: "shield_2", artist: "Bob Greyvenstein" },
    { image: "shield_3", artist: "Bob Greyvenstein" },
    { image: "shield_4", artist: "Bob Greyvenstein" },
    { image: "shield_5", artist: "Nana Landholt" },
    { image: "shield_6", artist: "Nana Landholt" },
    { image: "rod_1", artist: "Bob Greyvenstein" },
    { image: "rod_2", artist: "Bob Greyvenstein" },
    { image: "staff_1", artist: "Bob Greyvenstein" },
    { image: "staff_2", artist: "Bob Greyvenstein" },
    { image: "staff_3", artist: "Bob Greyvenstein" },
    { image: "staff_4", artist: "Nana Landholt" },
    { image: "wand_1", artist: "Bob Greyvenstein" },
    { image: "wand_2", artist: "Bob Greyvenstein" },
    { image: "wand_3", artist: "Bob Greyvenstein" },
    { image: "wand_4", artist: "Bob Greyvenstein" },
    { image: "axe_1", artist: "Bob Greyvenstein" },
    { image: "axe_2", artist: "Bob Greyvenstein" },
    { image: "axe_3", artist: "Bob Greyvenstein" },
    { image: "axe_4", artist: "Nana Landholt" },
    { image: "axe_5", artist: "Nana Landholt" },
    { image: "axe_6", artist: "Nana Landholt" },
    { image: "bow_1", artist: "Bob Greyvenstein" },
    { image: "bow_2", artist: "Bob Greyvenstein" },
    { image: "bow_3", artist: "Bob Greyvenstein" },
    { image: "bow_6", artist: "Nana Landholt" },
    { image: "bow_7", artist: "Nana Landholt" },
    { image: "bow_8", artist: "Nana Landholt" },
    { image: "club_1", artist: "Bob Greyvenstein" },
    { image: "club_2", artist: "Nana Landholt" },
    { image: "crossbow_1", artist: "Bob Greyvenstein" },
    { image: "crossbow_2", artist: "Nana Landholt" },
    { image: "dagger_1", artist: "Bob Greyvenstein" },
    { image: "dagger_2", artist: "Bob Greyvenstein" },
    { image: "dagger_4", artist: "Nana Landholt" },
    { image: "dagger_5", artist: "Nana Landholt" },
    { image: "dagger_6", artist: "Nana Landholt" },
    { image: "hammer_1", artist: "Bob Greyvenstein" },
    { image: "hammer_2", artist: "Nana Landholt" },
    { image: "morningstar_1", artist: "Bob Greyvenstein" },
    { image: "polearm_1", artist: "Bob Greyvenstein" },
    { image: "polearm_2", artist: "Bob Greyvenstein" },
    { image: "polearm_3", artist: "Bob Greyvenstein" },
    { image: "quarterstaff_1", artist: "Bob Greyvenstein" },
    { image: "quarterstaff_2", artist: "Nana Landholt" },
    { image: "scythe_1", artist: "Bob Greyvenstein" },
    { image: "sickle_1", artist: "Bob Greyvenstein" },
    { image: "sickle_2", artist: "Bob Greyvenstein" },
    { image: "sickle_3", artist: "Bob Greyvenstein" },
    { image: "sickle_4", artist: "Nana Landholt" },
    { image: "spear_1", artist: "Bob Greyvenstein" },
    { image: "spear_2", artist: "Bob Greyvenstein" },
    { image: "spear_3", artist: "Mariana Livraes" },
    { image: "sword_2", artist: "Bob Greyvenstein" },
    { image: "sword_3", artist: "Bob Greyvenstein" },
    { image: "sword_4", artist: "Bob Greyvenstein" },
    { image: "sword_5", artist: "Bob Greyvenstein" },
    { image: "sword_7", artist: "Bob Greyvenstein" },
    { image: "sword_8", artist: "Bob Greyvenstein" },
    { image: "sword_9", artist: "Bob Greyvenstein" },
    { image: "sword_12", artist: "Nana Landholt" },
    { image: "sword_13", artist: "Nana Landholt" },
    { image: "sword_14", artist: "Nana Landholt" },
    { image: "sword_15", artist: "Nana Landholt" },
    { image: "trident_1", artist: "Nana Landholt" },
    { image: "whip_1", artist: "Nana Landholt" },
    { image: "belt_1", artist: "Bob Greyvenstein" },
    { image: "belt_2", artist: "Bob Greyvenstein" },
    { image: "belt_3", artist: "Bob Greyvenstein" },
    { image: "belt_4", artist: "Bob Greyvenstein" },
    { image: "belt_5", artist: "Bob Greyvenstein" },
    { image: "belt_6", artist: "Bob Greyvenstein" },
    { image: "belt_7", artist: "Bob Greyvenstein" },
    { image: "belt_8", artist: "Bob Greyvenstein" },
    { image: "belt_9", artist: "Bob Greyvenstein" },
    { image: "belt_10", artist: "Bob Greyvenstein" },
    { image: "belt_11", artist: "Bob Greyvenstein" },
    { image: "belt_12", artist: "Nana Landholt" },
    { image: "boots_1", artist: "Bob Greyvenstein" },
    { image: "boots_2", artist: "Bob Greyvenstein" },
    { image: "boots_3", artist: "Bob Greyvenstein" },
    { image: "boots_4", artist: "Bob Greyvenstein" },
    { image: "boots_5", artist: "Bob Greyvenstein" },
    { image: "boots_6", artist: "Bob Greyvenstein" },
    { image: "boots_7", artist: "Bob Greyvenstein" },
    { image: "boots_8", artist: "Bob Greyvenstein" },
    { image: "boots_9", artist: "Bob Greyvenstein" },
    { image: "boots_10", artist: "Bob Greyvenstein" },
    { image: "boots_11", artist: "Nana Landholt" },
    { image: "boots_12", artist: "Nana Landholt" },
    { image: "bracers_1", artist: "Bob Greyvenstein" },
    { image: "bracers_2", artist: "Bob Greyvenstein" },
    { image: "bracers_3", artist: "Bob Greyvenstein" },
    { image: "bracers_4", artist: "Bob Greyvenstein" },
    { image: "bracers_5", artist: "Bob Greyvenstein" },
    { image: "bracers_6", artist: "Bob Greyvenstein" },
    { image: "bracers_7", artist: "Bob Greyvenstein" },
    { image: "bracers_8", artist: "Bob Greyvenstein" },
    { image: "bracers_9", artist: "Bob Greyvenstein" },
    { image: "bracers_10", artist: "Bob Greyvenstein" },
    { image: "bracers_11", artist: "Bob Greyvenstein" },
    { image: "bracers_12", artist: "Bob Greyvenstein" },
    { image: "bracers_13", artist: "Bob Greyvenstein" },
    { image: "bracers_14", artist: "Bob Greyvenstein" },
    { image: "bracers_15", artist: "Bob Greyvenstein" },
    { image: "bracers_16", artist: "Bob Greyvenstein" },
    { image: "bracers_17", artist: "Bob Greyvenstein" },
    { image: "bracers_18", artist: "Nana Landholt" },
    { image: "bracers_19", artist: "Nana Landholt" },
    { image: "cloak_1", artist: "Bob Greyvenstein" },
    { image: "cloak_2", artist: "Nana Landholt" },
    { image: "cloak_3", artist: "Nana Landholt" },
    { image: "cowl_1", artist: "Bob Greyvenstein" },
    { image: "gauntlets_1", artist: "Bob Greyvenstein" },
    { image: "gauntlets_2", artist: "Bob Greyvenstein" },
    { image: "gauntlets_3", artist: "Bob Greyvenstein" },
    { image: "gauntlets_4", artist: "Nana Landholt" },
    { image: "headdress_1", artist: "Bob Greyvenstein" },
    { image: "helmet_1", artist: "Bob Greyvenstein" },
    { image: "helmet_2", artist: "Bob Greyvenstein" },
    { image: "helmet_3", artist: "Bob Greyvenstein" },
    { image: "helmet_4", artist: "Bob Greyvenstein" },
    { image: "helmet_5", artist: "Nana Landholt" },
    { image: "helmet_6", artist: "Nana Landholt" },
    { image: "hood_1", artist: "Bob Greyvenstein" },
    { image: "mask_1", artist: "Bob Greyvenstein" },
    { image: "potion_19", artist: "Nana Landholt" },
    { image: "potion_20", artist: "Nana Landholt" },
    { image: "potion_21", artist: "Nana Landholt" },
    { image: "potion_22", artist: "Nana Landholt" },
    { image: "potion_23", artist: "Nana Landholt" },
    { image: "potion_24", artist: "Nana Landholt" },
    { image: "potion_25", artist: "Nana Landholt" },
    { image: "ring_5", artist: "Nana Landholt" },
    { image: "ring_6", artist: "Nana Landholt" },
    { image: "ring_7", artist: "Nana Landholt" },
    { image: "ring_8", artist: "Nana Landholt" },
    { image: "scroll_1", artist: "Nana Landholt" },
    { image: "scroll_2", artist: "Nana Landholt" },
    { image: "book_5", artist: "Nana Landholt" },
    { image: "amulet_1", artist: "Nana Landholt" },
    { image: "amulet_2", artist: "Nana Landholt" },
    { image: "amulet_3", artist: "Nana Landholt" },
    { image: "amulet_4", artist: "Nana Landholt" },
    { image: "amulet_5", artist: "Nana Landholt" },
    { image: "mirror_2", artist: "Nana Landholt" },
    { image: "hat_1", artist: "Nana Landholt" },
    { image: "flute_1", artist: "Nana Landholt" },
    { image: "tattoo_1", artist: "Nana Landholt" },
    { image: "tattoo_2", artist: "Nana Landholt" },
    { image: "tattoo_3", artist: "Nana Landholt" },
    { image: "tattoo_4", artist: "Nana Landholt" },
    { image: "tattoo_5", artist: "Nana Landholt" },
    { image: "tattoo_6", artist: "Nana Landholt" },
    { image: "tattoo_7", artist: "Nana Landholt" },
    { image: "tattoo_8", artist: "Nana Landholt" },
  ],
  rarities: [
    "Common",
    "Uncommon",
    "Rare",
    "Very Rare",
    "Legendary",
    "Artifact",
  ],
  attunementChoices: ["Yes", "No"],
  itemTypes: [
    "Armor",
    "Potion",
    "Ring",
    "Rod",
    "Scroll",
    "Staff",
    "Wand",
    "Weapon",
    "Wondrous item",
  ],
  itemTypesE: [
    "Armor",
    "Ring",
    "Rod",
    "Staff",
    "Wand",
    "Weapon",
    "Wondrous item",
  ],
  armors: [
    { name: "Any", light: true, medium: true, heavy: true },
    { name: "Padded Armor", light: true, medium: false, heavy: false },
    { name: "Leather Armor", light: true, medium: false, heavy: false },
    { name: "Studded leather", light: true, medium: false, heavy: false },
    { name: "Hide Armor", light: false, medium: true, heavy: false },
    { name: "Chain shirt", light: false, medium: true, heavy: false },
    { name: "Scale mail", light: false, medium: true, heavy: false },
    { name: "Breastplate", light: false, medium: true, heavy: false },
    { name: "Half plate", light: false, medium: true, heavy: false },
    { name: "Ring mail", light: false, medium: false, heavy: true },
    { name: "Chain mail", light: false, medium: false, heavy: true },
    { name: "Splint", light: false, medium: false, heavy: true },
    { name: "Plate", light: false, medium: false, heavy: true },
    { name: "Shield", light: false, medium: false, heavy: false },
  ],
  wonders: [
    { name: "Any" },
    { name: "Amulet" },
    { name: "Anklet" },
    { name: "Boots" },
    { name: "Belt" },
    { name: "Bracelet" },
    { name: "Bracers" },
    { name: "Brooch" },
    { name: "Cap" },
    { name: "Cape" },
    { name: "Circlet" },
    { name: "Cloak" },
    { name: "Crown" },
    { name: "Earring" },
    { name: "Gauntlets" },
    { name: "Gloves" },
    { name: "Greaves" },
    { name: "Hat" },
    { name: "Headband" },
    { name: "Helmet" },
    { name: "Hood" },
    { name: "Mask" },
    { name: "Mittens" },
    { name: "Necklace" },
    { name: "Nose Ring" },
    { name: "Pants" },
    { name: "Robe" },
    { name: "Sandals" },
    { name: "Scepter" },
    { name: "Shirt" },
    { name: "Slippers" },
  ],
  weapons: [
    {
      name: "Any",
      simple: true,
      martial: true,
      melee: true,
      ranged: true,
      bludgeoning: true,
      piercing: true,
      slashing: true,
    },
    {
      name: "Battleaxe",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Blowgun",
      simple: false,
      martial: true,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Club",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Crossbow, Light",
      simple: true,
      martial: false,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Crossbow, Hand",
      simple: false,
      martial: true,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Crossbow, Heavy",
      simple: false,
      martial: true,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Dagger",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Dart",
      simple: true,
      martial: false,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Flail",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Glaive",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Greataxe",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Greatclub",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Greatsword",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Halberd",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Handaxe",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Javelin",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Lance",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Light Hammer",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Longbow",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Longsword",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Mace",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Maul",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Morningstar",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Net",
      simple: false,
      martial: true,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: false,
      slashing: false,
    },
    {
      name: "Pike",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Quarterstaff",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Rapier",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Sickle",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Scimitar",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
    {
      name: "Shortbow",
      simple: true,
      martial: false,
      melee: false,
      ranged: true,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Shortsword",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Sling",
      simple: true,
      martial: false,
      melee: false,
      ranged: true,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Spear",
      simple: true,
      martial: false,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Trident",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "War Pick",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: true,
      slashing: false,
    },
    {
      name: "Warhammer",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: true,
      piercing: false,
      slashing: false,
    },
    {
      name: "Whip",
      simple: false,
      martial: true,
      melee: true,
      ranged: false,
      bludgeoning: false,
      piercing: false,
      slashing: true,
    },
  ],
  enchantments: [
    {
      name: "Absorption",
      type: "Suffix",
      description:
        "When you take acid, cold, fire, lightning, or thunder damage while carrying this item, you can choose to take no damage instead. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Absorption, Greater",
      type: "Suffix",
      description:
        "When you take acid, cold, fire, lightning, or thunder damage while carrying this item, you can choose to take no damage instead. You gain temporary hit points equal to half the damage prevented this way (rounded down). Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Adamantine",
      type: "Prefix",
      description:
        "While wearing this item, any critical hit against you becomes a normal hit.",
      rarity: 1,
      attunement: "No",
      armor: "MediumHeavy",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Adamantine, Greater",
      type: "Prefix",
      description:
        "While wearing this item, bludgeoning, piercing, and slashing damage that you take from nonmagical weapons is reduced by 3. In addition, any critical hit against you becomes a normal hit.",
      rarity: 2,
      attunement: "No",
      armor: "MediumHeavy",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Adept's",
      type: "Prefix",
      description:
        "While carrying this item, you gain proficiency in a skill (chosen by the DM or rolled on the Ability Score table). If you are already proficient in that skill, your proficiency bonus is doubled for any ability check you make that uses that skill.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Adept's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you gain proficiency in a skill (chosen by the DM or rolled on the Ability Score table). If you are already proficient in that skill, your proficiency bonus is doubled for any ability check you make that uses that skill. In addition, whenever you make an ability check using that skill, you can treat a d20 roll of 9 or lower as a 10.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Agathys",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>armor of Agathys</i>. For 1 charge, you cast the 1st-level version of the spell. You can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Agathys, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>armor of Agathys</i> (1 charge per spell level) or <i>fire shield</i> (4 charges, cold version only). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Airy",
      type: "Common",
      description:
        "This item is unnaturally light, weighing only one tenth of its usual weight. If applied to armor, the armor has no Strength requirement.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Ally's",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 1d6 damage of the weapon's type if at least one of your allies is within 5 feet of the creature and the ally isn't incapacitated.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Ally's, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 2d6 damage of the weapon's type if at least one of your allies is within 5 feet of the creature and the ally isn't incapacitated.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Ambushing",
      type: "Prefix",
      description:
        "When you hit a creature that is surprised with this weapon, the creature takes an extra 2d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Ambushing, Greater",
      type: "Prefix",
      description:
        "When you hit a creature that is surprised with this weapon, the creature takes an extra 4d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Ancients Paladin's",
      type: "Class",
      description:
        "While carrying this item, you can use your Channel Divinity: Nature's Wrath as a bonus action instead of an action.",
      rarity: 1,
      attunement: "Requires attunement by an Ancients paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Ancients Paladin's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can use your Channel Divinity: Nature's Wrath as a bonus action instead of an action, and the range increases to 30 feet.",
      rarity: 2,
      attunement: "Requires attunement by an Ancients paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Animal",
      type: "Common",
      description:
        "This item is fashioned in the likeness of a wild beast. While carrying it, you can use an action to have it make the sound of that animal, such as a bird's chirping or a lion's roar.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Animation",
      type: "Suffix",
      description:
        "While holding this magic shield, you can speak its command word as a bonus action to cause it to animate. The shield leaps into the air and hovers vertically in your space to protect you as if you were wielding it, leaving your hands free. The shield remains animated for 1 minute, until you use a bonus action to end this effect, or until you are incapacitated or die, at which point the shield falls to the ground or into your hand if you have one free. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Animation, Greater",
      type: "Suffix",
      description:
        "This magic shield has 3 charges. While holding it, you can speak its command word as a bonus action and expend 1 of its charges to cause it to animate. The shield leaps into the air and hovers vertically in your space to protect you as if you were wielding it, leaving your hands free. The shield remains animated for 1 minute, until you use a bonus action to end this effect, or until you are incapacitated or die, at which point the shield falls to the ground or into your hand if you have one free. The shield regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Answering",
      type: "Prefix",
      description:
        "While carrying this weapon, you can use your reaction to make one melee attack with disadvantage with it against any creature within your reach that deals damage to you.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Answering, Greater",
      type: "Prefix",
      description:
        "While carrying this weapon, you can use your reaction to make one melee attack with it against any creature within your reach that deals damage to you. ",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Antimagic",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to surround yourself with a 10-foot-radius invisible sphere of antimagic, as if you had cast the spell <i>antimagic field</i>. This effect lasts until the end of your next turn. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Antimagic, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 of its charges as an action to surround yourself with a 10-foot-radius invisible sphere of antimagic, as if you had cast the spell <i>antimagic field</i>. This effect lasts until the end of your next turn. While this antimagic field is active, you can use a bonus action and expend 1 of the item's charges to extend its duration until the end of your next turn. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Arachnid's",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on saving throws against being poisoned.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Arachnid's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to poison damage and advantage on saving throws against being poisoned.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Arcane",
      type: "Prefix",
      description:
        "The spells <i>mage armor</i>, <i>shield</i>, and <i>shield of faith</i> provide no defense against this weapon, which passes through those spells' barriers of magical force.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Arcane, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d6 force damage. The spells <i>mage armor</i>, <i>shield</i>, and <i>shield of faith</i> provide no defense against this weapon, which passes through those spells' barriers of magical force.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Archfey Warlock's",
      type: "Class",
      description:
        "While carrying this item, you can use your Fey Presence as a bonus action instead of an action. ",
      rarity: 1,
      attunement: "Requires attunement by an Archfey warlock",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Archfey Warlock's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can use your Fey Presence as a bonus action instead of an action. In addition, the range of your Fey Presence increases to 30 feet, and you can choose which creatures are affected.",
      rarity: 2,
      attunement: "Requires attunement by an Archfey warlock",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Arrow-Catching",
      type: "Prefix",
      description:
        "Whenever an attacker makes a ranged attack against a target within 5 feet of you while you are carrying this item, you can use your reaction to become the target of the attack instead.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Arrow-Catching, Greater",
      type: "Prefix",
      description:
        "You gain a +2 bonus to AC against ranged attacks while carrying this item. In addition, whenever an attacker makes a ranged attack against a target within 5 feet of you, you can use your reaction to become the target of the attack instead.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Ascetic's",
      type: "Prefix",
      description:
        "While carrying this item, you gain a +1 bonus to AC if you are wearing no armor and using no shield.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Ascetic's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you gain a +2 bonus to AC if you are wearing no armor and using no shield.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Assassin's",
      type: "Class",
      description:
        "When you score a critical hit against a surprised creature while carrying this item, the creature must make a Constitution saving throw (DC 8 + your Dexterity modifier + your proficiency bonus). On a failed save, the creature is incapacitated until the end of its next turn. If you have the Death Strike feature, the creature makes only a single Constitution saving throw, suffering both effects on a failure.",
      rarity: 1,
      attunement: "Requires attunement by an Assassin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Assassin's, Greater",
      type: "Class",
      description:
        "When you score a critical hit against a surprised creature while carrying this item, the creature must make a Constitution saving throw (DC 8 + your Dexterity modifier + your proficiency bonus). On a failed save, the creature is stunned until the end of its next turn. If you have the Death Strike feature, the creature makes only a single Constitution saving throw, suffering both effects on a failure.",
      rarity: 2,
      attunement: "Requires attunement by an Assassin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Athlete's",
      type: "Prefix",
      description:
        "When you attack with this weapon on your turn, you can use a bonus action to try to grapple or shove a creature within 5 feet of you.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Athlete's, Greater",
      type: "Prefix",
      description:
        "While carrying this weapon, you have advantage on Athletics checks. In addition, when you attack with this weapon on your turn, you can use a bonus action to try to grapple or shove a creature within 5 feet of you.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Avenger's",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the target takes an extra 1d6 damage of the weapon's type if it has dealt damage to you since the beginning of its last turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Avenger's, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the target takes an extra 2d6 damage of the weapon's type if it has dealt damage to you since the beginning of its last turn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Awakening Mind",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying it, you can expend the weapon's charges to cause the following effects:\n&#8226; When you roll an Intelligence, Wisdom, or Charisma saving throw, you can expend 1 charge to give yourself advantage on the roll.\n&#8226; You can expend 3 charges as an action to cast <i>confusion</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Awakening Mind, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying it, you can expend the weapon's charges to cause the following effects:\n&#8226; When you roll an Intelligence, Wisdom, or Charisma saving throw, you can expend 1 charge to give yourself advantage on the roll.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>confusion</i> (3 charges) or <i>synaptic static</i> (5 charges).\n   If the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Balor's",
      type: "Prefix",
      description:
        "When you are reduced to 0 hit points while carrying this item, all other creatures within 10 feet of you must make a DC 13 Dexterity saving throw, taking 4d6 fire damage on a failed save, or half as much damage on a successful one.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Balor's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action to begin radiating intense heat. A creature that touches you or hits you with a melee attack while within 5 feet of you takes 1d6 fire damage. This effect lasts until you end it as a bonus action. In addition, when you are reduced to 0 hit points while carrying this item, all other creatures within 10 feet of you must make a DC 15 Dexterity saving throw, taking 8d6 fire damage on a failed save, or half as much damage on a successful one.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Barbarian's",
      type: "Class",
      description:
        "While carrying this item, you gain a +2 bonus to your Rage Damage. ",
      rarity: 1,
      attunement: "Requires attunement by a barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Barbarian's, Greater",
      type: "Class",
      description:
        "While carrying this item, you gain a +4 bonus to your Rage Damage. ",
      rarity: 2,
      attunement: "Requires attunement by a barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Bard's",
      type: "Class",
      description:
        "When you or another creature rolls one of your Bardic Inspiration dice while you carry this item, any 1 on the roll is treated as a 2. ",
      rarity: 1,
      attunement: "Requires attunement by a bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Bard's, Greater",
      type: "Class",
      description:
        "When you or another creature rolls one of your Bardic Inspiration dice while you carry this item, any roll of 3 or lower is treated as a 4.",
      rarity: 2,
      attunement: "Requires attunement by a bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Bashing",
      type: "Prefix",
      description:
        "When you successfully shove a creature while carrying this shield, you can have the creature take bludgeoning damage equal to 1d4 + your Strength modifier.",
      rarity: 1,
      attunement: "No",
      armor: "Shield",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Bashing, Greater",
      type: "Prefix",
      description:
        "You have advantage on any Strength (Athletics) check you make to shove a creature while carrying this shield. On a success, you can have the creature take bludgeoning damage equal to 1d4 + your Strength modifier.",
      rarity: 2,
      attunement: "No",
      armor: "Shield",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Bat's",
      type: "Prefix",
      description:
        "While carrying this item, you can use an action to gain blindsight out to a range of 30 feet until the end of your next turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Bat's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have blindsight out to a range of 30 feet.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Battle Master's",
      type: "Class",
      description:
        "When you roll a Superiority Die while carrying this item, you can treat any 1 on the roll as a 2.",
      rarity: 1,
      attunement: "Requires attunement by a Battle Master",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Battle Master's, Greater",
      type: "Class",
      description:
        "When you roll a Superiority Die while carrying this item, you can treat any roll of 3 or lower as a 4.",
      rarity: 2,
      attunement: "Requires attunement by a Battle Master",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Beacon",
      type: "Common",
      description:
        "While carrying this item, you can use a bonus action to cause it to shed bright light in a 10-foot radius and dim light for an additional 10 feet, or to extinguish the light.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Berserk",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. Whenever a hostile creature damages you while you are cursed, you must succeed on a DC 15 Wisdom saving throw or go berserk. While berserk, you must use your action each round to attack the creature nearest to you. If you can make extra attacks as part of the Attack action, you use those extra attacks, moving to attack the next nearest creature after you fell your current target. If you have multiple possible targets, you attack one at random. You are berserk until you start your turn with no creatures within 60 feet of you that you can see or hear.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Berserker Barbarian's",
      type: "Class",
      description:
        "While carrying this item, you can spend ten minutes in quiet meditation to remove one level of exhaustion caused by using your Frenzy. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement by a Berserker barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Berserker Barbarian's, Greater",
      type: "Class",
      description:
        "This item has 3 charges. While carrying it, you can spend ten minutes in quiet meditation and expend 1 of its charges to remove one level of exhaustion caused by using your Frenzy. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement by a Berserker barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Berserker's",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon while your current hit points are equal to or less than half your hit point maximum, the target takes an extra 1d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Berserker's, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon while your current hit points are equal to or less than half your hit point maximum, the target takes an extra 2d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Blade Ward",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>blade ward</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Blinding",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 13 Constitution saving throw. On a failure, it takes 2d8 radiant damage and is blinded until the end of its next turn. On a success, it takes only half as much damage and isn't blinded. ",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Blinding, Greater",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 15 Constitution saving throw. On a failure, it takes 4d8 radiant damage and is blinded for 1 minute. The target can repeat the saving throw at the end of each of its turns, ending the effect on a success. On a success, it takes only half as much damage and isn't blinded.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Bloodied",
      type: "Prefix",
      description:
        "When you are reduced to 0 hit points while carrying this item, you become immune to all damage until the start of your next turn.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Bloodied, Greater",
      type: "Prefix",
      description:
        "When your current hit points are equal to or less than half your hit point maximum while carrying this item, you have resistance to bludgeoning, piercing, and slashing damage from nonmagical weapons. In addition, when you are reduced to 0 hit points while carrying this item, you become immune to all damage until the start of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Blueleaf",
      type: "Prefix",
      description:
        "When you are subjected to a spell or magical effect that allows you to make a Wisdom, Intelligence, or Charisma saving throw to take only half damage while carrying this item, you instead take no damage if you succeed on the saving throw.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Blueleaf, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Wisdom, Intelligence, and Charisma saving throws against spells and other magical effects. In addition, when you are subjected to a spell or magical effect that allows you to make a Wisdom, Intelligence, or Charisma saving throw to take only half damage, you instead take no damage if you succeed on the saving throw.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Booming",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature becomes sheathed in booming energy until the start of your next turn. If the target willingly moves before then, it immediately takes 1d6 thunder damage and the effect ends.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Booming, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, that creature takes an extra 1d6 thunder damage and becomes sheathed in booming energy until the start of your next turn. If the target willingly moves before then, it immediately takes 1d6 thunder damage and the effect ends.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Brilliance",
      type: "Suffix",
      description:
        "When you are attacked by a creature within 30 feet of you that you can see while carrying this item, you can use your reaction to cause light to flare before the attacker makes its attack roll. The attacker must succeed on a DC 13 Constitution saving throw or be blinded for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Brilliance, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. When you are attacked by a creature within 30 feet of you that you can see while carrying this item, you can expend 1 of its charges as a reaction to cause light to flare before the attacker makes its attack roll. The attacker must succeed on a DC 15 Constitution saving throw or be blinded for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. The item regains all expended charges daily at dawn. ",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Cast-off",
      type: "Common",
      description: "You can doff this armor as an action.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Celebration",
      type: "Suffix",
      description:
        "This item has 3 charges. While you carry it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 13): <i>hideous laughter</i> (1 charge) or <i>enthrall</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Celebration, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While you carry it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 15): <i>hideous laughter</i> (1 charge), <i>enthrall</i> (2 charges) or <i>Otto's irresistible dance</i> (5 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Celestial's",
      type: "Prefix",
      description:
        "While carrying this item, you can't be blinded by spells or magical effects.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Celestial's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to radiant damage and you can't be blinded by spells or magical effects.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Champion",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>heroism</i> (+3 spellcasting ability). For 1 charge, you cast the 1st-level version of the spell. You can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Champion, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells: <i>heroism</i> (1 charge per spell level, spellcasting ability +5) or <i>crusader's mantle</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Charm",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells (spell save DC 13): <i>charm person</i> (1 charge) or <i>suggestion</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Charm, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells (spell save DC 15): <i>charm person</i> (1 charge), <i>suggestion</i> (2 charges), or <i>compulsion</i> (4 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Cleansing",
      type: "Suffix",
      description:
        "While carrying this item, you can use a bonus action to end any spells of 3rd level or lower on yourself. For each spell of 4th level or higher on you, make an ability check using your Constitution modifier. The DC equals 10 + the spell's level. On a successful check, the spell ends. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Cleansing, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While wearing it, you can expend 1 charge as a bonus action to end any spells of 3rd level or lower on yourself. For each spell of 4th level or higher on you, make an ability check using your Constitution modifier. The DC equals 10 + the spell's level. On a successful check, the spell ends. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Cleric's",
      type: "Class",
      description:
        "While carrying this item, your cleric level is considered 3 levels higher than it actually is for the purposes of turning or destroying undead creatures using your Turn Undead.",
      rarity: 1,
      attunement: "Requires attunement by a cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Cleric's, Greater",
      type: "Class",
      description:
        "While carrying this item, your cleric level is considered 6 levels higher than it actually is for the purposes of turning or destroying undead creatures using your Turn Undead.",
      rarity: 2,
      attunement: "Requires attunement by a cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Command",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells (spell save DC 13): <i>command</i> (1 charge) or <i>hold person</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Command, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells (spell save DC 15): <i>charm person</i> (1 charge), <i>hold person</i> (2 charges), or <i>dominate person</i> (5 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Commander's",
      type: "Prefix",
      description:
        "When another creature within 30 feet that can hear and see you makes an attack roll while you are carrying this item, you can use your reaction to give that creature advantage on its roll. ",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Commander's, Greater",
      type: "Prefix",
      description:
        "When another creature within 30 feet that can hear and see you makes an attack roll or saving throw while you are carrying this item, you can use your reaction to give that creature advantage on its roll.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Compass",
      type: "Common",
      description:
        "While carrying this item, you can use an action to learn which way is north.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Conjuration Wizard's",
      type: "Class",
      description:
        "When you use your Minor Conjuration while carrying this item, you can bestow one of the following properties on the item you create: The object grants a +1 bonus to AC when carried or the object grants a +1 bonus to all saving throws when carried.",
      rarity: 1,
      attunement: "Requires attunement by a Conjuration wizard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Conjuration Wizard's, Greater",
      type: "Class",
      description:
        "When you use your Minor Conjuration while carrying this item, you can bestow one of the following properties on the item you create: The object grants a +2 bonus to AC when carried or the object grants a +2 bonus to all saving throws when carried.",
      rarity: 2,
      attunement: "Requires attunement by a Conjuration wizard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Conscientious",
      type: "Common",
      description:
        "While carrying this item and contemplating or undertaking a malevolent act, the item enhances pangs of conscience.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Construct's",
      type: "Prefix",
      description:
        "While carrying this item, you are immune to three spells of 5th level or lower chosen by its creator or rolled at random on the Spell Immunity table.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Construct's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to force damage. In addition, you are immune to three spells of 5th level or lower chosen by its creator or rolled at random on the Spell Immunity table.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Contingency",
      type: "Suffix",
      description:
        "This item can store a single spell cast into it. During a process that takes 10 minutes, any creature can cast a spell of up to 2nd level, that has a casting time of 1 action, and that can target you, into the item by touching it as the spell is cast. The spell has no immediate effect, other than to be stored in the item, where it takes effect when a certain circumstance occurs. When a creature casts a spell into the item, it must describe that circumstance. The spell takes effect immediately after the circumstance is met for the first time, whether or not you want it to. The spell uses the spell slot level, spell save DC, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell takes effect only on you, even if it can normally target others. Once the spell takes effect it is gone from the item, and a new spell can't be stored in the item until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Contingency, Greater",
      type: "Suffix",
      description:
        "This item can store a single spell cast into it. During a process that takes 10 minutes, any creature can cast a spell of up to 5th level, that has a casting time of 1 action, and that can target you, into the item by touching it as the spell is cast. The spell has no immediate effect, other than to be stored in the item, where it takes effect when a certain circumstance occurs. When a creature casts a spell into the item, it must describe that circumstance. The spell takes effect immediately after the circumstance is met for the first time, whether or not you want it to. The spell uses the spell slot level, spell save DC, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell takes effect only on you, even if it can normally target others. Once the spell takes effect it is gone from the item, and a new spell can't be stored in the item until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Convenient",
      type: "Prefix",
      description:
        "This armor has five pockets, each of which is an extradimensional space. Each pocket can hold up to 20 pounds of material, not exceeding a volume of 2 cubic feet. The armor's weight isn't affected by its pockets' contents. An object can be placed into a pocket or retrieved from a pocket as a bonus action. When you reach into a pocket for a specific item, the item is always magically on top.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Convenient, Greater",
      type: "Prefix",
      description:
        "This armor has five pockets, each of which is an extradimensional space. Each pocket can hold up to 20 pounds of material, not exceeding a volume of 2 cubic feet. When you are hit by a weapon or spell attack made with a missile or weapon no larger than 2 cubic feet while wearing this armor, you can roll a Dexterity saving throw as a reaction. If the result exceeds the attack roll against you, the attack hits an extradimensional pocket, missing you. If the attack was a missile smaller than 2 cubic feet, the missile is contained within the armor's pocket. Otherwise, any physical object (such as a weapon held by a creature) is immediately expelled from the pocket. The armor's weight isn't affected by its pockets' contents. An object can be placed into a pocket or retrieved from a pocket as a bonus action. When you reach into a pocket for a specific item, the item is always magically on top. When you are hit by a weapon or spell attack made with a missile or weapon no larger than 2 cubic feet while wearing this armor, you can roll a Dexterity saving throw as a reaction. If the result exceeds the attack roll against you, the attack hits an extradimensional pocket, missing you. If the attack was a missile smaller than 2 cubic feet, the missile is contained within the armor's pocket. Otherwise, any physical object (such as a weapon held by a creature) is immediately expelled from the pocket.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Corrosive",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes 1d6 acid damage at the end of its next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Corrosive, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d6 acid damage immediately and 1d6 acid damage at the end of its next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Creeping Cold",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend its charges to cause the following effects: \n&#8226; When an attacker that you can see hits you with an attack, you can expend 1 its charges to reduce the attack's damage by 1d8 for each charge expended. \n&#8226; You can expend 3 charges as an action to cast <i>ice storm</i> (save DC 13). \nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Creeping Cold, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend its charges to cause the following effects: \n&#8226; When an attacker that you can see hits you with an attack, you can expend 1 or more charges to reduce the attack's damage by 1d8 for each charge expended.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>ice storm</i> (3 charges) or <i>freezing sphere</i> (5 charges). \nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Curses",
      type: "Suffix",
      description:
        "When you hit a creature with an attack using this weapon, you can temporarily bestow a curse upon the target. Choose one ability score. The target has disadvantage on attack rolls, ability checks, and saving throws using that ability score until the end of your next turn. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Curses, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you hit a creature with an attack using this weapon, you can expend 1 charge to temporarily bestow a curse upon the target. Choose one ability score. The target has disadvantage on attack rolls, ability checks, and saving throws using that ability score until the end of your next turn. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Damnation",
      type: "Suffix",
      description:
        "When a creature hits you with a weapon attack while you are carrying this item, you can temporarily bestow a curse upon that creature. Choose one ability score. The target has disadvantage on attack rolls, ability checks, and saving throws using that ability score until the end of your next turn. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Damnation, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. When a creature hits you with a weapon attack while you are carrying it, you can expend 1 of its charges to temporarily bestow a curse upon that creature. Choose one ability score. The target has disadvantage on attack rolls, ability checks, and saving throws using that ability score until the end of your next turn. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Dancing",
      type: "Suffix",
      description:
        "You can use a bonus action to toss this weapon into the air and speak the command word. When you do so, the weapon begins to hover, flies up to 30 feet, and attacks one creature of your choice within 5 feet of it. The weapon uses your attack roll and ability score modifier to damage rolls, and is considered to be wielded by you in regards to other magical properties on the weapon, such as causing additional effects on successful hits. While the weapon hovers, you can use a bonus action to cause it to fly up to 30 feet to another spot within 30 feet of you. As part of the same bonus action, you can cause the weapon to attack one creature within 5 feet of it. After the hovering sword attacks for the third time, it flies up to 30 feet and tries to return to your hand. If you have no hand free, it falls to the ground at your feet. If the sword has no unobstructed path to you, it moves as close to you as it can and then falls to the ground. It also ceases to hover if you grasp it or move more than 30 feet away from it. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Dancing, Greater",
      type: "Suffix",
      description:
        "You can use a bonus action to toss this weapon into the air and speak the command word. When you do so, the weapon begins to hover, flies up to 30 feet, and attacks one creature of your choice within 5 feet of it. The weapon uses your attack roll and ability score modifier to damage rolls, and is considered to be wielded by you in regards to other magical properties on the weapon, such as causing additional effects on successful hits. While the weapon hovers, you can use a bonus action to cause it to fly up to 30 feet to another spot within 30 feet of you. As part of the same bonus action, you can cause the weapon to attack one creature within 5 feet of it. After 1 minute, the weapon flies up to 30 feet and tries to return to your hand. If you have no hand free, it falls to the ground at your feet. If the sword has no unobstructed path to you, it moves as close to you as it can and then falls to the ground. It also ceases to hover if you grasp it or move more than 30 feet away from it. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Darksteel",
      type: "Prefix",
      description:
        "When you are subjected to a spell or magical effect that allows you to make a Strength, Constitution, or Dexterity saving throw to take only half damage while carrying this item, you instead take no damage if you succeed on the saving throw.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Darksteel, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Strength, Constitution, and Dexterity saving throws against spells and other magical effects. In addition, when you are subjected to a spell or magical effect that allows you to make a Strength, Constitution, or Dexterity saving throw to take only half damage, you instead take no damage if you succeed on the saving throw.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Dawn",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>guiding bolt</i> (1 charge per level, +5 to hit) or <i>daylight</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Dawn, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>guiding bolt</i> (1 charge per level, +7 to hit), <i>daylight</i> (3 charges), or <i>dawn</i> (5 charges, save DC 15). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Deceptive",
      type: "Common",
      description:
        "This item looks rusty, chipped, worn, or damaged to the point of uselessness, even though it is in fact a remarkably well-crafted item.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Deflecting",
      type: "Prefix",
      description:
        "When a ranged weapon attack hits you while you are holding this weapon, you can use your reaction to reduce the damage by a roll of this weapon's damage dice + your Strength or Dexterity modifier (your choice).",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Deflecting, Greater",
      type: "Prefix",
      description:
        "When a ranged weapon attack hits you or another creature within 5 feet of you while you are holding this weapon, you can use your reaction to reduce the damage by a roll of this weapon's damage dice + your Strength or Dexterity modifier (your choice).",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Delver",
      type: "Common",
      description:
        "While carrying this item underground, you always know the item's depth below the surface and the direction to the nearest staircase, ramp, or other path leading upward.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Demon",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into a quasit. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Demon, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing it, you can expend 1 or more of its charges as an action to transform into a quasit (1 charge) or a barlgura (3 charges). The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Detection",
      type: "Common",
      description:
        "This item will glow with a dull light when within 1 foot of another magical item or magical effect.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Devil",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into an imp. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Devil, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing it, you can expend 1 or more of its charges as an action to transform into an imp (1 charge) or a barbed devil (3 charges). The transformation otherwise functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Devil's",
      type: "Prefix",
      description:
        "While carrying this item, you can see normally in darkness to a distance of 60 feet.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Devil's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can see normally in darkness, both magical and nonmagical, to a distance of 60 feet.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Devotion Paladin's",
      type: "Class",
      description:
        "When you use your Channel Divinity: Sacred Weapon, while carrying this item, your attacks with that weapon also deal additional radiant damage equal to your Charisma modifier (minimum of +1).",
      rarity: 1,
      attunement: "Requires attunement by a Devotion paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Devotion Paladin's, Greater",
      type: "Class",
      description:
        "When you use your Channel Divinity: Sacred Weapon, while carrying this item, your attacks with that weapon also deal additional radiant damage equal to your Charisma modifier (minimum of +1). In addition, a creature that takes this radiant damage must make a Constitution saving throw against your spell save DC or be blinded until the end of its next turn.",
      rarity: 2,
      attunement: "Requires attunement by a Devotion paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Diplomat",
      type: "Common",
      description:
        "While carrying this item, you can speak and understand a language of the DM's choice.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Discord",
      type: "Suffix",
      description:
        "When you hit a creature with this weapon, you can force the creature to make a DC 13 Intelligence saving throw. On a failed save, the target loses the ability to distinguish friend from foe, regarding all creatures it can see as enemies for 1 minute. Each time the target takes damage, it can repeat the saving throw, ending the effect on itself on a success. Whenever the affected creature chooses another creature as a target, it must choose the target at random from among the creatures it can see within range of the attack, spell, or ability it's using. If an enemy provokes an opportunity attack from the affected creature, the creature must make that attack if it is able to. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Discord, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you hit a creature with this weapon, you can expend 1 of its charges to force the creature to make a DC 15 Intelligence saving throw. On a failed save, the target loses the ability to distinguish friend from foe, regarding all creatures it can see as enemies for 1 minute. Each time the target takes damage, it can repeat the saving throw, ending the effect on itself on a success. Whenever the affected creature chooses another creature as a target, it must choose the target at random from among the creatures it can see within range of the attack, spell, or ability it's using. If an enemy provokes an opportunity attack from the affected creature, the creature must make that attack if it is able to. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Displacer's",
      type: "Prefix",
      description:
        "While carrying this item, it projects an illusion that makes you appear to be standing in a place near your actual location, causing any creature to have disadvantage on attack rolls against you. If you take damage, the property ceases to function until you use an action to reactivate it. This property is suppressed while you are incapacitated, restrained, or otherwise unable to move.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Displacer's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, it projects an illusion that makes you appear to be standing in a place near your actual location, causing any creature to have disadvantage on attack rolls against you. If you take damage, the property ceases to function until the start of your next turn. This property is suppressed while you are incapacitated, restrained, or otherwise unable to move.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Disruptive",
      type: "Prefix",
      description:
        "When you hit a creature that is concentrating on a spell or magical effect with this weapon, the creature takes an extra 2d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Disruptive, Greater",
      type: "Prefix",
      description:
        "When you hit a creature that is concentrating on a spell or magical effect with this weapon, the creature takes an extra 4d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Divination",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells: <i>identify</i> (1 charge) or <i>augury</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Divination, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells: <i>identify</i> (1 charge), <i>augury</i> (2 charges), or <i>divination</i> (4 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Djinni's",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to thunder damage.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Djinni's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to lightning and thunder damage.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Doppelganger",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 13): <i>disguise self</i> (1 charge) or <i>alter self</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Doppelganger, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 15): <i>disguise self</i> (1 charge), <i>alter self</i> (2 charges), or <i>polymorph</i> (4 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Draconic Sorcerer's",
      type: "Class",
      description:
        "While carrying this item and casting a spell that deals damage of the type associated with your Draconic ancestry, you can add your Charisma modifier (minimum of 1) to one damage roll of that spell.",
      rarity: 1,
      attunement: "Requires attunement by a Draconic sorcerer",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Draconic Sorcerer's, Greater",
      type: "Class",
      description:
        "While carrying this item, you gain the following benefits: When you cast a spell that deals damage of the type associated with your Draconic ancestry, you can add your Charisma modifier (minimum of 1) to one damage roll of that spell, and when you cast a spell that deals acid, cold, fire, lightning, or poison damage, you can change the type of damage dealt by that spell to the damage type associated with your draconic ancestry.",
      rarity: 2,
      attunement: "Requires attunement by a Draconic sorcerer",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Dragon",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>chromatic orb</i> (1 charge) or as a bonus action to cast <i>dragon's breath</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Dragon, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>chromatic orb</i> (1 charge) or <i>fly</i> (3 charges), or as a bonus action to cast <i>dragon's breath</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Dragonscale",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on saving throws against the Frightful Presence and breath weapons of dragons.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Dragonscale, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on saving throws against the Frightful Presence and breath weapons of dragons, and you have resistance to one damage type determined by the kind of dragon that provided the scales, as shown on the table below.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Dretch",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to conjure a cloud of disgusting green gas in a 10-foot radius around you. The gas moves with you, spreads around corners, and its area is lightly obscured. It lasts for 1 minute, until a strong wind disperses it, or you use a bonus action to dispel it. Any other creature that starts its turn in that area must succeed on a DC 13 Constitution saving throw or be poisoned until the start of its next turn. While poisoned in this way, the target can take either an action or a bonus action on its turn, not both, and can't take reactions. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Dretch, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as an action to conjure a cloud of disgusting green gas in a 10-foot radius around you. The gas moves with you, spreads around corners, and its area is lightly obscured. It lasts for 1 minute, until a strong wind disperses it, or you use a bonus action to dispel it. Any other creature that starts its turn in that area must succeed on a DC 15 Constitution saving throw or be poisoned until the start of its next turn. While poisoned in this way, the target can take either an action or a bonus action on its turn, not both, and can't take reactions. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Druid's",
      type: "Class",
      description:
        "While carrying this item, your druid level is considered to be 2 levels higher than it actually is when determining which beast shapes you can transform into using your Wild Shape. If you can already transform into CR 1 creatures (or CR 6 creatures for a Circle of the Moon Druid), the maximum CR of your Wild Shape instead increases by 1.",
      rarity: 1,
      attunement: "Requires attunement by a druid",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Druid's, Greater",
      type: "Class",
      description:
        "While carrying this item, your druid level is considered to be 4 levels higher than it actually is when determining which beast shapes you can transform into using your Wild Shape. If you can already transform into CR 1 creatures (or CR 6 creatures for a Circle of the Moon Druid), the maximum CR of your Wild Shape instead increases by 2.",
      rarity: 2,
      attunement: "Requires attunement by a druid",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Duelist's",
      type: "Prefix",
      description:
        "When you are holding this weapon and another creature hits you with a melee attack, you can use your reaction to add your proficiency bonus to your AC, potentially causing the attack to miss you.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Duelist's, Greater",
      type: "Prefix",
      description:
        "When you are holding this weapon and another creature hits you with a melee attack, you can use your reaction to add your proficiency bonus to your AC, potentially causing the attack to miss you. If the attack misses, you can then immediately make an opportunity attack with this weapon against that creature as part of the same reaction.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Duskwood",
      type: "Prefix",
      description:
        "While carrying this item in an area of dim light or darkness, you can use an action to teleport up to 30 feet to an unoccupied space you can see that is also in dim light or darkness.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Duskwood, Greater",
      type: "Prefix",
      description:
        "While carrying this item in an area of dim light or darkness, you can use a bonus action to teleport up to 30 feet to an unoccupied space you can see that is also in dim light or darkness.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Efreeti's",
      type: "Prefix",
      description:
        "While carrying this item, you can cast the spell <i>produce flame</i> (+5 to hit).",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Efreeti's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to fire damage and can cast the spell <i>produce flame</i> (+7 to hit).",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Eldritch Knight's",
      type: "Class",
      description:
        "While carrying this item, you add half your Intelligence modifier (rounded up, minimum of 1) to the damage dealt by attacks made with a weapon you are bonded with using your Weapon Bond.",
      rarity: 1,
      attunement: "Requires attunement by an Eldritch Knight",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Eldritch Knight's, Greater",
      type: "Class",
      description:
        "While carrying this item, you add your Intelligence modifier (minimum of 1) to the damage dealt by attacks made with a weapon you are bonded with using your Weapon Bond.",
      rarity: 2,
      attunement: "Requires attunement by an Eldritch Knight",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Elemental",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into a dust mephit, ice mephit, magma mephit, mud mephit, smoke mephit, or steam mephit. The transformation functions as the <i>polymorph</i> spell, and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Elemental, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing this armor, you can expend 1 of its charges as an action to transform into a dust mephit, ice mephit, magma mephit, mud mephit, smoke mephit, or steam mephit, or you can expend 3 of its charges as an action to turn into an air elemental, earth elemental, fire elemental, or water elemental. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Elements",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can expend 1 of its charges as a reaction to cast <i>absorb elements</i> (1 charge). The weapon regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Elements, Greater",
      type: "Suffix",
      description:
        "This weapon has 5 charges. While carrying it, you can expend 1 or more of its charges as a reaction to cast <i>absorb elements</i> (1 charge) or as an action to cast <i>elemental weapon</i> (3 charges). The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Emissary's",
      type: "Prefix",
      description:
        "While carrying this item, you can understand any spoken language you hear and when you speak, any creature that knows at least one language and can hear you understands what you say.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Emissary's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can understand any spoken language you hear and when you speak, any creature that knows at least one language and can hear you understands what you say. In addition, you can cast the spell <i>zone of truth</i> (save DC 15) from it as an action.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Empathy",
      type: "Suffix",
      description:
        "While carrying this item, you can use a bonus action to tie your form to another creature within 30 feet you can see. Until the end of your next turn, whenever you take damage, the target must make a DC 13 Constitution saving throw. On a failed save, you take half the damage (rounded down), and the target takes the remaining damage. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Empathy, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a bonus action to tie your form to another creature within 30 feet you can see. Until the end of your next turn, whenever you take damage, the target must make a DC 15 Constitution saving throw. On a failed save, you take half the damage (rounded down), and the target takes the remaining damage. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Empowering",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action to empower your spells to overcome other creatures' resistance to magic. If you do, creatures that have advantage on saving throws against spells and magical effects (e.g., granted by the feature Magic Resistance, the racial trait Gnome Cunning, or the item mantle of spell resistance) don't have advantage on their saving throws against the next spell you cast this turn. A creature still rolls its saving throw with advantage if it has advantage against a specific effect or condition produced by the spell you cast, such as advantage against being charmed, frightened, or poisoned.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Empowering, Greater",
      type: "Prefix",
      description:
        "While carrying this item, creatures that have advantage on saving throws against spells and magical effects (e.g., granted by the feature Magic Resistance, the racial trait Gnome Cunning, or the item mantle of spell resistance) don't have advantage on their saving throws against spells you cast. A creature still rolls its saving throw with advantage if it has advantage against a specific effect or condition produced by the spell you cast, such as advantage against being charmed, frightened, or poisoned.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Enchanter's",
      type: "Prefix",
      description:
        "This weapon can store a single spell cast into it. Any creature can cast a spell of up to 2nd level into the weapon by touching it as the spell is cast. The spell must have a harmful effect, a casting time of 1 action, and target only one creature. The spell has no effect, other than to be stored in the weapon. If the weapon can't hold the spell, the spell is expended without effect. When you make an attack using this weapon, you can have the spell stored inside the weapon affect the target of your attack on a successful hit. The spell uses the spell slot level, spell save DC, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. If the spell requires the caster to make a melee or ranged spell attack, it automatically hits. When you use this property, the spell cast from the weapon is no longer stored in it, freeing up space for a new spell.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Enchanter's, Greater",
      type: "Prefix",
      description:
        "This weapon can store a single spell cast into it. Any creature can cast a spell of up to 5th level into the weapon by touching it as the spell is cast. The spell must have a harmful effect, a casting time of 1 action, and target only one creature. The spell has no effect, other than to be stored in the weapon. If the weapon can't hold the spell, the spell is expended without effect. When you make an attack using this weapon, you can have the spell stored inside the weapon affect the target of your attack on a successful hit. The spell uses the spell slot level, spell save DC, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. If the spell requires the caster to make a melee or ranged spell attack, it automatically hits. When you use this property, the spell cast from the weapon is no longer stored in it, freeing up space for a new spell.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Enhancement",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells: <i>jump</i> (1 charge), <i>longstrider</i> (1 charge), or <i>enhance ability</i> (2 charges), targeting yourself. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Enhancement, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells: <i>jump</i> (1 charge), <i>longstrider</i> (1 charge), <i>enhance ability</i> (2 charges), or <i>skill empowerment</i> (5 charges), targeting yourself. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Executioner's",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 1d6 damage of the weapon's type if its current hit points are less than half its hit point maximum.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Executioner's, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 2d6 damage of the weapon's type if its current hit points are less than half its hit point maximum.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Expression",
      type: "Common",
      description:
        "The front of this shield is shaped in the likeness of a face. While carrying the shield, you can use a bonus action to alter the face's expression.",
      rarity: 0,
      attunement: "No",
      armor: "Shield",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Far Step",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a bonus action to cast <i>misty step</i>. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Far Step, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>misty step</i> (1 charge) or <i>far step</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Feather",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a reaction to cast <i>feather fall</i> or expend 2 charges as an action to cast <i>levitate</i>. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Feather, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a reaction to cast <i>feather fall</i> (1 charge) or as an action to cast <i>levitate</i> (2 charges) or <i>fly</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Fey",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>faerie fire</i> (1 charge, save DC 13) or <i>blink</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Fey, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 15): <i>faerie fire</i> (1 charge), <i>blink</i> (2 charges), or <i>seeming</i> (5 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Fiend Warlock's",
      type: "Class",
      description:
        "While carrying this item, you gain temporary hit points from your Dark One's Blessing as long as you are within 30 feet of a hostile creature when it is reduced to 0 hit points.",
      rarity: 1,
      attunement: "Requires attunement by a Fiend warlock",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Fiend Warlock's, Greater",
      type: "Class",
      description:
        "While carrying this item, you gain temporary hit points from your Dark One's Blessing as long as you are within 30 feet of a hostile creature when it is reduced to 0 hit points, and you also gain advantage on the next attack roll, ability check, or saving throw you make until the end of your next turn.",
      rarity: 2,
      attunement: "Requires attunement by a Fiend warlock",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Fighter's",
      type: "Class",
      description:
        "When you use your bonus action to regain hit points with Second Wind while carrying this item, you can make one weapon attack as part of the same bonus action.",
      rarity: 1,
      attunement: "Requires attunement by a fighter",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Fighter's, Greater",
      type: "Class",
      description:
        "While carrying this item, you gain the following benefits: When you use your bonus action to regain hit points with Second Wind, you can make one weapon attack as part of the same bonus action and when you use your Action Surge, you can also take one additional bonus action on your turn.",
      rarity: 2,
      attunement: "Requires attunement by a fighter",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Flaming",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d4 fire damage. ",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Flaming, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d8 fire damage.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Foe Guard",
      type: "Prefix",
      description:
        "This item is created to protect against a particular type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. While carrying this item, you have advantage on saving throws against the spells and special abilities of creatures of that type.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Foe Guard, Greater",
      type: "Prefix",
      description:
        "This item is created to protect against a particular type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. While carrying this item, creatures of that type have disadvantage on attack rolls against you, and you have advantage on saving throws against their spells and special abilities.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Foe Slayer",
      type: "Prefix",
      description:
        "This weapon is created to harm a particular type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. When you hit a creature of the chosen type with this weapon, the creature takes an extra 1d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Foe Slayer, Greater",
      type: "Prefix",
      description:
        "This weapon is created to harm a particular type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. When you hit a creature of the chosen type with this weapon, the creature takes an extra 2d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Four Element Monk's",
      type: "Class",
      description:
        "While carrying this item, spells cast using your Disciple of the Elements each cost 1 fewer ki point to cast. ",
      rarity: 1,
      attunement: "Requires attunement by a Four Elements monk",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Four Element Monk's, Greater",
      type: "Class",
      description:
        "While carrying this item, spells cast using your Disciple of the Elements each cost 2 fewer ki points to cast.",
      rarity: 2,
      attunement: "Requires attunement by a Four Elements monk",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Freezing",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target's speed is reduced by 10 feet (to a minimum of 10 feet) until the start of your next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Freezing, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d6 cold damage and its speed is reduced by 10 feet (to a minimum of 10 feet) until the start of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Fugitive's",
      type: "Prefix",
      description:
        "While carrying this item, you can't be targeted by any divination magic or perceived through magical scrying sensors.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Fugitive's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Dexterity (Stealth) checks, and leave behind no tracks or other traces of your passage. In addition, you can't be targeted by any divination magic or perceived through magical scrying sensors.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Ghost",
      type: "Suffix",
      description:
        "While carrying this item, you can use a bonus action to become incorporeal and translucent until the end of your next turn. While incorporeal, your weapon attacks deal force damage instead of bludgeoning, piercing, or slashing damage, you have resistance against bludgeoning, piercing, and slashing damage from nonmagical attacks, you can move through other creatures and objects as if they were difficult terrain, and you take 1d10 force damage if you end your turn inside an object. If this transformation ends while you are inside an object or other creature's space, you are pushed to the nearest unoccupied space, taking 1d10 force damage for each 5 feet you are pushed this way. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Ghost, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can use a bonus action to become incorporeal and translucent until the end of your next turn. While incorporeal, your weapon attacks deal force damage instead of bludgeoning, piercing, or slashing damage, you have resistance against bludgeoning, piercing, and slashing damage from nonmagical attacks, you can move through other creatures and objects as if they were difficult terrain, and you take 1d10 force damage if you end your turn inside an object. If this transformation ends while you are inside an object or other creature's space, you are pushed to the nearest unoccupied space, taking 1d10 force damage for each 5 feet you are pushed this way. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Ghoul's",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon and reduce the target to 0 hit points, you gain 10 temporary hit points.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Ghoul's, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon and reduce the target to 0 hit points, you gain 10 temporary hit points. In addition, you have advantage on all attack rolls, ability checks, and saving throws until the end of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Giant",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to magically increase in size for 1 minute. Your size doubles in all dimensions, and your weight is multiplied by eight. This growth increases your size by one category – from Medium to Large, for example. If there isn't enough room for you to double your size, you attain the maximum possible size in the space available. You have advantage on Strength checks and Strength saving throws. Your weapons also grow to match your new size. While your weapons are enlarged, your attacks with them deal an extra 1d4 damage of the weapon's type. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Giant, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as an action to magically increase in size for 1 minute. Your size doubles in all dimensions, and your weight is multiplied by eight. This growth increases your size by one category – from Medium to Large, for example. If there isn't enough room for you to double your size, you attain the maximum possible size in the space available. You have advantage on Strength checks and Strength saving throws. Your weapons also grow to match your new size. While your weapons are enlarged, your attacks with them deal an extra 1d4 damage of the weapon's type. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Glamoured",
      type: "Prefix",
      description:
        "While wearing this armor, you can use a bonus action to speak the armor's command word and cause the armor to assume the appearance of a normal set of clothing or some other kind of armor. You decide what it looks like, including color, style, and accessories, but the armor retains its normal bulk and weight. The illusory appearance lasts until you use this property again or remove the armor.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Glamoured, Greater",
      type: "Prefix",
      description:
        "While wearing this armor, you have advantage on Charisma (Persuasion) checks. In addition, you can use a bonus action to speak the armor's command word and cause the armor to assume the appearance of a normal set of clothing or some other kind of armor. You decide what it looks like, including color, style, and accessories, but the armor retains its normal bulk and weight. The illusory appearance lasts until you use this property again or remove the armor.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Gleaming",
      type: "Common",
      description: "This item never gets dirty.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Golem's",
      type: "Prefix",
      description:
        "While carrying this item, you are immune to spells and magic effects that would alter your form.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Golem's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you are immune to spells and magic effects that would alter your form. In addition, when a creature misses you with a melee attack while you are carrying this item, that creature must succeed on a DC 15 Wisdom saving throw or be magically slowed. Until the end of its next turn, it can't use reactions, its speed is halved, it can't make more than one attack on its turn, and it can take either an action or a bonus action on its turn, not both.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Gorgon",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into a cockatrice. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Gorgon, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing it, you can expend 1 or more of its charges as an action to transform into a cockatrice (1 charge) or a gorgon (3 charges). The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Grasping",
      type: "Prefix",
      description:
        "While wearing this armor, you have advantage on Strength (Athletics) checks made to grapple another creature.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Grasping, Greater",
      type: "Prefix",
      description:
        "While wearing this armor, you have advantage on Strength (Athletics) checks made to grapple another creature. In addition, a creature grappled by you takes 1d6 bludgeoning damage as the grapple begins, and at the start of each of its turns while it is grappled by you.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Guidance",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>guidance</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Harmonious",
      type: "Common",
      description: "Attuning to this item takes only 1 minute.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Haste",
      type: "Suffix",
      description:
        "While carrying this item, you can use it on your turn to gain the following benefits until the start of your next turn: your speed is doubled, you gain a +2 bonus to AC, you have advantage on Dexterity saving throws, and you gain an additional action on your turn, that can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Haste, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 of its charges on your turn to gain the following benefits until the start of your next turn: your speed is doubled, you gain a +2 bonus to AC, you have advantage on Dexterity saving throws, and you gain an additional action on your turn, that can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Haunting",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cause a dark spirit to rise from the corpse of a creature that has died within the last hour. The spirit has the characteristics of a shadow (Monster Manual p. 269), except that it doesn't create new shadows. It acts on your initiative and obeys any verbal commands you issue to it (no action required by you). If you don't issue any commands to it, the shadow defends itself from hostile creatures, but otherwise takes no actions. The shadow dissipates after 1 minute. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Haunting, Greater",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cause a dark spirit to rise from the corpse of a creature that has died within the last hour. The spirit has the characteristics of a shadow (Monster Manual p. 269), except that it doesn't create new shadows, it adds your character level to its hit points, and it adds your proficiency bonus to its AC, attack rolls, damage rolls, and saving throws. It acts on your initiative and obeys any verbal commands you issue to it (no action required by you). If you don't issue any commands to it, the shadow defends itself from hostile creatures, but otherwise takes no actions. The shadow dissipates after 1 minute. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Hawkish",
      type: "Prefix",
      description:
        "Attacking at long range doesn't impose disadvantage on ranged weapon attack rolls made with this weapon.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
    },
    {
      name: "Hawkish, Greater",
      type: "Prefix",
      description:
        "Attacking at long range doesn't impose disadvantage on ranged weapon attack rolls made with this weapon. In addition, your ranged weapon attacks made with this weapon ignore half cover and three-quarters cover.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
    },
    {
      name: "Healing",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>cure wounds</i> (+3 spellcasting ability). For 1 charge, you cast the 1st-level version of the spell. You can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Healing, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells (+5 spellcasting ability): <i>cure wounds</i> (1 charge per spell level) or <i>mass cure wounds</i> (5 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Healthy",
      type: "Prefix",
      description:
        "You are immune to contracting any disease while carrying this item. If you are already infected with a disease, the effects of the disease are suppressed while you carry the item.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Healthy, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you don't need to eat, drink, or sleep. In addition, you are immune to contracting any disease while carrying this item. If you are already infected with a disease, the effects of the disease are suppressed while you carry the item.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Heavens",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a bonus action to cast <i>divine favor</i>. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Heavens, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>divine favor</i> (1 charge) or as an action to cast <i>guardian of faith</i> (4 charges, spell save DC 15). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Hells",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as a reaction to cast <i>hellish rebuke</i> (save DC 13). For 1 charge, you cast the 1st-level version of the spell. You can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Hells, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a reaction to cast <i>hellish rebuke</i>  (1 charge per spell level, save DC 15) or as an action to cast <i>fire shield</i> (4 charges, fire version only). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Honesty",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, you are affected as by the spell <i>zone of truth</i> and can't speak a deliberate lie. You can avoid answering questions to which you would normally respond with a lie, or be evasive in your answers as long as you remain within the boundaries of the truth.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Hope",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>shield of faith</i> (1 action) or as an action to cast <i>aid</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Hope, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>shield of faith</i> (1 action) or as an action to cast <i>aid</i> (2 charges) or <i>beacon of hope</i> (3 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Hunter Ranger's",
      type: "Class",
      description:
        "While carrying this item, you can spend ten minutes in quiet meditation to change your choice of feature gained from either Hunter's Prey, Defensive Tactics, Multiattack, or Superior Hunter's Defense.",
      rarity: 1,
      attunement: "Requires attunement by a Hunter ranger",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Hunter Ranger's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can spend an action to change your choice of feature gained from either Hunter's Prey, Defensive Tactics, Multiattack, or Superior Hunter's Defense.",
      rarity: 2,
      attunement: "Requires attunement by a Hunter ranger",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Hunter",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>ensnaring strike</i> (1 charge, save DC 13) or as an action to cast <i>pass without trace</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The weapon regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Hunter, Greater",
      type: "Suffix",
      description:
        "This weapon has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>ensnaring strike</i> (1 charge, save DC 13) or as an action to cast <i>pass without trace</i> (2 charges) or <i>locate creature</i> (4 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Illithid's",
      type: "Prefix",
      description:
        "While carrying this item, you are immune to magic that allows other creatures to read your thoughts, determine whether you are lying, know your alignment, or know your creature type. Creatures can telepathically communicate with you only if you allow it.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Illithid's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to psychic damage. In addition, you are immune to magic that allows other creatures to read your thoughts, determine whether you are lying, know your alignment, or know your creature type. Creatures can telepathically communicate with you only if you allow it.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Illusionist",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>minor illusion</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Improviser's",
      type: "Prefix",
      description:
        "While wearing this armor, you can use a bonus action to change it into any other type of armor, such as leather armor, plate armor, or shield, as long as the armor has no other magic properties that restrict it from becoming that type of armor.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Improviser's, Greater",
      type: "Prefix",
      description:
        "While wearing this armor, you can use a bonus action to change it into any other type of armor, such as leather armor, plate armor, or shield, as long as the armor has no other magic properties that restrict it from becoming that type of armor. In addition, at the end of each short rest, you may choose one instrument, gaming set, tool, or language. You gain proficiency with that instrument or tool, or can speak, read, and understand that language until you are no longer attuned to this armor or when you choose another instrument, gaming set, tool, or language at the end of a short rest.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Independent's",
      type: "Prefix",
      description:
        "While carrying this item, difficult terrain doesn't cost you extra movement.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Independent's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, difficult terrain doesn't cost you extra movement. In addition, magic can neither reduce your speed nor cause you to be paralyzed or restrained.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Inevitable End",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When another creature you can see within 30 feet makes a saving throw, you can expend 1 or more of its charges as a reaction to roll a d4 and subtract the result + the number of charges expended from the creature's roll.\n&#8226; You can expend 3 charges as an action to cast <i>blight</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Inevitable End, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects: When another creature you can see within 30 feet makes a saving throw, you can expend 1 or more of its charges as a reaction to roll a d4 and subtract the result + the number of charges expended from the creature's roll, or you can expend its charges as an action to cast one of the following spells (save DC 15): <i>blight</i> (3 charges) or <i>finger of death</i> (5 charges). If the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Inquisitor's",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action on your turn to make a Charisma (Intimidation) check contested by the Wisdom saving throw of a creature within 30 feet that can see you. On a success, that creature is frightened of you until the start of your next turn. This property can't be used against the same creature until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Inquisitor's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Intimidation checks. In addition, while holding it, you can use a bonus action on your turn to make a Charisma (Intimidation) check contested by the Wisdom saving throw of a creature within 30 feet that can see you. On a success, that creature is frightened of you until the start of your next turn. This property can't be used against the same creature until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Intrusion",
      type: "Suffix",
      description:
        "When you hit a creature with this weapon, you can choose to learn any damage vulnerabilities, damage resistances, and damage immunities that creature has, and if the creature has the feature Magic Resistance. You can then choose one damage resistance that creature has or the feature Magic Resistance. The creature loses that damage resistance or feature for 1 minute. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Intrusion, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you hit a creature with this weapon, you can expend 1 charge to learn any damage vulnerabilities, damage resistances, and damage immunities that creature has, and if the creature has the feature Magic Resistance. You can then choose one damage resistance that creature has or the feature Magic Resistance. The creature loses that damage resistance or feature for 1 minute. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Invigorating",
      type: "Prefix",
      description:
        "When your current hit points are equal to or less than half your hit point maximum while carrying this item, you have advantage on ability checks made with Strength or Dexterity.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Invigorating, Greater",
      type: "Prefix",
      description:
        "When your current hit points are equal to or less than half your hit point maximum while carrying this item, you have advantage on ability checks and attack rolls made with Strength or Dexterity.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Invisibility",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to turn invisible. You remain invisible for 1 minute, until you attack or cast a spell, or until you use a bonus action to become visible again. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Invisibility, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a bonus action to turn invisible. You remain invisible for 1 minute, until you attack or cast a spell, or until you use a bonus action to become visible again. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Keen",
      type: "Prefix",
      description:
        "When you attack with this weapon, your weapon attacks score a critical hit on a roll of 19 or 20.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Keen, Greater",
      type: "Prefix",
      description:
        "When you attack with this weapon, your weapon attacks score a critical hit on a roll of 18-20.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Knowledge Cleric's",
      type: "Class",
      description:
        "While you carry this item and use your Channel Divinity: Knowledge of the Ages to gain proficiency in a skill or tool, your proficiency bonus is doubled for any ability check you make using that skill or tool for the duration.",
      rarity: 1,
      attunement: "Requires attunement by a Knowledge cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Knowledge Cleric's, Greater",
      type: "Class",
      description:
        "While you carry this item and use your Channel Divinity: Knowledge of the Ages to gain proficiency in a skill or tool, your proficiency bonus is doubled for any ability check you make using that skill or tool for the duration. In addition, the proficiency you gain from your Channel Divinity: Knowledge of the Ages lasts until you use the feature again and choose a different proficiency.",
      rarity: 2,
      attunement: "Requires attunement by a Knowledge cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Legion",
      type: "Prefix",
      description:
        "While wearing this armor, you gain a +1 bonus to AC for every ally within 5 feet of you that isn't incapacitated (up to a maximum of +2).",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Legion, Greater",
      type: "Prefix",
      description:
        "While wearing this armor, you gain a +1 bonus to AC for every ally within 5 feet of you that isn't incapacitated (up to a maximum of +3).",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Liar's",
      type: "Prefix",
      description:
        "While carrying this weapon, you can use a bonus action to make a Charisma (Deception) check against the passive Insight of a creature within 30 feet that can see you. On a success, you have advantage on the next attack you make against that creature until the end of your turn. This property can't be used against the same creature until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Liar's, Greater",
      type: "Prefix",
      description:
        "While carrying this weapon, you have advantage on Deception checks. In addition, while carrying this weapon, you can use a bonus action to make a Charisma (Deception) check against the passive Insight of a creature within 30 feet that can see you. On a success, you have advantage on the next attack you make against that creature until the end of your turn. This property can't be used against the same creature until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Life Cleric's",
      type: "Class",
      description:
        "While carrying this item, your Channel Divinity: Preserve Life can restore a creature to more than half of its hit point maximum.",
      rarity: 1,
      attunement: "Requires attunement by a Life cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Life Cleric's, Greater",
      type: "Class",
      description:
        "While carrying this item, your Channel Divinity: Preserve Life can restore a creature to more than half of its hit point maximum. In addition, any creature that regains hit points from your Channel Divinity: Preserve Life also gains the benefit of the lesser restoration spell.",
      rarity: 2,
      attunement: "Requires attunement by a Life cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Light Cleric's",
      type: "Class",
      description:
        "While you carry this item, a creature that fails its saving throw against your Channel Divinity: Radiance of the Dawn is also blinded until the end of its next turn.",
      rarity: 1,
      attunement: "Requires attunement by a Light cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Light Cleric's, Greater",
      type: "Class",
      description:
        "While you carry this item, a creature that fails its saving throw against your Channel Divinity: Radiance of the Dawn is also blinded and stunned until the end of its next turn.",
      rarity: 2,
      attunement: "Requires attunement by a Light cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Lightning",
      type: "Suffix",
      description:
        "When you make a ranged attack with this weapon and speak its command word, the weapon or a piece of ammunition fired from it transforms into a bolt of lightning, forming a line 5 feet wide that extends out from you to a target within the weapon's maximum range. Each creature in the line excluding you and the target must make a DC 13 Dexterity saving throw, taking 4d6 lightning damage on a failed save, and half as much damage on a successful one. The lightning bolt turns back into a weapon or piece of ammunition when it reaches the target. Make a ranged weapon attack against the target. On a hit, the target takes damage from the weapon plus 4d6 lightning damage. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Lightning, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you make a ranged attack with this weapon and speak its command word, you can expend 1 of its charges to transform the weapon or a piece of ammunition fired from it into a bolt of lightning, forming a line 5 feet wide that extends out from you to a target within the weapon's maximum range. Each creature in the line excluding you and the target must make a DC 15 Dexterity saving throw, taking 4d6 lightning damage on a failed save, and half as much damage on a successful one. The lightning bolt turns back into a weapon or piece of ammunition when it reaches the target. Make a ranged weapon attack against the target. On a hit, the target takes damage from the weapon plus 4d6 lightning damage. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Living",
      type: "Prefix",
      description:
        "When you take bludgeoning, piercing, or slashing damage while wearing this armor, you can use your reaction to reduce the damage you take by 1d10",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Living, Greater",
      type: "Prefix",
      description:
        "When you take bludgeoning, piercing, or slashing damage while wearing this armor, you can use your reaction to reduce the damage you take by 2d10",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Lore Bard's",
      type: "Class",
      description:
        "When you use your Cutting Words to reduce the result of a creature's attack roll, ability check, or damage roll while carrying this item, the creature also takes psychic damage equal to the number rolled on the Bardic Inspiration die.",
      rarity: 1,
      attunement: "Requires attunement by a Lore bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Lore Bard's, Greater",
      type: "Class",
      description:
        "When you use your Cutting Words to reduce the result of a creature's attack roll, ability check, or damage roll while carrying this item, the creature also takes psychic damage equal to the number rolled on the Bardic Inspiration die + your Charisma modifier.",
      rarity: 2,
      attunement: "Requires attunement by a Lore bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Loyal",
      type: "Common",
      description:
        "While you are conscious and holding this item, you can't unwillingly be disarmed of it.",
      rarity: 0,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Luck",
      type: "Suffix",
      description:
        "While carrying this item, you can call on its luck (no action required) to reroll one attack roll, ability check, or saving throw you dislike. You must use the second roll. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Luck, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 of its charges to call on its luck (no action required) to reroll one attack roll, ability check, or saving throw you dislike. You must use the second roll. The item regains all expended charges daily at dawn. ",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Mage Slayer's",
      type: "Prefix",
      description:
        "Once per turn, when you hit a creature with this weapon, you can have that creature make a DC 13 Constitution saving throw. On a failure, it can't cast spells higher than 1st level until the end of its next turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Mage Slayer's, Greater",
      type: "Prefix",
      description:
        "Once per turn, when you hit a creature with this weapon, you can have that creature make a DC 15 Constitution saving throw. On a failure, it can't cast spells other than cantrips until the end of its next turn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Mage's",
      type: "Prefix",
      description:
        "When you roll a 1 on the d20 for a saving throw you make to maintain your concentration on a spell while carrying this item, you can reroll the die and must use the new roll.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Mage's, Greater",
      type: "Prefix",
      description:
        "When you fail a saving throw you make to maintain your concentration on a spell while carrying this item, you can reroll the die and must use the new roll.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Magnetic",
      type: "Prefix",
      description:
        "When a creature misses you with a melee weapon attack made with a metallic weapon while you are wearing this armor, you can use your reaction to catch the weapon magnetically. The attacker must succeed on a DC 13 Strength (Athletics) check, or the weapon becomes stuck to your armor. If the weapon's wielder can't or won't let go of the weapon, the wielder is grappled while the weapon is stuck. While stuck, the weapon can't be used. A creature can pull the weapon free by using an action and succeeding on a DC 13 Strength (Athletics) check.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Magnetic, Greater",
      type: "Prefix",
      description:
        "When a creature attacks you with a melee weapon made of metal, you can use your reaction to impose disadvantage on the attack. If the attack misses you, the attacker must succeed on a DC 15 Strength (Athletics) check, or the weapon becomes stuck to your armor. If the weapon's wielder can't or won't let go of the weapon, the wielder is grappled while the weapon is stuck. While stuck, the weapon can't be used. A creature can pull the weapon free by using an action and succeeding on a DC 15 Strength (Athletics) check. ",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Marid's",
      type: "Prefix",
      description:
        "While carrying this item, you have a swimming speed equal to your walking speed.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Marid's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to cold damage and a swimming speed equal to your walking speed.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Master",
      type: "Suffix",
      description:
        "This weapon contains a transmuted orange faerie dragon, imp, or quasit (DM's choice). You can use an action on your turn to speak this weapon's command word and throw it up into the air. The weapon becomes a creature (see above) that is under your control and acts on its own initiative count. The creature obeys any verbal commands that you issue to it (no action required by you). The creature reverts back to the weapon after 1 hour, if it's reduced to 0 hit points, or if you use a bonus action to end the transformation. Once the transformation ends, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Master, Greater",
      type: "Suffix",
      description:
        "This weapon contains a transmuted orange faerie dragon, imp, or quasit (DM's choice). You can use an action on your turn to speak this weapon's command word and throw it up into the air. The weapon becomes a creature (see above) that is under your control and acts on its own initiative count. The creature obeys any verbal commands that you issue to it (no action required by you). The creature reverts back to the weapon if it's reduced to 0 hit points, or if you use a bonus action to end the transformation. Once the transformation ends, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Mending",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>mending</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Merciful",
      type: "Common",
      description:
        "When you roll damage for an attack using this weapon, you can choose to deal minimum damage instead of rolling.",
      rarity: 0,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Metamagic",
      type: "Suffix",
      description:
        "This item has 3 charges. When you cast a spell while carrying it, you can expend 1 or more of its charges to apply either the Subtle Spell (1 charge) or Quickened Spell (2 charges) Metamagic effects to the spell. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Metamagic, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. When you cast a spell while carrying it, you can expend 1 or more of its charges to apply either the Subtle Spell (1 charge), Quickened Spell (2 charges), or Heightened Spell (3 charges) Metamagic effects to the spell. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Mind's",
      type: "Prefix",
      description:
        "While carrying this item, you can telepathically speak to any creature you can see within 30 feet of you. You don't need to share a language with the creature for it to understand your telepathic utterances, but the creature must be able to understand at least one language.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Mind's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can telepathically speak to any creature you can see within 30 feet of you. You don't need to share a language with the creature for it to understand your telepathic utterances, but the creature must be able to understand at least one language. In addition, you can use an action to cast <i>detect thoughts</i> (save DC 15).",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Mirrors",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cast <i>mirror image</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Mirrors, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 of its charges as an action to cast <i>mirror image</i>. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Misleading",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cast <i>major image</i> (spell save DC 13). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Misleading, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges to cast <i>major image</i> (1 charge) or <i>mislead</i> (2 charges). The save DC for both spells is 15. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Missile Attraction",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. Whenever a ranged weapon attack is made against a target within 10 feet of you, the curse causes you to become the target instead.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Mithral",
      type: "Prefix",
      description:
        "This armor weighs only half its usual weight. It doesn't impose disadvantage on Dexterity (Stealth) checks and has no Strength requirement. ",
      rarity: 1,
      attunement: "No",
      armor: "MediumHeavy",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Mithral, Greater",
      type: "Prefix",
      description:
        "This armor weighs only half its usual weight. It doesn't impose disadvantage on Dexterity (Stealth) checks and has no Strength requirement. In addition, you are considered proficient with a medium mithral armor even if you lack proficiency with medium armor, and with a heavy mithral armor as long as you have proficiency with medium armor.",
      rarity: 2,
      attunement: "No",
      armor: "MediumHeavy",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Mocking",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature has disadvantage on the next attack roll it makes before the end of its next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Mocking, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 1d6 psychic damage and has disadvantage on the next attack roll it makes before the end of its next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Momentous",
      type: "Prefix",
      description:
        "Once per turn, when you move at least 10 feet in a straight line immediately before hitting with an attack using this weapon, the target takes an extra 2d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Momentous, Greater",
      type: "Prefix",
      description:
        "Once per turn, when you move at least 10 feet in a straight line immediately before hitting with an attack using this weapon, the target takes an extra 4d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Monk's",
      type: "Class",
      description:
        "While carrying this item, your unarmed strikes and attacks with monk weapons deal force damage instead of bludgeoning, piercing, or slashing damage, and the spells mage armor, shield, and shield of faith provide no defense against your unarmed strikes and attacks with monk weapons, which pass through those spells' barriers of magical force.",
      rarity: 1,
      attunement: "Requires attunement by a monk",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Monk's, Greater",
      type: "Class",
      description:
        "While carrying this item, your unarmed strikes and attacks with monk weapons deal force damage instead of bludgeoning, piercing, or slashing damage, and the spells mage armor, shield, and shield of faith provide no defense against your unarmed strikes and attacks with monk weapons, which pass through those spells' barriers of magical force. In addition, when you make an unarmed strike or attack with a monk weapon and roll a 20 on the attack roll, the target takes an extra 10 points of force damage.",
      rarity: 2,
      attunement: "Requires attunement by a monk",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Moon Druid's",
      type: "Class",
      description:
        "When you hit with a melee weapon attack while in your Wild Shape and carrying this item, you can expend one spell slot to deal additional damage of the weapon's type to the target. The extra damage is 1d8 for a 1st-level spell slot, plus 1d8 for each spell level higher than 1st.",
      rarity: 1,
      attunement: "Requires attunement by a Moon druid",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Moon Druid's, Greater",
      type: "Class",
      description:
        "When you hit with a melee weapon attack while in your Wild Shape and carrying this item, you can expend one spell slot to deal additional damage of the weapon's type to the target. The extra damage is 2d8 for a 1st-level spell slot, plus 1d8 for each spell level higher than 1st.",
      rarity: 2,
      attunement: "Requires attunement by a Moon druid",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Music",
      type: "Common",
      description: "This weapon also functions as an instrument.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Nature Cleric's",
      type: "Class",
      description:
        "While carrying this item, your Channel Divinity: Charm Animals and Plants also affects monstrosities with an Intelligence score of 5 or less.",
      rarity: 1,
      attunement: "Requires attunement by a Nature cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Nature Cleric's, Greater",
      type: "Class",
      description:
        "While carrying this item, your Channel Divinity: Charm Animals and Plants also affects monstrosities with an Intelligence score of 5 or less. In addition, you gain a telepathic link to a creature affected by your Channel Divinity: Charm Animals and Plants. You can use this telepathic link to issue commands to the creature while you are conscious (no action required), which it must do its best to obey. ",
      rarity: 2,
      attunement: "Requires attunement by a Nature cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Necromancy Wizard's",
      type: "Class",
      description:
        "While carrying this item, when you regain hit points from your Grim Harvest by killing one or more creatures with a spell from the School of Necromancy, you also regain one expended spell slot. The slot you regain must be of a level lower than the spell you cast and can't be higher than 5th level.",
      rarity: 1,
      attunement: "Requires attunement by a Necromancy wizard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Necromancy Wizard's, Greater",
      type: "Class",
      description:
        "While carrying this item, when you regain hit points from your Grim Harvest, you also regain one expended spell slot. The slot you regain must be of a level lower than the spell you cast and can't be higher than 5th level.",
      rarity: 2,
      attunement: "Requires attunement by a Necromancy wizard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Night",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>arms of Hadar</i> (1 charge per spell level) or <i>darkness</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Night, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>arms of Hadar</i> (1 charge per spell level), <i>darkness</i> (2 charges), or <i>hunger of Hadar</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Nullification",
      type: "Suffix",
      description:
        "While carrying this item, you can use a reaction to cast counterspell or use an action to cast dispel magic. Your spellcasting ability for both spells is +3. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Nullification, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 of its charges as a reaction to cast counterspell or as an action to cast dispel magic. Your spellcasting ability for both spells is +5. For 1 charge, you cast the 3rd-level version of the spell. You can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Ocean",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cast <i>water breathing</i> or <i>dominate beast</i> (save DC 13, can only target a beast that has an innate swimming speed). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Ocean, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 15): <i>water breathing</i> (1 charge), <i>dominate beast</i> (1 charge, can only target a beast that has an innate swimming speed), or <i>control water</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Odor",
      type: "Common",
      description:
        "While carrying this item, you can use a bonus action to cause it to emit either a foul, rancid smell of rot and manure, or a pleasant, rosy smell of flowery perfume. ",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Ooze's",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on ability checks and saving throws made to escape being grappled or restrained.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Ooze's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to acid damage, and you have advantage on ability checks and saving throws made to escape being grappled or restrained.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Paladin's",
      type: "Class",
      description:
        "While carrying this item, you can expend 5 hit points from your Lay on Hands pool of healing and use an action to touch one creature and end one condition that causes that creature to be blinded or deafened.",
      rarity: 1,
      attunement: "Requires attunement by a paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Paladin's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can expend 5 hit points from your Lay on Hands pool of healing and use an action to touch one creature and end one condition that causes that creature to be blinded, deafened, frightened, paralyzed, or stunned.",
      rarity: 2,
      attunement: "Requires attunement by a paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Petrifying",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 13 Constitution saving throw if its body is made of flesh. On a failed save, the creature is restrained for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Petrifying, Greater",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 15 Constitution saving throw if its body is made of flesh. On a failed save, the creature is restrained and must make another DC 15 Constitution saving throw at the end of each of its turns. On a success, the effect ends. If it fails its saves three times (including the first failure), it is turned to stone and subjected to the petrified condition for 1 hour.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Phaser's",
      type: "Prefix",
      description:
        "When you take the Attack action while carrying this item, you can use a bonus action to immediately teleport up to 10 feet to an unoccupied space you can see.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Phaser's, Greater",
      type: "Prefix",
      description:
        "When you take the Attack action while carrying this item, you can teleport up to 10 feet before each attack to an unoccupied space you can see.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Poisonous",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature must succeed on a DC 13 Constitution saving throw or become poisoned until the end of your next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "PiercingSlashing",
      wondrous: "No",
    },
    {
      name: "Poisonous, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes an extra 1d6 poison damage and must succeed on a DC 15 Constitution saving throw or become poisoned until the end of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "PiercingSlashing",
      wondrous: "No",
    },
    {
      name: "Polymorph",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 13 Wisdom saving throw. On a failed save, the creature is affected as by the spell <i>polymorph</i>. Roll on the Polymorph table to randomly determine the creature's new form, which lasts for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. This property has no effect on a shapechanger or a creature with 0 hit points.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Polymorph, Greater",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 15 Wisdom saving throw. On a failed save, the creature is affected as by the spell <i>polymorph</i>. Choose any beast with a challenge rating of 8 or less as the creature's new form, which lasts for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. This property has no effect on a shapechanger or a creature with 0 hit points.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Possessive",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, you are unwilling to part with the item. If the item is a wearable object, you refuse to take it off, even when it is detrimental to keep it on. If it is a weapon or tool, you have disadvantage with all other weapons or tools.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Power",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cause divine energy to radiate from it, distorting and diffusing magical energy around you. For 1 minute, you have advantage on saving throws against spells and other magical effects. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Power, Greater",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cause divine energy to radiate from it, distorting and diffusing magical energy around you. For 1 minute, each friendly creature within 30 feet of you (including you) has advantage on saving throws against spells and other magical effects. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Prestidigitation",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>prestidigitation</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Prodigy's",
      type: "Prefix",
      description:
        "While carrying this item, one of your ability scores (DM's choice or rolled on the Ability Score table) increases by 1, to a maximum of 22.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Prodigy's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, one of your ability scores (DM's choice or rolled on the Ability Score table) increases by 2, to a maximum of 24.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Profane",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature can't regain hit points until the start of your next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Profane, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with this weapon, the creature takes 1d6 necrotic damage and it can't regain hit points until the start of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Protective",
      type: "Prefix",
      description:
        "When a creature you can see attacks a target other than you that is within 5 feet of you while you are holding this magic shield, you can use your reaction to impose disadvantage on the attack roll.",
      rarity: 1,
      attunement: "No",
      armor: "Shield",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Protective, Greater",
      type: "Prefix",
      description:
        "When a creature you can see attacks a target other than you that is within 5 feet of you while you are holding this magic shield, you can use your reaction to impose disadvantage on the attack roll. If the attack misses, you can then immediately make an opportunity attack with a melee weapon you are wielding against the attacker as part of the same reaction, if the attacker is within your reach.",
      rarity: 2,
      attunement: "No",
      armor: "Shield",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Pugilist",
      type: "Prefix",
      description:
        "While carrying this item, you gain a +1 bonus to attack and damage rolls made with unarmed attacks and your unarmed attacks count as magical for the purpose of overcoming resistance and immunity to nonmagical attacks and damage. ",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Pugilist, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you gain a +2 bonus to attack and damage rolls made with unarmed attacks and your unarmed attacks count as magical for the purpose of overcoming resistance and immunity to nonmagical attacks and damage. ",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Ranger's",
      type: "Class",
      description:
        "While carrying this item, your favored enemies have disadvantage on attack rolls against you.",
      rarity: 1,
      attunement: "Requires attunement by a ranger",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Ranger's, Greater",
      type: "Class",
      description:
        "While carrying this item, your favored enemies have disadvantage on attack rolls against you. In addition, you have advantage on any ability check or saving throw made to resist or defend yourself against harmful conditions and effects created by your favored enemies' features (not including spells), such as a dragon's Breath Weapon or a mindflayer's Mind Blast.",
      rarity: 2,
      attunement: "Requires attunement by a ranger",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Reflection",
      type: "Suffix",
      description:
        "When a creature misses you with a weapon attack while you are wearing this armor, you can choose to reflect the attack back on the attacker. The creature must make a new attack roll for the attack against its own AC. On a hit, the creature takes damage and suffers other effects of the attack as normal. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Reflection, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. When a creature misses you with a weapon attack while you are wearing this armor, you can expend 1 charge to reflect the attack back on the attacker. The creature must make a new attack roll for the attack against its own AC. On a hit, the creature takes damage and suffers other effects of the attack as normal. The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Rejuvenating",
      type: "Common",
      description:
        "While carrying this item, you require only 6 hours to gain the benefits of a long rest.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Restoration",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to cast <i>lesser restoration</i> targeting yourself. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Restoration, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>lesser restoration</i> (1 charge) or <i>greater restoration</i> (2 charges), targeting yourself. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Rising Sun",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When you make an attack roll or saving throw, you can expend 1 or more of its charges to roll a d4 and add the result + the number of charges expended to the roll.\n&#8226; You can expend 3 charges as an action to cast <i>dawn</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Rising Sun, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When you make an attack roll or saving throw, you can expend 1 or more of its charges to roll a d4 and add the result + the number of charges expended to the roll.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>dawn</i> (3 charges) or <i>sunbeam</i> (5 charges).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Roaring Fire",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend its charges to cause the following effects: \n&#8226; When a creature within 5 feet of you hits you with a melee attack while you carry this weapon, you can expend 1 or more charges to deal 1d8 fire damage to that creature for each charge expended this way.\n&#8226; You can expend 3 charges as an action to cast <i>wall of fire</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Roaring Fire, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend its charges to cause the following effects:\n&#8226; When a creature within 5 feet of you hits you with a melee attack while you carry this weapon, you can expend 1 or more charges to deal 1d8 fire damage to that creature for each charge expended this way.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>fire wall</i> (3 charges) or <i>fire storm</i> (5 charges).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Rogue's",
      type: "Class",
      description:
        "When you deal your Sneak Attack damage to a creature while carrying this item, the target takes an additional 1d6 damage of the weapon's type.",
      rarity: 1,
      attunement: "Requires attunement by a rogue",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Rogue's, Greater",
      type: "Class",
      description:
        "When you deal your Sneak Attack damage to a creature while carrying this item, the target takes an additional 2d6 damage of the weapon's type.",
      rarity: 2,
      attunement: "Requires attunement by a rogue",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Roiling Clouds",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When you roll a Strength or Constitution saving throw, you can expend 1 charge to give yourself advantage on the roll.\n&#8226; You can expend 3 charges as an action to cast <i>thunder step</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Roiling Clouds, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When you roll a Strength or Constitution saving throw, you can expend 1 charge to give yourself advantage on the roll.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>thunder step</i> (3 charges) or <i>destructive wave</i> (5 charges).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Sabotage",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, your are weaker against a specific type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. You have disadvantage on attack rolls against creatures of that type and on saving throws against their spells and special abilities.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Sacred",
      type: "Prefix",
      description:
        "When you hit a fiend or undead creature with an attack using this weapon, the creature takes an extra 1d6 radiant damage.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Sacred, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an extra 1d6 radiant damage. If the target is a fiend or undead creature it takes an extra 2d6 radiant damage instead.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Sage",
      type: "Common",
      description:
        "While carrying this item, you can give yourself advantage on an Intelligence (Arcana, History, Nature or Religion) check you make. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Savior",
      type: "Suffix",
      description:
        "When a creature you can see attacks a target other than you that is within 30 feet of you while you are carrying this item, you can use your reaction to magically swap places with the target of the attack, if it is willing. The attack is made against you instead. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Savior, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. When a creature you can see attacks a target other than you that is within 30 feet of you while you are carrying this item, you can expend 1 charge as a reaction to magically swap places with the target of the attack, if it is willing. The attack is made against you instead. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "School Specialization",
      type: "Suffix",
      description:
        "This item is attuned to one school of magic (chosen by the DM or rolled on the School Specialization table). When you cast a spell from that school of magic using one of your spell slots while carrying this item, you can choose to have the spell take effect as if you had cast it using a spell slot one level higher than the one you used to cast it. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "School Specialization, Greater",
      type: "Suffix",
      description:
        "This item is attuned to one school of magic (chosen by the DM or rolled on the School Specialization table) and has 3 charges. When you cast a spell from that school of magic using one of your spell slots while carrying this item, you can expend 1 charge and choose that the spell takes effect as if you had cast it using a spell slot one level higher than the one you used to cast it. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Scornful",
      type: "Prefix",
      description:
        "When a creature misses you with an attack while you are carrying this item, you can use your reaction to force the attacker to make a DC 13 Wisdom saving throw. On a failure, the creature takes 1d6 psychic damage and has disadvantage on the next attack roll it makes before the end of its next turn.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Scornful, Greater",
      type: "Prefix",
      description:
        "When a creature misses you with an attack while you are carrying this item, you can use your reaction to force the attacker to make a DC 15 Wisdom saving throw. On a failure, the creature takes 2d6 psychic damage and has disadvantage on the next attack roll it makes before the end of its next turn.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Searching",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells: <i>detect evil and good</i> (1 charge), <i>detect magic</i> (1 charge), or <i>locate object</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Searching, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast the following spells: <i>detect evil and good</i> (1 charge), <i>detect magic</i> (1 charge), <i>locate object</i> (2 charges), or <i>locate creature</i> (4 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Seeking",
      type: "Suffix",
      description:
        "When you make a ranged attack using this weapon, you can choose to imbue the missile with seeking magic. You don't make an attack roll for the attack, but instead choose one creature or object you have seen in the past minute. The missile flies toward that target, moving around corners if necessary and ignoring three-quarters cover and half cover. If the target is within the weapon's range and there is a path large enough for the missile to travel to the target, the target must succeed on a DC 13 Dexterity saving throw (an inanimate object automatically fails this saving throw) or take damage as if it were hit by the missile, plus an extra 1d10 force damage, and you learn the target's current location. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Seeking, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you make a ranged attack using this weapon, you can expend 1 charge to imbue the missile with seeking magic. You don't make an attack roll for the attack, but instead choose one creature or object you have seen in the past minute. The missile flies toward that target, moving around corners if necessary and ignoring three-quarters cover and half cover. If the target is within the weapon's range and there is a path large enough for the missile to travel to the target, the target must succeed on a DC 15 Dexterity saving throw (an inanimate object automatically fails this saving throw) or take damage as if it were hit by the missile, plus an extra 2d10 force damage, and you learn the target's current location. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Seer's",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Wisdom (Perception) checks that rely on sight.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Seer's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on Wisdom (Perception) checks that rely on sight. In addition, you have darkvision out to a range of 60 ft. and can see invisible creatures and objects as well as see into the Ethereal Plane, out to a range of 60 feet.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Sensitivity",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. Whenever you take damage while cursed, you must make a DC 15 Constitution saving throw. On a failure, you become stunned until the end of your next turn.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Sentinel's",
      type: "Prefix",
      description:
        "You have advantage on your attack roll when you make an opportunity attack using this weapon. ",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Sentinel's, Greater",
      type: "Prefix",
      description:
        "You have advantage on your attack roll when you make an opportunity attack using this weapon. In addition, if the attack hits, you can move up to 10 feet immediately after the attack and as part of the same reaction. This movement doesn't provoke opportunity attacks.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Shadow Monk's",
      type: "Class",
      description:
        "While carrying this item, spells cast using your Shadow Arts each costs 1 fewer ki point to cast.",
      rarity: 1,
      attunement: "Requires attunement by a Way of Shadow Monk",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Shadow Monk's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can cast spells using your Shadow Arts without expending ki points.",
      rarity: 2,
      attunement: "Requires attunement by a Way of Shadow Monk",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Shadow",
      type: "Suffix",
      description:
        "While carrying this weapon, you can use a bonus action to turn the weapon into a shadowy version of itself. For 1 minute, or until you end this effect as a bonus action, it deals psychic damage instead of its usual damage type, and has the finesse and light properties. In addition, when you use the weapon to attack a target that is in dim light or darkness, you make the attack roll with advantage. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Shadow, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can use a bonus action to turn the weapon into a shadowy version of itself. For 1 minute, or until you end this effect as a bonus action, it deals psychic damage instead of its usual damage type, and has the finesse and light properties. In addition, when you use the weapon to attack a target that is in dim light or darkness, you make the attack roll with advantage and the target takes an extra 1d10 psychic damage if the attack hits. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Shadowfell",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to magically cause flame-like shadows to wreathe your body for 1 minute or until you dismiss them as a bonus action, causing you to become heavily obscured to others. The shadows turn dim light within 10 feet of you into darkness, and bright light in the same area to dim light. In addition, whenever a creature within 10 feet of you hits you with an attack, the shadows lash out at that creature, dealing it 1d8 necrotic damage. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Shadowfell, Greater",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing it, you can expend 1 charge as an action to magically cause flame-like shadows to wreathe your body for 1 minute or until you dismiss them as a bonus action, causing you to become heavily obscured to others. The shadows turn dim light within 10 feet of you into darkness, and bright light in the same area to dim light. In addition, whenever a creature within 10 feet of you hits you with an attack, the shadows lash out at that creature, dealing it 1d8 necrotic damage. The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Shadowtop",
      type: "Prefix",
      description:
        "While carrying this item in dim light or darkness, you have advantage on Strength and Dexterity ability checks.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Shadowtop, Greater",
      type: "Prefix",
      description:
        "While carrying this item in dim light or darkness, you have advantage on Strength and Dexterity ability checks and saving throws.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Shark",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into a hunter shark or a young bulette. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Shark, Greater",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to transform into a giant shark or a bulette. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Shattering",
      type: "Prefix",
      description:
        "When you attack with this weapon and roll a 20 on the attack roll, each creature of your choice within 10 feet of the target must make a DC 13 Constitution saving throw. A creature takes 2d8 thunder damage on a failed save, or half as much damage on a successful one. A creature made of inorganic material such as stone, crystal, or metal has disadvantage on this saving throw.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Shattering, Greater",
      type: "Prefix",
      description:
        "When you attack with this weapon and roll a 20 on the attack roll, each creature of your choice within 10 feet of the target must make a DC 15 Constitution saving throw. A creature takes 4d8 thunder damage on a failed save, or half as much damage on a successful one. A creature made of inorganic material such as stone, crystal, or metal has disadvantage on this saving throw.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Shielding",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a reaction to cast <i>shield</i> or as an action to cast <i>mage armor</i>. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Shielding, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a reaction to cast <i>shield</i> (1 charge) or as an action to cast <i>mage armor</i> (1 charge) or <i>stoneskin</i> (4 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Shocking",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target can't take reactions until the start of its next turn.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Shocking, Greater",
      type: "Prefix",
      description:
        "When you hit with an attack using this weapon, the target takes an additional 1d6 lightning damage and can't take reactions until the start of its next turn.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Siege",
      type: "Common",
      description:
        "When you hit an object with this weapon, the object takes an extra 2d6 damage of the weapon's type.",
      rarity: 0,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Silver Tongue",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>friends</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Skinlike",
      type: "Common",
      description:
        "You are considered proficient with this armor even if you lack proficiency with light armor.",
      rarity: 0,
      attunement: "No",
      armor: "Light",
      weapon: "No",
      wondrous: "No",
    },
    {
      name: "Skirmisher's",
      type: "Prefix",
      description:
        "While carrying this item, any creature that makes an opportunity attack against you has disadvantage on the attack roll.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Skirmisher's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, your speed is increased by 10 feet. In addition, any creature that makes an opportunity attack against you has disadvantage on the attack roll.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Smoke",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>fog cloud</i> (1 charge) or <i>pass without trace</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Smoke, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells: <i>fog cloud</i> (1 charge), <i>pass without trace</i> (2 charges), or <i>gaseous form</i> (3 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Soldier's",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on death saving throws and saving throws against being frightened.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Soldier's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you stabilize whenever you are dying at the start of your turn. In addition, you are immune to being frightened.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Soul Theft",
      type: "Suffix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, and the creature has fewer than 50 hit points, it must succeed on a DC 13 Constitution saving throw or be slain instantly as the weapon tears its life force from its body (a construct or an undead is immune). Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Soul Theft, Greater",
      type: "Suffix",
      description:
        "When you attack a creature that has fewer than 100 hit points with this weapon and roll a 20 on the attack roll, it must succeed on a DC 15 Constitution saving throw or be slain instantly as the weapon tears its life force from its body (a construct or an undead is immune). Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Spectacular",
      type: "Common",
      description:
        "As an action, you can cause illusory smoke, faint flames, rime ice, electric sparks, or dripping venom to form on the surface of this item until you dismiss the effect as an action. This effect can only be seen, not smelled, felt, tasted, or heard.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Spell Absorption",
      type: "Suffix",
      description:
        "When a spell or magical effect you can see deals damage to you while you are holding this weapon, you can use your reaction to halve the spell's damage against you. The first time you hit with an attack using this weapon until the end of your next turn, the target takes extra force damage equal to the damage prevented this way. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Spell Absorption, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When a spell or magical effect you can see deals damage to you while you are holding it, you can expend 1 charge as a reaction to halve the spell's damage against you. The first time you hit with an attack using this weapon until the end of your next turn, the target takes extra force damage equal to the damage prevented this way. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Spell Duelist's",
      type: "Prefix",
      description:
        "Whenever you successfully counter a spell or dispel magic using a spell slot of 2nd-level or higher, you regain one expended spell slot. The slot you regain must be of a level lower than the spell you cast and can't be higher than 5th level.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Spell Duelist's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on ability checks made to counter a spell or dispel magic, and other creatures have disadvantage on ability checks made to counter a spell you cast or to dispel a magic effect created by a spell you cast. In addition, whenever you successfully counter a spell or dispel magic using a spell slot of 2nd-level or higher, you regain one expended spell slot. The slot you regain must be of a level lower than the spell you cast and can't be higher than 5th level.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Spell Storing",
      type: "Suffix",
      description:
        "This item can store up to 2 levels worth of spells cast into it. Any creature can cast a spell of 1st through 2nd level into the item by touching the item as the spell is cast. The spell has no effect, other than to be stored in the item. If the item can't hold the spell, the spell is expended without effect. The level of the slot used to cast the spell determines how much space it uses. While carrying this item, you can cast any spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell cast from the item is no longer stored in it, freeing up space.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Spell Storing, Greater",
      type: "Suffix",
      description:
        "This item can store up to 5 levels worth of spells cast into it. Any creature can cast a spell of 1st through 5th level into the item by touching the item as the spell is cast. The spell has no effect, other than to be stored in the item. If the item can't hold the spell, the spell is expended without effect. The level of the slot used to cast the spell determines how much space it uses. While carrying this item, you can cast any spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell cast from the item is no longer stored in it, freeing up space.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Spell Turning",
      type: "Suffix",
      description:
        "When you make a saving throw against a spell that targets only you while carrying this item, you can choose to make the saving throw with advantage. If the saving throw succeeds and the spell is 3rd level or lower, the spell has no effect on you and instead targets the caster, using the slot level, spell save DC, attack bonus, and spellcasting ability of the caster. If the spell requires concentration, it lasts until the end of the caster's next turn, even if they choose not to maintain their concentration on it. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Spell Turning, Greater",
      type: "Suffix",
      description:
        "When you make a saving throw against a spell that targets only you while carrying this item, you can choose to make the saving throw with advantage. If the saving throw succeeds and the spell is 7th level or lower, the spell has no effect on you and instead targets the caster, using the slot level, spell save DC, attack bonus, and spellcasting ability of the caster. If the spell requires concentration, it lasts until the end of the caster's next turn, even if they choose not to maintain their concentration on it. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Spellbreaker",
      type: "Suffix",
      description:
        "When you hit with an attack using this weapon (or harmlessly touch the weapon to a target), you can choose to end any spells of 3rd level or lower on the target. For each spell of 4th level or higher on the target, make an ability check using the ability modifier you use when attacking with the weapon. The DC equals 10 + the spell's level. On a successful check, the spell ends. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Spellbreaker, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you hit with an attack using this weapon (or harmlessly touch the weapon to a target), you can expend 1 charge to end any spells of 3rd level or lower on the target. For each spell of 4th level or higher on the target, make an ability check using the ability modifier you use when attacking with the weapon. The DC equals 10 + the spell's level. On a successful check, the spell ends. The weapon regains all expended charges daily at dawn",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Steady",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on ability checks and saving throws made to avoid being shoved back, knocked prone, or losing your balance.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Steady, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on ability checks and saving throws made to avoid being shoved back, knocked prone, or losing your balance. In addition, if an effect moves you against your will along the ground, you can use your reaction to reduce the distance you are moved by up to 30 feet.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Stone",
      type: "Prefix",
      description:
        "While carrying this item, you can use an action to become petrified until the start of your next turn.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Stone, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action to become petrified until the start of your next turn.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Striking Lightning",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When a creature you can see makes an attack against you or you make a Dexterity saving throw, you can expend 1 charge to give the creature disadvantage on its attack roll or give yourself advantage on the Dexterity saving throw.\n&#8226; You can expend 3 charges to cast <i>storm sphere</i> (save DC 13).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Striking Lightning, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects:\n&#8226; When a creature you can see makes an attack against you or you make a Dexterity saving throw, you can expend 1 charge to give the creature disadvantage on its attack roll or give yourself advantage on the Dexterity saving throw.\n&#8226; You can expend its charges as an action to cast one of the following spells (save DC 15): <i>storm sphere</i> (3 charges) or <i>chain lightning</i> (5 charges).\nIf the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Studious",
      type: "Common",
      description:
        "While carrying this item, you can read twice as fast as you usually would be able to and have advantage on Intelligence checks made to recall information.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Swarm",
      type: "Suffix",
      description:
        "While carrying this weapon, you can use an action to make a ranged attack against up to six creatures within 30 feet of a point you can see within the weapon's range. You make a separate attack roll for each target. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Swarm, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying this weapon, you can use an action and expend 1 of its charges to make a ranged attack against up to six creatures within 30 feet of a point you can see within the weapon's range. You make a separate attack roll for each target. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Ranged",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Swift",
      type: "Prefix",
      description:
        "You can make one attack with disadvantage with this weapon as a bonus action on each of your turns.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Swift, Greater",
      type: "Prefix",
      description:
        "You can make one attack with this weapon as a bonus action on each of your turns.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Sylvan",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on saving throws against being charmed and magic can't put you to sleep.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Sylvan, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you are immune to being charmed and magic can't put you to sleep.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Symbol",
      type: "Common",
      description: "This item also functions as a spellcasting focus.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Temperate",
      type: "Common",
      description:
        "While carrying this item, you suffer no harm in temperatures as cold -20\u00B0 Fahrenheit or as warm as 120\u00B0 Fahrenheit.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Tempest Cleric's",
      type: "Class",
      description:
        "While you carry this item, any creature you deal damage to using your Channel Divinity: Destructive Wrath must also succeed on a Constitution saving throw against your spell save DC or be incapacitated until the end of its next turn. ",
      rarity: 1,
      attunement: "Requires attunement by a Tempest cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Tempest Cleric's, Greater",
      type: "Class",
      description:
        "While you carry this item, any creature you deal damage to using your Channel Divinity: Destructive Wrath must also succeed on a Constitution saving throw against your spell save DC or be stunned until the end of its next turn. ",
      rarity: 2,
      attunement: "Requires attunement by a Tempest cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Terror",
      type: "Suffix",
      description:
        "While carrying this item, you can use an action to release a wave of terror. Each creature of your choice in a 30-foot radius extending from you must succeed on a DC 13 Wisdom saving throw or become frightened of you for 1 minute. While it is frightened in this way, a creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If it has nowhere it can move, the creature can use the Dodge action. At the end of each of its turns, a creature can repeat the saving throw, ending the effect on itself on a success. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Terror, Greater",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as an action to release a wave of terror. Each creature of your choice in a 30-foot radius extending from you must succeed on a DC 15 Wisdom saving throw or become frightened of you for 1 minute. While it is frightened in this way, a creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If it has nowhere it can move, the creature can use the Dodge action. At the end of each of its turns, a creature can repeat the saving throw, ending the effect on itself on a success. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Thaumaturgy",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>thaumaturgy</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Thief's",
      type: "Prefix",
      description:
        "While carrying this weapon, you can use a bonus action to make a Dexterity (Sleight of Hand) check against the passive Perception of a creature within 30 feet that can see you. On a success, you have advantage on the next attack you make with this weapon against that creature until the end of your turn. This property can't be used against the same creature until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Thief's, Greater",
      type: "Prefix",
      description:
        "While carrying this weapon, you have advantage on Sleight of Hand checks. In addition, while carrying this weapon, you can use a bonus action to make a Dexterity (Sleight of Hand) check against the passive Perception of a creature within 30 feet that can see you. On a success, you have advantage on the next attack you make with this weapon against that creature until the end of your turn. This property can't be used against the same creature until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Thorns",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 13): <i>hail of thorns</i> (1 charge) or <i>spike growth</i> (2 charges). The weapon regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Thorns, Greater",
      type: "Suffix",
      description:
        "This weapon has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 15): <i>hail of thorns</i> (1 charge), <i>spike growth</i> (2 charges), or <i>wrath of nature</i> (3 charges). The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Thrower's",
      type: "Prefix",
      description:
        "This weapon has the thrown property with a normal range of 20 feet and a long range of 60 feet. When you make a ranged attack with this weapon, the weapon flies back to your hand immediately after the attack.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Thrower's, Greater",
      type: "Prefix",
      description:
        "This weapon has the thrown property with a normal range of 20 feet and a long range of 60 feet. When you hit with a ranged attack using this weapon, it deals an extra 1d6 damage of the weapon's type. Immediately after the attack, the weapon flies back to your hand.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Melee",
      wondrous: "No",
    },
    {
      name: "Thunder",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 13): <i>thunderwave</i> (1 charge) or <i>shatter</i> (2 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Thunder, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast one of the following spells (save DC 15): <i>thunderwave</i> (1 charge), <i>shatter</i> (2 charges), or <i>thunder step</i> (3 charges). The spells are cast at the lowest possible level, but you can increase the spell slot level by one for each additional charge you expend. The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Totem Barbarian's",
      type: "Class",
      description:
        "While carrying this item, you can spend ten minutes in quiet meditation to change your choice of totem spirit and feature gained from either Totem Spirit, Aspect of the Beast, or Totemic Attunement.",
      rarity: 1,
      attunement: "Requires attunement by a Totem barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Totem Barbarian's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can spend an action to change your choice of totem spirit and feature gained from either Totem Spirit, Aspect of the Beast, or Totemic Attunement.",
      rarity: 2,
      attunement: "Requires attunement by a Totem barbarian",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Trainer's",
      type: "Prefix",
      description:
        "When you hit a beast or monstrosity that has an Intelligence score of 5 or less with this weapon, the creature must succeed on a DC 13 Wisdom saving throw or become frightened of you until the end of your next turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Trainer's, Greater",
      type: "Prefix",
      description:
        "While carrying this weapon, you have advantage on Animal Handling checks. In addition, When you hit a beast or monstrosity that has an Intelligence score of 5 or less with this weapon, the creature must succeed on a DC 15 Wisdom saving throw or become frightened of you until the end of your next turn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Tranquility",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, you have disadvantage on Initiative rolls and Dexterity saving throws.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Transformation",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, your physical appearance magically transforms to become more like the creature that crafted it (chosen by the DM). At the end of each long rest, you lose one of your racial traits, and instead gain one of that creature's racial traits (chosen by the DM). When all your original racial traits have been replaced, or you have gained all the creature's racial traits, the transformation is complete, and you lose all your original racial traits, gain all the creature's racial traits, and are considered a creature of that type.",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Trickery Cleric's",
      type: "Class",
      description:
        "While carrying this item, you can choose to have any creature that makes an attack against you while you are within 5 feet of the illusion created by your Channel Divinity: Invoke Duplicity roll a d20. On a roll of 11–20, the attacker hits your illusion instead of you.",
      rarity: 1,
      attunement: "Requires attunement by a Trickery cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Trickery Cleric's, Greater",
      type: "Class",
      description:
        "While carrying this item, you can choose to have any creature that makes an attack against you while you are within 5 feet of the illusion created by your Channel Divinity: Invoke Duplicity roll a d20. On a roll of 11–20, the attacker hits your illusion instead of you. In addition, you no longer need to concentrate when using your Channel Divinity: Invoke Duplicity.",
      rarity: 2,
      attunement: "Requires attunement by a Trickery cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Troll's",
      type: "Prefix",
      description:
        "While carrying this item, you gain 5 temporary hit points at the start of each of your turns. You don't gain this benefit if you have taken acid or fire damage since the end of your last turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Troll's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you gain 10 temporary hit points at the start of each of your turns. You don't gain this benefit if you have taken acid or fire damage since the end of your last turn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "True Strikes",
      type: "Suffix",
      description:
        "When you make an attack roll using this weapon, you can choose to gain a +10 bonus to the roll. You make this choice after you see the roll, but before the DM says whether the attack hits or misses. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "True Strikes, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you make an attack roll using this weapon, you can expend 1 charge to gain a +10 bonus to the roll. You make this choice after you see the roll, but before the DM says whether the attack hits or misses. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Unbreakable",
      type: "Common",
      description:
        "This item can't be broken. Special means must be used to destroy it.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Undying",
      type: "Suffix",
      description:
        "While you are carrying this item and damage reduces you to 0 hit points, you can choose to remain conscious instead. You still must make death saving throws, and you suffer the normal effects of taking damage while at 0 hit points. If you still have 0 hit points at the end of your next turn, you fall unconscious. This effect ends if you regain hit points. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Undying, Greater",
      type: "Suffix",
      description:
        "While you are carrying this item and damage reduces you to 0 hit points, you can choose to remain conscious instead. You still must make death saving throws, and you suffer the normal effects of taking damage while at 0 hit points. However, if you would die due to failing death saving throws, you don't die until the end of your next turn, and you die only if you still have 0 hit points. This effect ends if you regain hit points. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Unholy",
      type: "Prefix",
      description:
        "While carrying this item, undead that have an Intelligence score of 7 or lower won't threaten or harm you unless you harm them.",
      rarity: 1,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Unholy, Greater",
      type: "Prefix",
      description:
        "While carrying this item, undead that have an Intelligence score of 7 or lower won't threaten or harm you unless you harm them. In addition, when damage reduces you to 0 hit points while carrying this item, you can make a Constitution saving throw with a DC of 10 + the damage taken, unless the damage is radiant or from a critical hit. On a success, you instead drop to 1 hit point.",
      rarity: 2,
      attunement: "No",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Unicorn's",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action to create a shimmering, magical field around yourself or another creature you can see within 30 feet of you. The target gains a +1 bonus to AC until the end of your next turn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Unicorn's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you can use a bonus action to create a shimmering, magical field around yourself or another creature you can see within 30 feet of you. The target gains a +2 bonus to AC until the end of your next turn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Untamed Force",
      type: "Suffix",
      description:
        "This weapon can hold up to 3 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects: When you are hit by an attack, you can expend 1 or more of its charges to roll a d4 and add the result + the number of charges expended to your AC against that attack, or you can expend 3 charges as an action to cast <i>resilient sphere</i> (save DC 13). If the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Untamed Force, Greater",
      type: "Suffix",
      description:
        "This weapon can hold up to 5 charges. Once per turn, when you hit a hostile creature with this weapon, it gains 1 charge. While carrying the weapon, you can expend the weapon's charges to cause the following effects: When you are hit by an attack, you can expend 1 or more of its charges to roll a d4 and add the result + the number of charges expended to your AC against that attack, or you can expend its charges as an action to cast one of the following spells (+7 to hit, save DC 15): <i>resilient sphere</i> (3 charges) or <i>steel wind strike</i> (5 charges). If the weapon hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Valor Bard's",
      type: "Class",
      description:
        "When a creature rolls a Bardic Inspiration die to increase the damage of a weapon attack using your Combat Inspiration while you carry this item, the creature adds twice the number rolled to the weapon damage roll. ",
      rarity: 1,
      attunement: "Requires attunement by a Valor bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Valor Bard's, Greater",
      type: "Class",
      description:
        "When a creature rolls a Bardic Inspiration die to increase the damage of a weapon attack using your Combat Inspiration while you carry this item, the creature adds twice the number rolled + your Charisma modifier to the weapon damage roll.",
      rarity: 2,
      attunement: "Requires attunement by a Valor bard",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Vanguard",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 charge as a bonus action to cast <i>compelled duel</i> (save DC 13) or as an action to cast <i>protection from evil and good</i>. The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Vanguard, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>compelled duel</i> (1 charge, save DC 15) or as an action to cast <i>protection from evil and good</i> (1 charge) or <i>compulsion</i> (4 charges, save DC 15). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Vengeance Paladin's",
      type: "Class",
      description:
        "When you hit a creature affected by your Channel Divinity: Vow of Enmity while carrying this item, you deal additional damage of the weapon's type equal to your Charisma modifier (minimum of +1).",
      rarity: 1,
      attunement: "Requires attunement by a Vengeance paladin",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Vengeance Paladin's, Greater",
      type: "Class",
      description:
        "When you hit a creature affected by your Channel Divinity: Vow of Enmity while carrying this item, you deal additional damage of the weapon's type equal to your Charisma modifier (minimum of +1). In addition, the creature has disadvantage on saving throws against spells you cast and effects you create.",
      rarity: 2,
      attunement: "Requires attunement by a Vengeance paladin",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Vengeance",
      type: "Suffix",
      description:
        "When you use this weapon to make an attack, you can speak the weapon's command word. The target of your attack becomes your sworn enemy until it dies or until dawn seven days later. You can have only one such sworn enemy at a time. When your sworn enemy dies, you can choose a new one after the next dawn. When you make an attack roll with this weapon against your sworn enemy, you have advantage on the roll. While your sworn enemy lives, you have disadvantage on attack rolls with this weapon against all other creatures.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Vengeance, Greater",
      type: "Suffix",
      description:
        "When you use this weapon to make an attack, you can speak the weapon's command word. The target of your attack becomes your sworn enemy until it dies or until dawn seven days later. You can have only one such sworn enemy at a time. When your sworn enemy dies, you can choose a new one after the next dawn. When you make an attack roll with this weapon against your sworn enemy, you have advantage on the roll. If the attack hits, your sworn enemy takes an extra 1d6 damage of the weapon's type. While your sworn enemy lives, you have disadvantage on attack rolls with this weapon against all other creatures.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Venom",
      type: "Suffix",
      description:
        "While carrying this weapon, you can use an action to coat its edge or a piece of ammunition fired from it with serpent venom (see Dungeon Master's Guide p. 258). The poison remains for 1 minute or until an attack using this weapon hits a creature. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "PiercingSlashing",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Venom, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can use an action and expend 1 or more of its charges to cause one of the following poisons (see Dungeon Master's Guide p. 258) to coat its edge or a piece of ammunition fired from it: serpent venom (1 charge), drow poison (2 charges), or wyvern poison (3 charges). The poison remains for 1 minute or until an attack using this weapon hits a creature. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "PiercingSlashing",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Vicious",
      type: "Prefix",
      description:
        "When you roll a 20 on your attack roll with this weapon, the target takes an extra 10 damage of the weapon's type.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Vicious, Greater",
      type: "Prefix",
      description:
        "When you roll a 20 on your attack roll with this weapon, the target takes an extra 10 damage of the weapon's type, and you can immediately make another weapon attack with this weapon against the same target.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Vulnerability",
      type: "Curse",
      description:
        "When you attune to this magic item, you become cursed until the curse is broken with a <i>remove curse</i> spell or similar magic. You can't voluntarily end your attunement to the item unless the curse is broken first. While cursed, you have vulnerability to a damage type (chosen by the DM or rolled on the Damage Types table).",
      rarity: 0,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Wailing",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 13 Constitution saving throw. On a failure, it takes 2d6 psychic damage and is stunned until the end of your next turn. On a success, it takes only half as much damage and isn't stunned. This property has no effect on constructs and undead.",
      rarity: 1,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Wailing, Greater",
      type: "Prefix",
      description:
        "When you attack a creature with this weapon and roll a 20 on the attack roll, the creature must make a DC 15 Constitution saving throw. On a failure, it takes 4d6 psychic damage and is stunned until the end of your next turn. On a success, it takes only half as much damage and isn't stunned. This property has no effect on constructs and undead.",
      rarity: 2,
      attunement: "No",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Wakeful",
      type: "Common",
      description:
        "As an action, you can say this item's command word and choose a time in the future. At that time, the item emits a high-pitched screeching for a few seconds, after which it becomes silent again.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "War Caster's",
      type: "Prefix",
      description:
        "When you cast a spell of 1st level or higher while carrying this item, you gain a +1 bonus to AC and all saving throws until the end of your next turn or until you cast another spell of 1st level or higher.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "War Caster's, Greater",
      type: "Prefix",
      description:
        "When you cast a spell of 1st level or higher while carrying this item, you gain a +2 bonus to AC and all saving throws until the end of your next turn or until you cast another spell of 1st level or higher.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "War Cleric's",
      type: "Class",
      description:
        "When you use your Channel Divinity: Guided Strike to give yourself a +10 bonus to the attack roll of a weapon attack while carrying this item, you also deal additional damage of the weapon's type equal to your Wisdom modifier on a hit.",
      rarity: 1,
      attunement: "Requires attunement by a War cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "War Cleric's, Greater",
      type: "Class",
      description:
        "While carrying this item, when you use your Channel Divinity: Guided Strike to give yourself a +10 bonus to the attack roll of a weapon attack while carrying this item, you also deal additional damage of the weapon's type equal to half your cleric level (rounded down) + your Wisdom modifier on a hit.",
      rarity: 2,
      attunement: "Requires attunement by a War cleric",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "War Leader",
      type: "Common",
      description:
        "While carrying this item, you can use an action to cause your voice to carry clearly for up to 300 feet until the end of your next turn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "War Mage's",
      type: "Prefix",
      description:
        "When you cast a spell while carrying this weapon, it becomes charged with arcane energy. The next time you hit a target with an attack made with this weapon before the end of your next turn, the target takes an extra 1d6 force damage.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "War Mage's, Greater",
      type: "Prefix",
      description:
        "When you cast a spell while carrying this weapon, it becomes charged with arcane energy. The next time you hit a target with an attack made with this weapon before the end of your next turn, the target takes an extra 2d6 force damage.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Warding",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>sanctuary</i> (1 charge) or as an action to cast <i>warding bond</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Warding, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>sanctuary</i> (1 charge) or as an action to cast <i>warding bond</i> (2 charges) or <i>death ward</i> (4 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
      ofthe: "of",
    },
    {
      name: "Warning",
      type: "Common",
      description:
        "This item is created to warn against a particular type of creature, either aberrations, beasts, celestials, constructs, dragons, elementals, fey, fiends, giants, monstrosities, oozes, plants, undead, or a race of humanoid, such as orcs or elves. When a creature of that type is within 120 feet of this item, the item glows with a dull, red light.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Warrior's",
      type: "Prefix",
      description:
        "When you hit a creature with an attack using this weapon, you can use a bonus action to wound the target. At the start of each of the wounded creature's turns, it takes 1d4 necrotic damage for each time you've wounded it, and it can then make a DC 13 Constitution saving throw, ending the effect of all such wounds on itself on a success. Alternatively, the wounded creature, or a creature within 5 feet of it, can use an action to make a DC 13 Wisdom (Medicine) check, ending the effect of such wounds on it on a success.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Warrior's, Greater",
      type: "Prefix",
      description:
        "When you hit a creature with an attack using this weapon, you can wound the target. At the start of each of the wounded creature's turns, it takes 1d4 necrotic damage for each time you've wounded it, and it can then make a DC 15 Constitution saving throw, ending the effect of all such wounds on itself on a success. Alternatively, the wounded creature, or a creature within 5 feet of it, can use an action to make a DC 15 Wisdom (Medicine) check, ending the effect of such wounds on it on a success.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
    },
    {
      name: "Watcher's",
      type: "Prefix",
      description: "While carrying this item, you can't be surprised.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Watcher's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have advantage on initiative rolls and you can't be surprised.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Waterborne",
      type: "Common",
      description:
        "This item floats on water and other liquids. While carrying it, you have advantage on Strength (Athletics) checks to swim.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Weave",
      type: "Suffix",
      description:
        "This item has 3 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>detect magic</i> (1 charge), <i>magic missile</i> (1 charge per spell level), or <i>arcanist's magic aura</i> (2 charges). The item regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Weave, Greater",
      type: "Suffix",
      description:
        "This item has 5 charges. While carrying it, you can expend 1 or more of its charges as an action to cast <i>detect magic</i> (1 charge), <i>magic missile</i> (1 charge per spell level), <i>arcanist's magic aura</i> (2 charges), or <i>arcane hand</i> (5 charges). The item regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "Any",
      ofthe: "of the",
    },
    {
      name: "Whispers",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>message</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Wicked",
      type: "Common",
      description:
        "When you are presented with an opportunity to act in a selfish or malevolent way while carrying this magic item, it heightens your urge to do so.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Wight's",
      type: "Prefix",
      description:
        "While carrying this item, your hit point maximum can't be reduced.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Wight's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have resistance to necrotic damage and your hit point maximum can't be reduced.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Wind Wall",
      type: "Suffix",
      description:
        "This armor has 3 charges. While wearing it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 13): <i>gust of wind</i> (1 charge) or <i>warding wind</i> (2 charges). The armor regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Wind Wall, Greater",
      type: "Suffix",
      description:
        "This armor has 5 charges. While wearing it, you can expend 1 or more of its charges as an action to cast one of the following spells (spell save DC 15): <i>gust of wind</i> (1 charge), <i>warding wind</i> (2 charges), or <i>wind wall</i> (3 charges). The armor regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "Any",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Wind",
      type: "Common",
      description:
        "While carrying this item, you can cast <i>gust</i>. Once used, this property can't be used again until the next dawn.",
      rarity: 0,
      attunement: "No",
      armor: "Any",
      weapon: "Any",
      wondrous: "Any",
    },
    {
      name: "Wings",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to speak its command word. Wings sprout from the armor and remain for 10 minutes or until you speak its command word as an action. The wings give you a flying speed of 60 feet. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "NonShield",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Wings, Greater",
      type: "Suffix",
      description:
        "While wearing this armor, you can use an action to speak its command word. Wings sprout from the armor and remain for 1 hour or until you speak its command word as an action. The wings give you a flying speed of 60 feet. Once used, this property can't be used again until the next dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "NonShield",
      weapon: "No",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Withering",
      type: "Suffix",
      description:
        "When you hit on an attack using this weapon, you can choose to deal an extra 1d10 necrotic damage to the target. In addition, the target must succeed on a DC 13 Constitution saving throw or the target deals only half damage with weapon attacks that use Strength for 1 minute. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. Once used, this property can't be used again until the next dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Withering, Greater",
      type: "Suffix",
      description:
        "This weapon has 3 charges. When you hit on an attack using this weapon, you can expend 1 charge to deal an extra 1d10 necrotic damage to the target. In addition, the target must succeed on a DC 15 Constitution saving throw or the target deals only half damage with weapon attacks that use Strength for 1 minute. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of",
    },
    {
      name: "Worm's",
      type: "Prefix",
      description:
        "While carrying this item, you have tremorsense out to a range of 30 feet.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Worm's, Greater",
      type: "Prefix",
      description:
        "While carrying this item, you have tremorsense out to a range of 60 feet.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "No",
      wondrous: "Any",
    },
    {
      name: "Zephyr",
      type: "Suffix",
      description:
        "This weapon has 3 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>zephyr strike</i> (1 charge) or an action to cast <i>warding wind</i> (2 charges). The weapon regains all expended charges daily at dawn.",
      rarity: 1,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
    {
      name: "Zephyr, Greater",
      type: "Suffix",
      description:
        "This weapon has 5 charges. While carrying it, you can expend 1 or more of its charges as a bonus action to cast <i>zephyr strike</i> (1 charge) or an action to cast <i>warding wind</i> (2 charges) or <i>control winds</i> (5 charges, save DC 15). The weapon regains all expended charges daily at dawn.",
      rarity: 2,
      attunement: "Requires attunement",
      armor: "No",
      weapon: "Any",
      wondrous: "No",
      ofthe: "of the",
    },
  ],
  itemsSRD: [
    {
      name: "Adamantine Armor",
      type: "Armor",
      subtype: "Medium or heavy",
      description:
        "This suit of armor is reinforced with adamantine, one of the hardest substances in existence. While you're wearing it, any critical hit against you becomes a normal hit.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Amulet of Health",
      type: "Wondrous item",
      description:
        "Your Constitution score is 19 while you wear this amulet. It has no effect on you if your Constitution is already 19 or higher.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Amulet of Proof against Detection and Location",
      type: "Wondrous item",
      description:
        "While wearing this amulet, you are hidden from divination magic. You can't be targeted by such magic or perceived through magical scrying sensors.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Amulet of the Planes",
      type: "Wondrous item",
      description:
        "While wearing this amulet, you can use an action to name a location that you are familiar with on another plane of existence. Then make a DC 15 Intelligence check. On a successful check, you cast the <i>plane shift</i> spell. On a failure, you and each creature and object within 15 feet of you travel to a random destination. Roll a d100. On a 1-60, you travel to a random location on the plane you named. On a 61-100, you travel to a randomly determined plane of existence.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Animated Shield",
      type: "Armor",
      subtype: "Shield",
      description:
        "While holding this shield, you can speak its command word as a bonus action to cause it to animate. The shield leaps into the air and hovers in your space to protect you as if you were wielding it, leaving your hands free. The shield remains animated for 1 minute, until you use a bonus action to end this effect, or until you are incapacitated or die, at which point the shield falls to the ground or into your hand if you have one free.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Apparatus of the Crab",
      type: "Wondrous item",
      description:
        "This item first appears to be a Large sealed iron barrel weighing 500 pounds. The barrel has a hidden catch, which can be found with a successful DC 20 Intelligence (Investigation) check. Releasing the catch unlocks a hatch at one end of the barrel, allowing two Medium or smaller creatures to crawl inside. Ten levers are set in a row at the far end, each in a neutral position, able to move either up or down. When certain levers are used, the apparatus transforms to resemble a giant lobster. \nFor a full description of the Apparatus of the Crab, see pg. 208 of the SRD 5.1.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Armor +1",
      type: "Armor",
      subtype: "Any",
      description: "You have a +1 bonus to AC while wearing this armor.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Armor +2",
      type: "Armor",
      subtype: "Any",
      description: "You have a +2 bonus to AC while wearing this armor.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Armor +3",
      type: "Armor",
      subtype: "Any",
      description: "You have a +3 bonus to AC while wearing this armor.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Armor of Invulnerability",
      type: "Armor",
      subtype: "Plate",
      description:
        "You have resistance to nonmagical damage while you wear this armor. Additionally, you can use an action to make yourself immune to nonmagical damage for 10 minutes or until you are no longer wearing the armor. Once this special action is used, it can't be used again until the next dawn.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Armor of Resistance",
      type: "Armor",
      subtype: "Light, Medium, or Heavy",
      description:
        "You have resistance to [option] damage while you wear this armor.",
      rarity: "Rare",
      attunement: "Requires attunement",
      optionName: "Resistance:",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Armor of Vulnerability",
      type: "Armor",
      subtype: "Plate",
      description:
        "While wearing this armor, you have resistance to [option] damage.\n<b><i>Curse</i></b>. This armor is cursed, a fact that is revealed only when an <i>identify</i> spell is cast on the armor or you attune to it. Attuning to the armor curses you until you are targeted by the <i>remove curse</i> spell or similar magic; removing the armor fails to end the curse. While cursed, you have vulnerability to two of the three damage types associated with the armor (not the one to which it grants resistance).",
      rarity: "Rare",
      attunement: "Requires attunement",
      optionName: "Resistance:",
      options: [
        [
          { name: "Bludgeoning", value: "bludgeoning" },
          { name: "Piercing", value: "piercing" },
          { name: "Slashing", value: "slashing" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Arrow-Catching Shield",
      type: "Armor",
      subtype: "Shield",
      description:
        "You gain a +2 bonus to AC against ranged attacks while you wield this shield. This bonus is in addition to the shield's normal bonus to AC. In addition, whenever an attacker makes a ranged attack against a target within 5 feet of you, you can use your reaction to become the target of the attack instead.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Arrow of Slaying",
      type: "Weapon",
      subtype: "Arrow",
      description:
        "An <i>arrow of slaying</i> is a magic weapon meant to slay a particular kind of creature. Some are more focused than others; for example, there are both <i>arrows of dragon slaying</i> and <i>arrows of blue dragon slaying</i>. If a creature belonging to the type, race, or group associated with an <i>arrow of slaying</i> takes damage from the arrow, the creature must make a DC 17 Constitution saving throw, taking an extra 6d10 piercing damage on a failed save, or half as much extra damage on a successful one.\nOnce an <i>arrow of slaying</i> deals its extra damage to a creature, it becomes a nonmagical arrow.\nOther types of magic ammunition of this kind exist, such as <i>bolts of slaying</i> meant for a crossbow, though arrows are most common.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Beans",
      type: "Wondrous item",
      description:
        "Inside this heavy cloth bag are 3d4 dry beans. The bag weighs 1/2 pound plus 1/4 pound for each bean it contains.\nIf you dump the bag's contents out on the ground, they explode in a 10-foot radius, extending from the beans. Each creature in the area, including you, must make a DC 15 Dexterity saving throw, taking 5d4 fire damage on a failed save, or half as much damage on a successful one. The fire ignites flammable objects in the area that aren't being worn or carried.\nIf you remove a bean from the bag, plant it in dirt or sand, and then water it, the bean produces an effect 1 minute later from the ground where it was planted. For a full list of the beans' effects, see page 209 of the 5E SRD 5.1.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Devouring",
      type: "Wondrous item",
      description:
        "This bag superficially resembles a <i>bag of holding</i> but is a feeding orifice for a gigantic extradimensional creature. Turning the bag inside out closes the orifice.\nThe extradimensional creature attached to the bag can sense whatever is placed inside the bag. Animal or vegetable matter placed wholly in the bag is devoured and lost forever. When part of a living creature is placed in the bag, as happens when someone reaches inside it, there is a 50 percent chance that the creature is pulled inside the bag. A creature inside the bag can use its action to try to escape with a successful DC 15 Strength check. Another creature can use its action to reach into the bag to pull a creature out, doing so with a successful DC 20 Strength check (provided it isn't pulled inside the bag first). Any creature that starts its turn inside the bag is devoured, its body destroyed.\nInanimate objects can be stored in the bag, which can hold a cubic foot of such material. However, once each day, the bag swallows any objects inside it and spits them out into another plane of existence. The GM determines the time and plane.\nIf the bag is pierced or torn, it is destroyed, and anything contained within it is transported to a random location on the Astral Plane.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Holding",
      type: "Wondrous item",
      description:
        "This bag has an interior space considerably larger than its outside dimensions, roughly 2 feet in diameter at the mouth and 4 feet deep. The bag can hold up to 500 pounds, not exceeding a volume of 64 cubic feet. The bag weighs 15 pounds, regardless of its contents. Retrieving an item from the bag requires an action.\nIf the bag is overloaded, pierced, or torn, it ruptures and is destroyed, and its contents are scattered in the Astral Plane. If the bag is turned inside out, its contents spill forth, unharmed, but the bag must be put right before it can be used again. Breathing creatures inside the bag can survive up to a number of minutes equal to 10 divided by the number of creatures (minimum 1 minute), after which time they begin to suffocate.\nPlacing a <i>bag of holding</i> inside an extradimensional space created by a <i>handy haversack</i>, <i>portable hole</i>, or similar item instantly destroys both items and opens a gate to the Astral Plane. The gate originates where the one item was placed inside the other. Any creature within 10 feet of the gate is sucked through it to a random location on the Astral Plane. The gate then closes. The gate is one-way only and can't be reopened.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Tricks (gray)",
      type: "Wondrous item",
      description:
        "This ordinary bag, made from gray cloth, appears empty. Reaching inside the bag, however, reveals the presence of a small, fuzzy object. The bag weighs 1/2 pound.\nYou can use an action to pull the fuzzy object from the bag and throw it up to 20 feet. When the object lands, it transforms into a creature you determine by rolling a d8 (1. Weasel; 2. Giant Rat; 3. Badger; 4. Boar; 5. Panther; 6. Giant Badger; 7. Dire Wolf; 8. Giant Elk).\nThe creature is friendly to you and your companions, and it acts on your turn. You can use a bonus action to command how the creature moves and what action it takes on its next turn, or to give it general orders, such as to attack your enemies. In the absence of such orders, the creature acts in a fashion appropriate to its nature.\nOnce three fuzzy objects have been pulled from the bag, the bag can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Tricks (rust)",
      type: "Wondrous item",
      description:
        "This ordinary bag, made from rust cloth, appears empty. Reaching inside the bag, however, reveals the presence of a small, fuzzy object. The bag weighs 1/2 pound.\nYou can use an action to pull the fuzzy object from the bag and throw it up to 20 feet. When the object lands, it transforms into a creature you determine by rolling a d8 (1. Rat; 2. Owl; 3. Mastiff; 4. Goat; 5. Giant goat; 6. Giant Boar; 7. Lion; 8. Brown Bear).\nThe creature is friendly to you and your companions, and it acts on your turn. You can use a bonus action to command how the creature moves and what action it takes on its next turn, or to give it general orders, such as to attack your enemies. In the absence of such orders, the creature acts in a fashion appropriate to its nature.\nOnce three fuzzy objects have been pulled from the bag, the bag can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bag of Tricks (tan)",
      type: "Wondrous item",
      description:
        "This ordinary bag, made from tan cloth, appears empty. Reaching inside the bag, however, reveals the presence of a small, fuzzy object. The bag weighs 1/2 pound.\nYou can use an action to pull the fuzzy object from the bag and throw it up to 20 feet. When the object lands, it transforms into a creature you determine by rolling a d8 (1. Jackal; 2. Ape; 3. Baboon; 4. Axe Beak; 5. Black Bear; 6. Giant Weasel; 7. Giant Hyena; 8. Tiger).\nThe creature is friendly to you and your companions, and it acts on your turn. You can use a bonus action to command how the creature moves and what action it takes on its next turn, or to give it general orders, such as to attack your enemies. In the absence of such orders, the creature acts in a fashion appropriate to its nature.\nOnce three fuzzy objects have been pulled from the bag, the bag can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bead of Force",
      type: "Wondrous item",
      description:
        "This small black sphere measures 3/4 of an inch in diameter and weighs an ounce. Typically, 1d4 + 4 <i>beads of force</i> are found together.\nYou can use an action to throw the bead up to 60 feet. The bead explodes on impact and is destroyed. Each creature within a 10-foot radius of where the bead landed must succeed on a DC 15 Dexterity saving throw or take 5d4 force damage. A sphere of transparent force then encloses the area for 1 minute. Any creature that failed the save and is completely within the area is trapped inside this sphere. Creatures that succeeded on the save, or are partially within the area, are pushed away from the center of the sphere until they are no longer inside it. Only breathable air can pass through the sphere's wall. No attack or other effect can.\nAn enclosed creature can use its action to push against the sphere's wall, moving the sphere up to half the creature's walking speed. The sphere can be picked up, and its magic causes it to weigh only 1 pound, regardless of the weight of creatures inside.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Belt of Dwarvenkind",
      type: "Wondrous item",
      description:
        "While wearing this belt, you gain the following benefits:\n&#8226; Your Constitution score increases by 2, to a maximum of 20.\n&#8226; You have advantage on Charisma (Persuasion) checks made to interact with dwarves.\nIn addition, while attuned to the belt, you have a 50 percent chance each day at dawn of growing a full beard if you're capable of growing one, or a visibly thicker beard if you already have one.\nIf you aren't a dwarf, you gain the following additional benefits while wearing the belt:\n&#8226; You have advantage on saving throws against poison, and you have resistance against poison damage.\n&#8226; You have darkvision out to a range of 60 feet.\n&#8226; You can speak, read, and write Dwarvish.</p>",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Hill Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 21. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Stone Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 23. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Frost Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 23. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Fire Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 25. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Cloud Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 27. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Belt of Storm Giant Strength",
      type: "Wondrous item",
      description:
        "While wearing this belt, your Strength score changes to 29. If your Strength is already equal to or greater than the belt's score, the item has no effect on you.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Berserker Axe",
      type: "Weapon",
      subtype: "Any axe",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic weapon. In addition, while you are attuned to this weapon, your hit point maximum increases by 1 for each level you have attained.\n<b><i>Curse</i></b>. This axe is cursed, and becoming attuned to it extends the curse to you. As long as you remain cursed, you are unwilling to part with the axe, keeping it within reach at all times. You also have disadvantage on attack rolls with weapons other than this one, unless no foe is within 60 feet of you that you can see or hear.\nWhenever a hostile creature damages you while the axe is in your possession, you must succeed on a DC 15 Wisdom saving throw or go berserk. While berserk, you must use your action each round to attack the creature nearest to you with the axe. If you can make extra attacks as part of the Attack action, you use those extra attacks, moving to attack the next nearest creature after you fell your current target. If you have multiple possible targets, you attack one at random. You are berserk until you start your turn with no creatures within 60 feet of you that you can see or hear.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Boots of Elvenkind",
      type: "Wondrous item",
      description:
        "While you wear these boots, your steps make no sound, regardless of the surface you are moving across. You also have advantage on Dexterity (Stealth) checks that rely on moving silently.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Boots of Levitation",
      type: "Wondrous item",
      description:
        "While you wear these boots, you can use an action to cast the <i>levitate</i> spell on yourself at will.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Boots of Speed",
      type: "Wondrous item",
      description:
        "While you wear these boots, you can use a bonus action and click the boots' heels together. If you do, the boots double your walking speed, and any creature that makes an opportunity attack against you has disadvantage on the attack roll. If you click your heels together again, you end the effect.\nWhen the boots' property has been used for a total of 10 minutes, the magic ceases to function until you finish a long rest.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Boots of Striding and Springing",
      type: "Wondrous item",
      description:
        "While you wear these boots, your walking speed becomes 30 feet, unless your walking speed is higher, and your speed isn't reduced if you are encumbered or wearing heavy armor. In addition, you can jump three times the normal distance, though you can't jump farther than your remaining movement would allow.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Boots of the Winterlands",
      type: "Wondrous item",
      description:
        "These furred boots are snug and feel quite warm. While you wear them, you gain the following benefits:\n&#8226; You have resistance to cold damage.\n&#8226; You ignore difficult terrain created by ice or snow.\n&#8226; You can tolerate temperatures as low as -50 degrees Fahrenheit without any additional protection. If you wear heavy clothes, you can tolerate temperatures as low as -100 degrees Fahrenheit.</p>",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Bowl of Commanding Water Elementals",
      type: "Wondrous item",
      description:
        "While this bowl is filled with water, you can use an action to speak the bowl's command word and summon a water elemental, as if you had cast the <i>conjure elemental</i> spell. The bowl can't be used this way again until the next dawn.\nThe bowl is about 1 foot in diameter and half as deep. It weighs 3 pounds and holds about 3 gallons.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Bracers of Archery",
      type: "Wondrous item",
      description:
        "While wearing these bracers, you have proficiency with the longbow and shortbow, and you gain a +2 bonus to damage rolls on ranged attacks made with such weapons.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Bracers of Defense",
      type: "Wondrous item",
      description:
        "While wearing these bracers, you gain a +2 bonus to AC if you are wearing no armor and using no shield.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Brazier of Commanding Fire Elementals",
      type: "Wondrous item",
      description:
        "While a fire burns in this brass brazier, you can use an action to speak the brazier's command word and summon a fire elemental, as if you had cast the <i>conjure elemental</i> spell. The brazier can't be used this way again until the next dawn.\nThe brazier weighs 5 pounds.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Brooch of Shielding",
      type: "Wondrous item",
      description:
        "While wearing this brooch, you have resistance to force damage, and you have immunity to damage from the <i>magic missile</i> spell.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Broom of Flying",
      type: "Wondrous item",
      description:
        "This wooden broom, which weighs 3 pounds, functions like a mundane broom until you stand astride it and speak its command word. It then hovers beneath you and can be ridden in the air. It has a flying speed of 50 feet. It can carry up to 400 pounds, but its flying speed becomes 30 feet while carrying over 200 pounds. The broom stops hovering when you land.\nYou can send the broom to travel alone to a destination within 1 mile of you if you speak the command word, name the location, and are familiar with that place. The broom comes back to you when you speak another command word, provided that the broom is still within 1 mile of you.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Candle of Invocation",
      type: "Wondrous item",
      description:
        "This slender taper is dedicated to a deity and shares that deity's alignment. The candle's alignment can be detected with the <i>detect evil and good</i> spell.\nThe candle's magic is activated when the candle is lit, which requires an action. After burning for 4 hours, the candle is destroyed. You can snuff it out early for use at a later time. Deduct the time it burned in increments of 1 minute from the candle's total burn time.\nWhile lit, the candle sheds dim light in a 30-foot radius. Any creature within that light whose alignment matches that of the candle makes attack rolls, saving throws, and ability checks with advantage. In addition, a cleric or druid in the light whose alignment matches the candle's can cast 1st level spells he or she has prepared without expending spell slots, though the spell's effect is as if cast with a 1st-level slot.\nAlternatively, when you light the candle for the first time, you can cast the <i>gate</i> spell with it. Doing so destroys the candle.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cape of the Mountebank",
      type: "Wondrous item",
      description:
        "This cape smells faintly of brimstone. While wearing it, you can use it to cast the <i>dimension door</i> spell as an action. This property of the cape can't be used again until the next dawn.\nWhen you disappear, you leave behind a cloud of smoke, and you appear in a similar cloud of smoke at your destination. The smoke lightly obscures the space you left and the space you appear in, and it dissipates at the end of your next turn. A light or stronger wind disperses the smoke.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Carpet of Flying",
      type: "Wondrous item",
      description:
        "You can speak the carpet's command word as an action to make the carpet hover and fly. It moves according to your spoken directions, provided that you are within 30 feet of it.\n[option]",
      rarity: "Very Rare",
      attunement: "No",
      optionName: "Size:",
      options: [
        [
          {
            name: "Small",
            value:
              "This carpet is 3 ft. \u00D7 5 ft., has a carrying capacity of 200 lb. and a flying speed of 80 ft. It can carry up to to twice its capacity, but flies at half var carpet speed if it carries more than its normal capacity.",
          },
          {
            name: "Medium",
            value:
              "This carpet is 4 ft. \u00D7 6 ft., has a carrying capacity of 400 lb. and a flying speed of 60 ft. It can carry up to to twice its capacity, but flies at half speed if it carries more than its normal capacity.",
          },
          {
            name: "Large",
            value:
              "This carpet is 5 ft. \u00D7 7 ft., has a carrying capacity of 600 lb. and a flying speed of 40 ft. It can carry up to to twice its capacity, but flies at half speed if it carries more than its normal capacity.",
          },
          {
            name: "Huge",
            value:
              "This carpet is 6 ft. \u00D7 9 ft., has a carrying capacity of 800 lb. and a flying speed of 30 ft. It can carry up to to twice its capacity, but flies at half speed if it carries more than its normal capacity.",
          },
        ],
      ],
      source: "srd",
    },
    {
      name: "Censer of Controlling Air Elementals",
      type: "Wondrous item",
      description:
        "While incense is burning in this censer, you can use an action to speak the censer's command word and summon an air elemental, as if you had cast the <i>conjure elemental</i> spell. The censer can't be used this way again until the next dawn.\nThis 6-inch-wide, 1-foot-high vessel resembles a chalice with a decorated lid. It weighs 1 pound.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Chime of Opening",
      type: "Wondrous item",
      description:
        "This hollow metal tube measures about 1 foot long and weighs 1 pound. You can strike it as an action, pointing it at an object within 120 feet of you that can be opened, such as a door, lid, or lock. The chime issues a clear tone, and one lock or latch on the object opens unless the sound can't reach the object. If no locks or latches remain, the object itself opens.\nThe chime can be used ten times. After the tenth time, it cracks and becomes useless.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Circlet of Blasting",
      type: "Wondrous item",
      description:
        "While wearing this circlet, you can use an action to cast the <i>scorching ray</i> spell with it. When you make the spell's attacks, you do so with an attack bonus of +5. The circlet can't be used this way again until the next dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Cloak of Arachnida",
      type: "Wondrous item",
      description:
        "This fine garment is made of black silk interwoven with faint silvery threads. While wearing it, you gain the following benefits:\n&#8226; You have resistance to poison damage.\n&#8226; You have a climbing speed equal to your walking speed.\n&#8226; You can move up, down, and across vertical surfaces and upside down along ceilings, while leaving your hands free.\n&#8226; You can't be caught in webs of any sort and can move through webs as if they were difficult terrain.\n&#8226; You can use an action to cast the <i>web</i> spell (save DC 13). The web created by the spell fills twice its normal area. Once used, this property of the cloak can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cloak of Displacement",
      type: "Wondrous item",
      description:
        "While you wear this cloak, it projects an illusion that makes you appear to be standing in a place near your actual location, causing any creature to have disadvantage on attack rolls against you. If you take damage, the property ceases to function until the start of your next turn. This property is suppressed while you are incapacitated, restrained, or otherwise unable to move.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cloak of Elvenkind",
      type: "Wondrous item",
      description:
        "While you wear this cloak with its hood up, Wisdom (Perception) checks made to see you have disadvantage, and you have advantage on Dexterity (Stealth) checks made to hide, as the cloak's color shifts to camouflage you. Pulling the hood up or down requires an action.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cloak of Protection",
      type: "Wondrous item",
      description:
        "You gain a +1 bonus to AC and saving throws while you wear this cloak.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cloak of the Bat",
      type: "Wondrous item",
      description:
        "While wearing this cloak, you have advantage on Dexterity (Stealth) checks. In an area of dim light or darkness, you can grip the edges of the cloak with both hands and use it to fly at a speed of 40 feet. If you ever fail to grip the cloak's edges while flying in this way, or if you are no longer in dim light or darkness, you lose this flying speed.\nWhile wearing the cloak in an area of dim light or darkness, you can use your action to cast <i>polymorph</i> on yourself, transforming into a bat. While you are in the form of the bat, you retain your Intelligence, Wisdom, and Charisma scores. The cloak can't be used this way again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cloak of the Manta Ray",
      type: "Wondrous item",
      description:
        "While wearing this cloak with its hood up, you can breathe underwater, and you have a swimming speed of 60 feet. Pulling the hood up or down requires an action.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Crystal Ball",
      type: "Wondrous item",
      description:
        "The typical <i>crystal ball</i>, a very rare item, is about 6 inches in diameter. While touching it, you can cast the <i>scrying</i> spell (save DC 17) with it.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Crystal Ball of Mind Reading",
      type: "Wondrous item",
      description:
        "The <i>crystal ball</i> is about 6 inches in diameter. While touching it, you can cast the <i>scrying</i> spell (save DC 17) with it.\n<b><i>Crystal Ball of Mind Reading</i></b>. You can use an action to cast the <i>detect thoughts</i> spell (save DC 17) while you are scrying with the <i>crystal ball</i>, targeting creatures you can see within 30 feet of the spell's sensor. You don't need to concentrate on this <i>detect thoughts</i> to maintain it during its duration, but it ends if <i>scrying</i> ends.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Crystal Ball of Telepathy",
      type: "Wondrous item",
      description:
        "The <i>crystal ball</i> is about 6 inches in diameter. While touching it, you can cast the <i>scrying</i> spell (save DC 17) with it.\n<b><i>Crystal Ball of Telepathy</i></b>. While scrying with the crystal ball, you can communicate telepathically with creatures you can see within 30 feet of the spell's sensor. You can also use an action to cast the <i>suggestion</i> spell (save DC 17) through the sensor on one of those creatures. You don't need to concentrate on this <i>suggestion</i> to maintain it during its duration, but it ends if <i>scrying</i> ends. Once used, the <i>suggestion</i> power of the <i>crystal ball</i> can't be used again until the next dawn.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Crystal Ball of True Seeing",
      type: "Wondrous item",
      description:
        "The <i>crystal ball</i> is about 6 inches in diameter. While touching it, you can cast the <i>scrying</i> spell (save DC 17) with it.\n<b><i>Crystal Ball of True Seeing</i></b>. While scrying with the crystal ball, you have truesight with a radius of 120 feet centered on the spell's sensor.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cube of Force",
      type: "Wondrous item",
      description:
        "This cube is about an inch across. Each face has a distinct marking on it that can be pressed. The cube starts with 36 charges, and it regains 1d20 expended charges daily at dawn.\nYou can use an action to press one of the cube's faces, expending a number of charges based on the chosen face. For a full descrition of the <i>cube of force</i>, see page 215 of the 5E SRD 5.1.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Cubic Gate",
      type: "Wondrous item",
      description:
        "This cube is 3 inches across and radiates palpable magical energy. The six sides of the cube are each keyed to a different plane of existence, one of which is the Material Plane. The other sides are linked to planes determined by the GM.\nYou can use an action to press one side of the cube to cast the <i>gate</i> spell with it, opening a portal to the plane keyed to that side. Alternatively, if you use an action to press one side twice, you can cast the <i>plane shift</i> spell (save DC 17) with the cube and transport the targets to the plane keyed to that side.\nThe cube has 3 charges. Each use of the cube expends 1 charge. The cube regains 1d3 expended charges daily at dawn.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dagger of Venom",
      type: "Weapon",
      subtype: "Dagger",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic weapon.\nYou can use an action to cause thick, black poison to coat the blade. The poison remains for 1 minute or until an attack using this weapon hits a creature. That creature must succeed on a DC 15 Constitution saving throw or take 2d10 poison damage and become poisoned for 1 minute. The dagger can't be used this way again until the next dawn.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dancing Sword",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You can use a bonus action to toss this magic sword into the air and speak the command word. When you do so, the sword begins to hover, flies up to 30 feet, and attacks one creature of your choice within 5 feet of it. The sword uses your attack roll and ability score modifier to damage rolls.\nWhile the sword hovers, you can use a bonus action to cause it to fly up to 30 feet to another spot within 30 feet of you. As part of the same bonus action, you can cause the sword to attack one creature within 5 feet of it.\nAfter the hovering sword attacks for the fourth time, it flies up to 30 feet and tries to return to your hand. If you have no hand free, it falls to the ground at your feet. If the sword has no unobstructed path to you, it moves as close to you as it can and then falls to the ground. It also ceases to hover if you grasp it or move more than 30 feet away from it.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Decanter of Endless Water",
      type: "Wondrous item",
      description:
        "This stoppered flask sloshes when shaken, as if it contains water. The decanter weighs 2 pounds.\nYou can use an action to remove the stopper and speak one of three command words, whereupon an amount of fresh water or salt water (your choice) pours out of the flask. The water stops pouring out at the start of your next turn. Choose from the following options:\n&#8226; 'Stream' produces 1 gallon of water.\n&#8226; 'Fountain' produces 5 gallons of water.\n&#8226; 'Geyser' produces 30 gallons of water that gushes forth in a geyser 30 feet long and 1 foot wide. As a bonus action while holding the decanter, you can aim the geyser at a creature you can see within 30 feet of you. The target must succeed on a DC 13 Strength saving throw or take 1d4 bludgeoning damage and fall prone. Instead of a creature, you can target an object that isn't being worn or carried and that weighs no more than 200 pounds. The object is either knocked over or pushed up to 15 feet away from you.</p>",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Deck of Illusions",
      type: "Wondrous item",
      description:
        "This box contains a set of parchment cards. A full deck has 34 cards. A deck found as treasure is usually missing 1d20 - 1 cards.\nThe magic of the deck functions only if cards are drawn at random (you can use an altered deck of playing cards to simulate the deck). You can use an action to draw a card at random from the deck and throw it to the ground at a point within 30 feet of you.\nAn illusion of one or more creatures forms over the thrown card and remains until dispelled. An illusory creature appears real, of the appropriate size, and behaves as if it were a real creature except that it can do no harm. While you are within 120 feet of the illusory creature and can see it, you can use an action to move it magically anywhere within 30 feet of its card. Any physical interaction with the illusory creature reveals it to be an illusion, because objects pass through it. Someone who uses an action to visually inspect the creature identifies it as illusory with a successful DC 15 Intelligence (Investigation) check. The creature then appears translucent.\nThe illusion lasts until its card is moved or the illusion is dispelled. When the illusion ends, the image on its card disappears, and that card can't be used again. \nFor a full description of the <i>deck of illusions</i> see page 216 of the 5E SRD 5.1.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Deck of Many Things",
      type: "Wondrous item",
      description:
        "Usually found in a box or pouch, this deck contains a number of cards made of ivory or vellum. Most (75 percent) of these decks have only thirteen cards, but the rest have twenty-two.\nBefore you draw a card, you must declare how many cards you intend to draw and then draw them randomly (you can use an altered deck of playing cards to simulate the deck). Any cards drawn in excess of this number have no effect. Otherwise, as soon as you draw a card from the deck, its magic takes effect. You must draw each card no more than 1 hour after the previous draw. If you fail to draw the chosen number, the remaining number of cards fly from the deck on their own and take effect all at once.\nOnce a card is drawn, it fades from existence. Unless the card is the Fool or the Jester, the card reappears in the deck, making it possible to draw the same card twice.\n  For a full description of the <i>deck of many things</i> see page 216 of the 5E SRD 5.1.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Defender",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You gain a +3 bonus to attack and damage rolls made with this magic weapon.\nThe first time you attack with the sword on each of your turns, you can transfer some or all of the sword's bonus to your Armor Class, instead of using the bonus on any attacks that turn. For example, you could reduce the bonus to your attack and damage rolls to +1 and gain a +2 bonus to AC. The adjusted bonuses remain in effect until the start of your next turn, although you must hold the sword to gain a bonus to AC from it.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Demon Armor",
      type: "Armor",
      subtype: "Plate",
      description:
        "While wearing this armor, you gain a +1 bonus to AC, and you can understand and speak Abyssal. In addition, the armor's clawed gauntlets turn unarmed strikes with your hands into magic weapons that deal slashing damage, with a +1 bonus to attack rolls and damage rolls and a damage die of 1d8.\n<b><i>Curse</i></b>. Once you don this cursed armor, you can't doff it unless you are targeted by the <i>remove curse</i> spell or similar magic. While wearing the armor, you have disadvantage on attack rolls against demons and on saving throws against their spells and special abilities.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Dimensional Shackles",
      type: "Wondrous item",
      description:
        "You can use an action to place these shackles on an incapacitated creature. The shackles adjust to fit a creature of Small to Large size. In addition to serving as mundane manacles, the shackles prevent a creature bound by them from using any method of extradimensional movement, including teleportation or travel to a different plane of existence. They don't prevent the creature from passing through an interdimensional portal.\nYou and any creature you designate when you use the shackles can use an action to remove them. Once every 30 days, the bound creature can make a DC 30 Strength (Athletics) check. On a success, the creature breaks free and destroys the shackles.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dragon Scale Mail",
      type: "Armor",
      subtype: "Scale mail",
      description:
        "Dragon scale mail is made of the scales of one kind of dragon. Sometimes dragons collect their cast-off scales and gift them to humanoids. Other times, hunters carefully skin and preserve the hide of a dead dragon. In either case, dragon scale mail is highly valued.\nWhile wearing this armor, you gain a +1 bonus to AC, you have advantage on saving throws against the Frightful Presence and breath weapons of dragons, and you have resistance to [option] damage.\nAdditionally, you can focus your senses as an action to magically discern the distance and direction to the closest dragon within 30 miles of you that is of the same type as the armor. This special action can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      optionName: "Color",
      options: [
        [
          { name: "Black", value: "acid" },
          { name: "Blue", value: "lightning" },
          { name: "Brass", value: "fire" },
          { name: "Bronze", value: "lightning" },
          { name: "Copper", value: "acid" },
          { name: "Gold", value: "fire" },
          { name: "Green", value: "poison" },
          { name: "Red", value: "fire" },
          { name: "Silver", value: "cold" },
          { name: "White", value: "cold" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Dragon Slayer",
      type: "Weapon",
      subtype: "Any sword",
      description:
        '<p>You gain a +1 bonus to attack and damage rolls made with this magic weapon.\nWhen you hit a dragon with this weapon, the dragon takes an extra 3d6 damage of the weapon\'s type. For the purpose of this weapon, "dragon" refers to any creature with the dragon type, including dragon turtles and wyverns.',
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dust of Disappearance",
      type: "Wondrous item",
      description:
        "Found in a small packet, this powder resembles very fine sand. There is enough of it for one use. When you use an action to throw the dust into the air, you and each creature and object within 10 feet of you become invisible for 2d4 minutes. The duration is the same for all subjects, and the dust is consumed when its magic takes effect. If a creature affected by the dust attacks or casts a spell, the invisibility ends for that creature.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dust of Dryness",
      type: "Wondrous item",
      description:
        "This small packet contains 1d6 + 4 pinches of dust. You can use an action to sprinkle a pinch of it over water. The dust turns a cube of water 15 feet on a side into one marble-sized pellet, which floats or rests near where the dust was sprinkled. The pellet's weight is negligible.\nSomeone can use an action to smash the pellet against a hard surface, causing the pellet to shatter and release the water the dust absorbed. Doing so ends that pellet's magic.\nAn elemental composed mostly of water that is exposed to a pinch of the dust must make a DC 13 Constitution saving throw, taking 10d6 necrotic damage on a failed save, or half as much damage on a successful one.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dust of Sneezing and Choking",
      type: "Wondrous item",
      description:
        "Found in a small container, this powder resembles very fine sand. It appears to be <i>dust of disappearance</i>, and an <i>identify</i> spell reveals it to be such. There is enough of it for one use.\nWhen you use an action to throw a handful of the dust into the air, you and each creature that needs to breathe within 30 feet of you must succeed on a DC 15 Constitution saving throw or become unable to breathe, while sneezing uncontrollably. A creature affected in this way is incapacitated and suffocating. As long as it is conscious, a creature can repeat the saving throw at the end of each of its turns, ending the effect on it on a success. The <i>lesser restoration</i> spell can also end the effect on a creature.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dwarven Plate",
      type: "Armor",
      subtype: "Plate",
      description:
        "While wearing this armor, you gain a +2 bonus to AC. In addition, if an effect moves you against your will along the ground, you can use your reaction to reduce the distance you are moved by up to 10 feet.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Dwarven Thrower",
      type: "Weapon",
      subtype: "Warhammer",
      description:
        "You gain a +3 bonus to attack and damage rolls made with this magic weapon. It has the thrown property with a normal range of 20 feet and a long range of 60 feet. When you hit with a ranged attack using this weapon, it deals an extra 1d8 damage or, if the target is a giant, 2d8 damage. Immediately after the attack, the weapon flies back to your hand.",
      rarity: "Very Rare",
      attunement: "Requires attunement by a dwarf",
      source: "srd",
    },
    {
      name: "Efficient Quiver",
      type: "Wondrous item",
      description:
        "Each of the quiver's three compartments connects to an extradimensional space that allows the quiver to hold numerous items while never weighing more than 2 pounds. The shortest compartment can hold up to sixty arrows, bolts, or similar objects. The midsize compartment holds up to eighteen javelins or similar objects. The longest compartment holds up to six long objects, such as bows, quarterstaffs, or spears.\nYou can draw any item the quiver contains as if doing so from a regular quiver or scabbard.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Efreeti Bottle",
      type: "Wondrous item",
      description:
        "This painted brass bottle weighs 1 pound. When you use an action to remove the stopper, a cloud of thick smoke flows out of the bottle. At the end of your turn, the smoke disappears with a flash of harmless fire, and an efreeti appears in an unoccupied space within 30 feet of you.\nThe first time the bottle is opened, the GM rolls to determine what happens.\n On a roll of 1-10, the efreeti attacks you. After fighting for 5 rounds, the efreeti disappears, and the bottle loses its magic.\n On a roll of 11-90, the efreeti serves you for 1 hour, doing as you command. Then the efreeti returns to the bottle, and a new stopper contains it. The stopper can't be removed for 24 hours. The next two times the bottle is opened, the same effect occurs. If the bottle is opened a fourth time, the efreeti escapes and disappears, and the bottle loses its magic. \n On a roll of 91-100, the efreeti can cast the wish spell three times for you. It disappears when it grants the final wish or after 1 hour, and the bottle loses its magic.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Elemental Gem",
      type: "Wondrous item",
      description: "[option]",
      rarity: "Uncommon",
      attunement: "No",
      optionName: "Element:",
      options: [
        [
          {
            name: "Blue Sapphire",
            value:
              "This blue sapphire contains a mote of elemental energy. When you use an action to break the gem, an air elemental is summoned as if you had cast the <i>conjure elemental</i> spell, and the gem's magic is lost.",
          },
          {
            name: "Yellow Diamond",
            value:
              "This yellow diamond contains a mote of elemental energy. When you use an action to break the gem, an earth elemental is summoned as if you had cast the <i>conjure elemental</i> spell, and the gem's magic is lost.",
          },
          {
            name: "Red Corundum",
            value:
              "This red corundum contains a mote of elemental energy. When you use an action to break the gem, a fire elemental is summoned as if you had cast the <i>conjure elemental</i> spell, and the gem's magic is lost.",
          },
          {
            name: "Emerald",
            value:
              "This emerald contains a mote of elemental energy. When you use an action to break the gem, a water elemental is summoned as if you had cast the <i>conjure elemental</i> spell, and the gem's magic is lost.",
          },
        ],
      ],
      source: "srd",
    },
    {
      name: "Elven Chain",
      type: "Armor",
      subtype: "Chain shirt",
      description:
        "You gain a +1 bonus to AC while you wear this armor. You are considered proficient with this armor even if you lack proficiency with medium armor.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Eversmoking Bottle",
      type: "Wondrous item",
      description:
        "Smoke leaks from the lead-stoppered mouth of this brass bottle, which weighs 1 pound. When you use an action to remove the stopper, a cloud of thick smoke pours out in a 60-foot radius from the bottle. The cloud's area is heavily obscured. Each minute the bottle remains open and within the cloud, the radius increases by 10 feet until it reaches its maximum radius of 120 feet.\nThe cloud persists as long as the bottle is open. Closing the bottle requires you to speak its command word as an action. Once the bottle is closed, the cloud disperses after 10 minutes. A moderate wind (11 to 20 miles per hour) can also disperse the smoke after 1 minute, and a strong wind (21 or more miles per hour) can do so after 1 round.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Eyes of Charming",
      type: "Wondrous item",
      description:
        "These crystal lenses fit over the eyes. They have 3 charges. While wearing them, you can expend 1 charge as an action to cast the <i>charm person</i> spell (save DC 13) on a humanoid within 30 feet of you, provided that you and the target can see each other. The lenses regain all expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Eyes of Minute Seeing",
      type: "Wondrous item",
      description:
        "These crystal lenses fit over the eyes. While wearing them, you can see much better than normal out to a range of 1 foot. You have advantage on Intelligence (Investigation) checks that rely on sight while searching an area or studying an object within that range.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Eyes of the Eagle",
      type: "Wondrous item",
      description:
        "These crystal lenses fit over the eyes. While wearing them, you have advantage on Wisdom (Perception) checks that rely on sight. In conditions of clear visibility, you can make out details of even extremely distant creatures and objects as small as 2 feet across.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Feather Token",
      type: "Wondrous item",
      description: "This tiny object looks like a feather.\n[option]",
      rarity: "Rare",
      attunement: "No",
      optionName: "Token Type:",
      options: [
        [
          {
            name: "Anchor",
            value:
              "<b><i>Anchor.</i></b> You can use an action to touch the token to a boat or ship. For the next 24 hours, the vessel can't be moved by any means. Touching the token to the vessel again ends the effect. When the effect ends, the token disappears.",
          },
          {
            name: "Bird",
            value:
              "<b><i>Bird.</i></b> You can use an action to toss the token 5 feet into the air. The token disappears and an enormous, multicolored bird takes its place. The bird has the statistics of a roc, but it obeys your simple commands and can't attack. It can carry up to 500 pounds while flying at its maximum speed (16 miles an hour for a maximum of 144 miles per day, with a one-hour rest for every 3 hours of flying), or 1,000 pounds at half that speed. The bird disappears after flying its maximum distance for a day or if it drops to 0 hit points. You can dismiss the bird as an action.",
          },
          {
            name: "Fan",
            value:
              "<b><i>Fan.</i></b> If you are on a boat or ship, you can use an action to toss the token up to 10 feet in the air. The token disappears, and a giant flapping fan takes its place. The fan floats and creates a wind strong enough to fill the sails of one ship, increasing its speed by 5 miles per hour for 8 hours. You can dismiss the fan as an action.",
          },
          {
            name: "Swan Boat",
            value:
              "<b><i>Swan Boat.</i></b> You can use an action to touch the token to a body of water at least 60 feet in diameter. The token disappears, and a 50-foot-long, 20-foot wide boat shaped like a swan takes its place. The boat is self-propelled and moves across water at a speed of 6 miles per hour. You can use an action while on the boat to command it to move or to turn up to 90 degrees. The boat can carry up to thirty-two Medium or smaller creatures. A Large creature counts as four Medium creatures, while a Huge creature counts as nine. The boat remains for 24 hours and then disappears. You can dismiss the boat as an action.",
          },
          {
            name: "Tree",
            value:
              "<b><i>Tree.</i></b> You must be outdoors to use this token. You can use an action to touch it to an unoccupied space on the ground. The token disappears, and in its place a nonmagical oak tree springs into existence. The tree is 60 feet tall and has a 5-foot-diameter trunk, and its branches at the top spread out in a 20-foot radius.",
          },
          {
            name: "Whip",
            value:
              "<b><i>Whip.</i></b> You can use an action to throw the token to a point within 10 feet of you. The token disappears, and a floating whip takes its place. You can then use a bonus action to make a melee spell attack against a creature within 10 feet of the whip, with an attack bonus of +9. On a hit, the target takes 1d6 + 5 force damage.\nAs a bonus action on your turn, you can direct the whip to fly up to 20 feet and repeat the attack against a creature within 10 feet of it. The whip disappears after 1 hour, when you use an action to dismiss it, or when you are incapacitated or die.",
          },
        ],
      ],
      source: "srd",
    },
    {
      name: "Figurine of Wondrous Power (Bronze Griffon)",
      type: "Wondrous item",
      description:
        "A <i>figurine of wondrous power</i> is a statuette of a beast small enough to fit in a pocket. If you use an action to speak the command word and throw the figurine to a point on the ground within 60 feet of you, the figurine becomes a living creature. If the space where the creature would appear is occupied by other creatures or objects, or if there isn't enough space for the creature, the figurine doesn't become a creature.\nThe creature is friendly to you and your companions. It understands your languages and obeys your spoken commands. If you issue no commands, the creature defends itself but takes no other actions.\nThe creature exists for a duration specific to each figurine. At the end of the duration, the creature reverts to its figurine form. It reverts to a figurine early if it drops to 0 hit points or if you use an action to speak the command word again while touching it.\n<b><i>Bronze Griffon</i></b>. This bronze statuette is of a griffon rampant. It can become a griffon for up to 6 hours. Once it has been used, it can't be used again until 5 days have passed.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Figurine of Wondrous Power (Ebony Fly)",
      type: "Wondrous item",
      description:
        "A <i>figurine of wondrous power</i> is a statuette of a beast small enough to fit in a pocket. If you use an action to speak the command word and throw the figurine to a point on the ground within 60 feet of you, the figurine becomes a living creature. If the space where the creature would appear is occupied by other creatures or objects, or if there isn't enough space for the creature, the figurine doesn't become a creature.\nThe creature is friendly to you and your companions. It understands your languages and obeys your spoken commands. If you issue no commands, the creature defends itself but takes no other actions.\nThe creature exists for a duration specific to each figurine. At the end of the duration, the creature reverts to its figurine form. It reverts to a figurine early if it drops to 0 hit points or if you use an action to speak the command word again while touching it.\n<b><i>Ebony Fly</i></b>. This ebony statuette is carved in the likeness of a horsefly. It can become a giant fly for up to 12 hours and can be ridden as a mount. Once it has been used, it can't be used again until 2 days have passed.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Flame Tongue",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You can use a bonus action to speak this magic sword's command word, causing flames to erupt from the blade. These flames shed bright light in a 40-foot radius and dim light for an additional 40 feet. While the sword is ablaze, it deals an extra 2d6 fire damage to any target it hits. The flames last until you use a bonus action to speak the command word again or until you drop or sheathe the sword.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Folding Boat",
      type: "Wondrous item",
      description:
        "This object appears as a wooden box that measures 12 inches long, 6 inches wide, and 6 inches deep. It weighs 4 pounds and floats. It can be opened to store items inside. This item also has three command words, each requiring you to use an action to speak it.\nOne command word causes the box to unfold into a boat 10 feet long, 4 feet wide, and 2 feet deep. The boat has one pair of oars, an anchor, a mast, and a lateen sail. The boat can hold up to four Medium creatures comfortably.\nThe second command word causes the box to unfold into a ship 24 feet long, 8 feet wide, and 6 feet deep. The ship has a deck, rowing seats, five sets of oars, a steering oar, an anchor, a deck cabin, and a mast with a square sail. The ship can hold fifteen Medium creatures comfortably.\nWhen the box becomes a vessel, its weight becomes that of a normal vessel its size, and anything that was stored in the box remains in the boat.\nThe third command word causes the <i>folding boat</i> to fold back into a box, provided that no creatures are aboard. Any objects in the vessel that can't fit inside the box remain outside the box as it folds. Any objects in the vessel that can fit inside the box do so.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Frost Brand",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "When you hit with an attack using this magic sword, the target takes an extra 1d6 cold damage. In addition, while you hold the sword, you have resistance to fire damage.\nIn freezing temperatures, the blade sheds bright light in a 10-foot radius and dim light for an additional 10 feet.\nWhen you draw this weapon, you can extinguish all nonmagical flames within 30 feet of you. This property can be used no more than once per hour.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Gauntlets of Ogre Power",
      type: "Wondrous item",
      description:
        "Your Strength score is 19 while you wear these gauntlets. They have no effect on you if your Strength is already 19 or higher.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Gem of Brightness",
      type: "Wondrous item",
      description:
        "This prism has 50 charges. While you are holding it, you can use an action to speak one of three command words to cause one of the following effects:\n&#8226; The first command word causes the gem to shed bright light in a 30-foot radius and dim light for an additional 30 feet. This effect doesn't expend a charge. It lasts until you use a bonus action to repeat the command word or until you use another function of the gem.\n&#8226; The second command word expends 1 charge and causes the gem to fire a brilliant beam of light at one creature you can see within 60 feet of you. The creature must succeed on a DC 15 Constitution saving throw or become blinded for 1 minute. The creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.\n&#8226; The third command word expends 5 charges and causes the gem to flare with blinding light in a 30 foot cone originating from it. Each creature in the cone must make a saving throw as if struck by the beam created with the second command word.</p>\nWhen all of the gem's charges are expended, the gem becomes a nonmagical jewel worth 50 gp.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Gem of Seeing",
      type: "Wondrous item",
      description:
        "This gem has 3 charges. As an action, you can speak the gem's command word and expend 1 charge. For the next 10 minutes, you have truesight out to 120 feet when you peer through the gem.\nThe gem regains 1d3 expended charges daily at dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Giant Slayer",
      type: "Weapon",
      subtype: "Any axe or sword",
      description:
        '<p>You gain a +1 bonus to attack and damage rolls made with this magic weapon.\nWhen you hit a giant with it, the giant takes an extra 2d6 damage of the weapon\'s type and must succeed on a DC 15 Strength saving throw or fall prone. For the purpose of this weapon, "giant" refers to any creature with the giant type, including ettins and trolls.',
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Glamoured Studded Leather",
      type: "Armor",
      subtype: "Studded leather",
      description:
        "While wearing this armor, you gain a +1 bonus to AC. You can also use a bonus action to speak the armor's command word and cause the armor to assume the appearance of a normal set of clothing or some other kind of armor. You decide what it looks like, including color, style, and accessories, but the armor retains its normal bulk and weight. The illusory appearance lasts until you use this property again or remove the armor.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Gloves of Missile Snaring",
      type: "Wondrous item",
      description:
        "These gloves seem to almost meld into your hands when you don them. When a ranged weapon attack hits you while you're wearing them, you can use your reaction to reduce the damage by 1d10 + your Dexterity modifier, provided that you have a free hand. If you reduce the damage to 0, you can catch the missile if it is small enough for you to hold in that hand.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Gloves of Swimming and Climbing",
      type: "Wondrous item",
      description:
        "While wearing these gloves, climbing and swimming don't cost you extra movement, and you gain a +5 bonus to Strength (Athletics) checks made to climb or swim.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Goggles of Night",
      type: "Wondrous item",
      description:
        "While wearing these dark lenses, you have darkvision out to a range of 60 feet. If you already have darkvision, wearing the goggles increases its range by 60 feet.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Hammer of Thunderbolts",
      type: "Weapon",
      subtype: "Maul",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic weapon.\n<b><i>Giant's Bane</i></b>. You must be wearing a <i>belt of giant strength</i> (any variety) and <i>gauntlets of ogre power</i> to attune to this weapon. The attunement ends if you take off either of those items. While you are attuned to this weapon and holding it, your Strength score increases by 4 and can exceed 20, but not 30. When you roll a 20 on an attack roll made with this weapon against a giant, the giant must succeed on a DC 17 Constitution saving throw or die.\nThe hammer also has 5 charges. While attuned to it, you can expend 1 charge and make a ranged weapon attack with the hammer, hurling it as if it had the thrown property with a normal range of 20 feet and a long range of 60 feet. If the attack hits, the hammer unleashes a thunderclap audible out to 300 feet. The target and every creature within 30 feet of it must succeed on a DC 17 Constitution saving throw or be stunned until the end of your next turn. The hammer regains 1d4 + 1 expended charges daily at dawn.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Handy Haversack",
      type: "Wondrous item",
      description:
        "This backpack has a central pouch and two side pouches, each of which is an extradimensional space. Each side pouch can hold up to 20 pounds of material, not exceeding a volume of 2 cubic feet. The large central pouch can hold up to 8 cubic feet or 80 pounds of material. The backpack always weighs 5 pounds, regardless of its contents.\nPlacing an object in the haversack follows the normal rules for interacting with objects. Retrieving an item from the haversack requires you to use an action. When you reach into the haversack for a specific item, the item is always magically on top.\nThe haversack has a few limitations. If it is overloaded, or if a sharp object pierces it or tears it, the haversack ruptures and is destroyed. If the haversack is destroyed, its contents are lost forever, although an artifact always turns up again somewhere. If the haversack is turned inside out, its contents spill forth, unharmed, and the haversack must be put right before it can be used again. If a breathing creature is placed within the haversack, the creature can survive for up to 10 minutes, after which time it begins to suffocate.\nPlacing the haversack inside an extradimensional space created by a <i>bag of holding</i>, <i>portable hole</i>, or similar item instantly destroys both items and opens a gate to the Astral Plane. The gate originates where the one item was placed inside the other. Any creature within 10 feet of the gate is sucked through it and deposited in a random location on the Astral Plane. The gate then closes. The gate is one-way only and can't be reopened.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Hat of Disguise",
      type: "Wondrous item",
      description:
        "While wearing this hat, you can use an action to cast the <i>disguise self</i> spell from it at will. The spell ends if the hat is removed.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Headband of Intellect",
      type: "Wondrous item",
      description:
        "Your Intelligence score is 19 while you wear this headband. It has no effect on you if your Intelligence is already 19 or higher.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Helm of Brilliance",
      type: "Wondrous item",
      description:
        "This dazzling helm is set with 1d10 diamonds, 2d10 rubies, 3d10 fire opals, and 4d10 opals. Any gem pried from the helm crumbles to dust. When all the gems are removed or destroyed, the helm loses its magic.\nYou gain the following benefits while wearing it:\n&#8226; You can use an action to cast one of the following spells (save DC 18), using one of the helm's gems of the specified type as a component: <i>daylight</i> (opal), <i>fireball</i> (fire opal), <i>prismatic spray</i> (diamond), or <i>wall of fire</i> (ruby). The gem is destroyed when the spell is cast and disappears from the helm.\n&#8226; As long as it has at least one diamond, the helm emits dim light in a 30-foot radius when at least one undead is within that area. Any undead that starts its turn in that area takes 1d6 radiant damage.\n&#8226; As long as the helm has at least one ruby, you have resistance to fire damage.\n&#8226; As long as the helm has at least one fire opal, you can use an action and speak a command word to cause one weapon you are holding to burst into flames. The flames emit bright light in a 10-foot radius and dim light for an additional 10 feet. The flames are harmless to you and the weapon. When you hit with an attack using the blazing weapon, the target takes an extra 1d6 fire damage. The flames last until you use a bonus action to speak the command word again or until you drop or stow the weapon.</p>\nRoll a d20 if you are wearing the helm and take fire damage as a result of failing a saving throw against a spell. On a roll of 1, the helm emits beams of light from its remaining gems. Each creature within 60 feet of the helm other than you must succeed on a DC 17 Dexterity saving throw or be struck by a beam, taking radiant damage equal to the number of gems in the helm. The helm and its gems are then destroyed.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Helm of Comprehending Languages",
      type: "Wondrous item",
      description:
        "While wearing this helm, you can use an action to cast the <i>comprehend languages</i> spell from it at will.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Helm of Telepathy",
      type: "Wondrous item",
      description:
        "While wearing this helm, you can use an action to cast the <i>detect thoughts</i> spell (save DC 13) from it. As long as you maintain concentration on the spell, you can use a bonus action to send a telepathic message to a creature you are focused on. It can reply-using a bonus action to do so-while your focus on it continues.\nWhile focusing on a creature with <i>detect thoughts</i>, you can use an action to cast the <i>suggestion</i> spell (save DC 13) from the helm on that creature. Once used, the <i>suggestion</i> property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Helm of Teleportation",
      type: "Wondrous item",
      description:
        "This helm has 3 charges. While wearing it, you can use an action and expend 1 charge to cast the <i>teleport</i> spell from it. The helm regains 1d3 expended charges daily at dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Holy Avenger",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You gain a +3 bonus to attack and damage rolls made with this magic weapon. When you hit a fiend or an undead with it, that creature takes an extra 2d10 radiant damage.\nWhile you hold the drawn sword, it creates an aura in a 10-foot radius around you. You and all creatures friendly to you in the aura have advantage on saving throws against spells and other magical effects. If you have 17 or more levels in the paladin class, the radius of the aura increases to 30 feet.",
      rarity: "Legendary",
      attunement: "Requires attunement by a paladin",
      source: "srd",
    },
    {
      name: "Horn of Blasting",
      type: "Wondrous item",
      description:
        "You can use an action to speak the horn's command word and then blow the horn, which emits a thunderous blast in a 30-foot cone that is audible 600 feet away. Each creature in the cone must make a DC 15 Constitution saving throw. On a failed save, a creature takes 5d6 thunder damage and is deafened for 1 minute. On a successful save, a creature takes half as much damage and isn't deafened. Creatures and objects made of glass or crystal have disadvantage on the saving throw and take 10d6 thunder damage instead of 5d6.\nEach use of the horn's magic has a 20 percent chance of causing the horn to explode. The explosion deals 10d6 fire damage to the blower and destroys the horn.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horn of Valhalla (Brass)",
      type: "Wondrous item",
      description:
        "You can use an action to blow this horn. In response, 3d4 + 3 warrior spirits from the Valhalla appear within 60 feet of you. They use the statistics of a berserker. They return to Valhalla after 1 hour or when they drop to 0 hit points. Once you use the horn, it can't be used again until 7 days have passed.\nIf you blow the horn without having proficiency with all simple weapons, the summoned berserkers attack you. If you meet the requirement, they are friendly to you and your companions and follow your commands.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horn of Valhalla (Bronze)",
      type: "Wondrous item",
      description:
        "You can use an action to blow this horn. In response, 4d4 + 4 warrior spirits from the Valhalla appear within 60 feet of you. They use the statistics of a berserker. They return to Valhalla after 1 hour or when they drop to 0 hit points. Once you use the horn, it can't be used again until 7 days have passed.\nIf you blow the horn without having proficiency with medium armor, the summoned berserkers attack you. If you meet the requirement, they are friendly to you and your companions and follow your commands.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horn of Valhalla (Iron)",
      type: "Wondrous item",
      description:
        "You can use an action to blow this horn. In response, 5d4 + 5 warrior spirits from the Valhalla appear within 60 feet of you. They use the statistics of a berserker. They return to Valhalla after 1 hour or when they drop to 0 hit points. Once you use the horn, it can't be used again until 7 days have passed.\nIf you blow the horn without having proficiency with all martial weapons, the summoned berserkers attack you. If you meet the requirement, they are friendly to you and your companions and follow your commands.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horn of Valhalla (Silver)",
      type: "Wondrous item",
      description:
        "You can use an action to blow this horn. In response, 2d4 + 2 warrior spirits from the Valhalla appear within 60 feet of you. They use the statistics of a berserker. They return to Valhalla after 1 hour or when they drop to 0 hit points. Once you use the horn, it can't be used again until 7 days have passed.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horseshoes of a Zephyr",
      type: "Wondrous item",
      description:
        "These iron horseshoes come in a set of four. While all four shoes are affixed to the hooves of a horse or similar creature, they allow the creature to move normally while floating 4 inches above the ground. This effect means the creature can cross or stand above nonsolid or unstable surfaces, such as water or lava. The creature leaves no tracks and ignores difficult terrain. In addition, the creature can move at normal speed for up to 12 hours a day without suffering exhaustion from a forced march.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Horseshoes of Speed",
      type: "Wondrous item",
      description:
        "These iron horseshoes come in a set of four. While all four shoes are affixed to the hooves of a horse or similar creature, they increase the creature's walking speed by 30 feet.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Immovable Rod",
      type: "Rod",
      description:
        "This flat iron rod has a button on one end. You can use an action to press the button, which causes the rod to become magically fixed in place. Until you or another creature uses an action to push the button again, the rod doesn't move, even if it is defying gravity. The rod can hold up to 8,000 pounds of weight. More weight causes the rod to deactivate and fall. A creature can use an action to make a DC 30 Strength check, moving the fixed rod up to 10 feet on a success.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Instant Fortress",
      type: "Wondrous item",
      description:
        "You can use an action to place this 1-inch metal cube on the ground and speak its command word. The cube rapidly grows into a fortress that remains until you use an action to speak the command word that dismisses it, which works only if the fortress is empty.\nThe fortress is a square tower, 20 feet on a side and 30 feet high, with arrow slits on all sides and a battlement atop it. Its interior is divided into two floors, with a ladder running along one wall to connect them. The ladder ends at a trapdoor leading to the roof. When activated, the tower has a small door on the side facing you. The door opens only at your command, which you can speak as a bonus action. It is immune to the <i>knock</i> spell and similar magic, such as that of a <i>chime of opening</i>.\nEach creature in the area where the fortress appears must make a DC 15 Dexterity saving throw, taking 10d10 bludgeoning damage on a failed save, or half as much damage on a successful one. In either case, the creature is pushed to an unoccupied space outside but next to the fortress. Objects in the area that aren't being worn or carried take this damage and are pushed automatically.\nThe tower is made of adamantine, and its magic prevents it from being tipped over. The roof, the door, and the walls each have 100 hit points,\nimmunity to damage from nonmagical weapons excluding siege weapons, and resistance to all other damage. Only a <i>wish</i> spell can repair the fortress (this use of the spell counts as replicating a spell of 8th level or lower). Each casting of <i>wish</i> causes the roof, the door, or one wall to regain 50 hit points.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ioun Stone of Absorption",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Absorption</i></b>. While this pale lavender ellipsoid orbits your head, you can use your reaction to cancel a spell of 4th level or lower cast by a creature you can see and targeting only you.\nOnce the stone has canceled 20 levels of spells, it burns out and turns dull gray, losing its magic. If you are targeted by a spell whose level is higher than the number of spell levels the stone has left, the stone can't cancel it.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Agility",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Agility</i></b>. Your Dexterity score increases by 2, to a maximum of 20, while this deep red sphere orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Awareness",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Awareness</i></b>. You can't be surprised while this dark blue rhomboid orbits your head.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Fortitude",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Fortitude</i></b>. Your Constitution score increases by 2, to a maximum of 20, while this pink rhomboid orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Greater Absorption",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Greater Absorption</i></b>. While this marbled lavender and green ellipsoid orbits your head, you can use your reaction to cancel a spell of 8th level or lower cast by a creature you can see and targeting only you.\nOnce the stone has canceled 50 levels of spells, it burns out and turns dull gray, losing its magic. If you are targeted by a spell whose level is higher than the number of spell levels the stone has left, the stone can't cancel it.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Insight",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n<b><i>Insight</i></b>. Your Wisdom score increases by 2, to a maximum of 20, while this incandescent blue sphere orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Intellect",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Intellect</i></b>. Your Intelligence score increases by 2, to a maximum of 20, while this marbled scarlet and blue sphere orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Leadership",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Leadership</i></b>. Your Charisma score increases by 2, to a maximum of 20, while this marbled pink and green sphere orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Mastery",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Mastery</i></b>. Your proficiency bonus increases by 1 while this pale green prism orbits your head.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Protection",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Protection</i></b>. You gain a +1 bonus to AC while this dusty rose prism orbits your head.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Regeneration",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Regeneration</i></b>. You regain 15 hit points at the end of each hour this pearly white spindle orbits your head, provided that you have at least 1 hit point.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Reserve",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Reserve</i></b>. This vibrant purple prism stores spells cast into it, holding them until you use them. The stone can store up to 3 levels worth of spells at a time. When found, it contains 1d4 - 1 levels of stored spells chosen by the GM.\nAny creature can cast a spell of 1st through 3rd level into the stone by touching it as the spell is cast. The spell has no effect, other than to be stored in the stone. If the stone can't hold the spell, the spell is expended without effect. The level of the slot used to cast the spell determines how much space it uses.\nWhile this stone orbits your head, you can cast any spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell cast from the stone is no longer stored in it, freeing up space.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Strength",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Strength</i></b>. Your Strength score increases by 2, to a maximum of 20, while this pale blue rhomboid orbits your head.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ioun Stone of Sustenance",
      type: "Wondrous item",
      description:
        "An <i>Ioun stone</i> is named after Ioun, a god of knowledge and prophecy revered on some worlds.\nWhen you use an action to toss this stone into the air, the stone orbits your head at a distance of 1d3 feet and confers a benefit to you. Thereafter, another creature must use an action to grasp or net the stone to separate it from you, either by making a successful attack roll against AC 24 or a successful DC 24 Dexterity (Acrobatics) check. You can use an action to seize and stow the stone, ending its effect.\nThe stone has AC 24, 10 hit points, and resistance to all damage. It is considered to be an object that is being worn while it orbits your head.\n <b><i>Sustenance</i></b>. You don't need to eat or drink while this clear spindle orbits your head.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Iron Bands of Binding",
      type: "Wondrous item",
      description:
        "This rusty iron sphere measures 3 inches in diameter and weighs 1 pound. You can use an action to speak the command word and throw the sphere at a Huge or smaller creature you can see within 60 feet of you. As the sphere moves through the air, it opens into a tangle of metal bands.\nMake a ranged attack roll with an attack bonus equal to your Dexterity modifier plus your proficiency bonus. On a hit, the target is restrained until you take a bonus action to speak the command word again to release it. Doing so, or missing with the attack, causes the bands to contract and become a sphere once more.\nA creature, including the one restrained, can use an action to make a DC 20 Strength check to break the iron bands. On a success, the item is destroyed, and the restrained creature is freed. If the check fails, any further attempts made by that creature automatically fail until 24 hours have elapsed.\nOnce the bands are used, they can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Iron Flask",
      type: "Wondrous item",
      description:
        "This iron bottle has a brass stopper. You can use an action to speak the flask's command word, targeting a creature that you can see within 60 feet of you. If the target is native to a plane of existence other than the one you're on, the target must succeed on a DC 17 Wisdom saving throw or be trapped in the flask. If the target has been trapped by the flask before, it has advantage on the saving throw. Once trapped, a creature remains in the flask until released. The flask can hold only one creature at a time. A creature trapped in the flask doesn't need to breathe, eat, or drink and doesn't age.\nYou can use an action to remove the flask's stopper and release the creature the flask contains. The creature is friendly to you and your companions for 1 hour and obeys your commands for that duration. If you give no commands or give it a command that is likely to result in its death, it defends itself but otherwise takes no actions. At the end of the duration, the creature acts in accordance with its normal disposition and alignment.\nAn <i>identify</i> spell reveals that a creature is inside the flask, but the only way to determine the type of creature is to open the flask. A newly discovered bottle might already contain a creature chosen by the GM or determined randomly (see page 228 of the 5E SRD 5.1 for a random rolling table).",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Javelin of Lightning",
      type: "Weapon",
      subtype: "Javelin",
      description:
        "This javelin is a magic weapon. When you hurl it and speak its command word, it transforms into a bolt of lightning, forming a line 5 feet wide that extends out from you to a target within 120 feet. Each creature in the line excluding you and the target must make a DC 13 Dexterity saving throw, taking 4d6 lightning damage on a failed save, and half as much damage on a successful one. The lightning bolt turns back into a javelin when it reaches the target. Make a ranged weapon attack against the target. On a hit, the target takes damage from the javelin plus 4d6 lightning damage.\nThe javelin's property can't be used again until the next dawn. In the meantime, the javelin can still be used as a magic weapon.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Lantern of Revealing",
      type: "Wondrous item",
      description:
        "While lit, this hooded lantern burns for 6 hours on 1 pint of oil, shedding bright light in a 30-foot radius and dim light for an additional 30 feet. Invisible creatures and objects are visible as long as they are in the lantern's bright light. You can use an action to lower the hood, reducing the light to dim light in a 5 foot radius.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Luck Blade",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic weapon. While the sword is on your person, you also gain a +1 bonus to saving throws.\n<b><i>Luck</i></b>. If the sword is on your person, you can call on its luck (no action required) to reroll one attack roll, ability check, or saving throw you dislike. You must use the second roll. This property can't be used again until the next dawn.\n<b><i>Wish</i></b>. The sword has 1d4 - 1 charges. While holding it, you can use an action to expend 1 charge and cast the <i>wish</i> spell from it. This property can't be used again until the next dawn. The sword loses this property if it has no charges.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Mace of Disruption",
      type: "Weapon",
      subtype: "Mace",
      description:
        "When you hit a fiend or an undead with this magic weapon, that creature takes an extra 2d6 radiant damage. If the target has 25 hit points or fewer after taking this damage, it must succeed on a DC 15 Wisdom saving throw or be destroyed. On a successful save, the creature becomes frightened of you until the end of your next turn.\nWhile you hold this weapon, it sheds bright light in a 20-foot radius and dim light for an additional 20 feet.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Mace of Smiting",
      type: "Weapon",
      subtype: "Mace",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic weapon. The bonus increases to +3 when you use the mace to attack a construct.\nWhen you roll a 20 on an attack roll made with this weapon, the target takes an extra 2d6 bludgeoning damage, or 4d6 bludgeoning damage if it's a construct. If a construct has 25 hit points or fewer after taking this damage, it is destroyed.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Mace of Terror",
      type: "Weapon",
      subtype: "Mace",
      description:
        "This magic weapon has 3 charges. While holding it, you can use an action and expend 1 charge to release a wave of terror. Each creature of your choice in a 30-foot radius extending from you must succeed on a DC 15 Wisdom saving throw or become frightened of you for 1 minute. While it is frightened in this way, a creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If it has nowhere it can move, the creature can use the Dodge action. At the end of each of its turns, a creature can repeat the saving throw, ending the effect on itself on a success.\nThe mace regains 1d3 expended charges daily at dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Mantle of Spell Resistance",
      type: "Wondrous item",
      description:
        "You have advantage on saving throws against spells while you wear this cloak.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Manual of Bodily Health",
      type: "Wondrous item",
      description:
        "This book contains health and diet tips, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Constitution score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Manual of Gainful Exercise",
      type: "Wondrous item",
      description:
        "This book describes fitness exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Strength score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Manual of Golems",
      type: "Wondrous item",
      description:
        "This tome contains information and incantations necessary to make a particular type of golem. The GM chooses the type or determines it randomly. To decipher and use the manual, you must be a spellcaster with at least two 5th-level spell slots. A creature that can't use a <i>manual of golems</i> and attempts to read it takes 6d6 psychic damage.\n d20    Golem  Time      Cost       \n\n 1-5    Clay   30 days   65,000 gp  \n 6-17   Flesh  60 days   50,000 gp  \n 18     Iron   120 days  100,000 gp \n 19-20  Stone  90 days   80,000 gp  \nTo create a golem, you must spend the time shown on the table, working without interruption with the manual at hand and resting no more than 8 hours per day. You must also pay the specified cost to purchase supplies.\nOnce you finish creating the golem, the book is consumed in eldritch flames. The golem becomes animate when the ashes of the manual are sprinkled on it. It is under your control, and it understands and obeys your spoken commands.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Manual of Quickness of Action",
      type: "Wondrous item",
      description:
        "This book contains coordination and balance exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Dexterity score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Marvelous Pigments",
      type: "Wondrous item",
      description:
        "Typically found in 1d4 pots inside a fine wooden box with a brush (weighing 1 pound in total), these pigments allow you to create three-dimensional objects by painting them in two dimensions. The paint flows from the brush to form the desired object as you concentrate on its image.\nEach pot of paint is sufficient to cover 1,000 square feet of a surface, which lets you create inanimate objects or terrain features-such as a door, a pit, flowers, trees, cells, rooms, or weapons- that are up to 10,000 cubic feet. It takes 10 minutes to cover 100 square feet.\nWhen you complete the painting, the object or terrain feature depicted becomes a real, nonmagical object. Thus, painting a door on a wall creates an actual door that can be opened to whatever is beyond. Painting a pit on a floor creates a real pit, and its depth counts against the total area of objects you create.\nNothing created by the pigments can have a value greater than 25 gp. If you paint an object of greater value (such as a diamond or a pile of gold), the object looks authentic, but close inspection reveals it is made from paste, bone, or some other worthless material.\nIf you paint a form of energy such as fire or lightning, the energy appears but dissipates as soon as you complete the painting, doing no harm to anything.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Medallion of Thoughts",
      type: "Wondrous item",
      description:
        "The medallion has 3 charges. While wearing it, you can use an action and expend 1 charge to cast the <i>detect thoughts</i> spell (save DC 13) from it. The medallion regains 1d3 expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Mirror of Life Trapping",
      type: "Wondrous item",
      description:
        "When this 4-foot-tall mirror is viewed indirectly, its surface shows faint images of creatures. The mirror weighs 50 pounds, and it has AC 11, 10 hit points, and vulnerability to bludgeoning damage. It shatters and is destroyed when reduced to 0 hit points.\nIf the mirror is hanging on a vertical surface and you are within 5 feet of it, you can use an action to speak its command word and activate it. It remains activated until you use an action to speak the command word again.\nAny creature other than you that sees its reflection in the activated mirror while within 30 feet of it must succeed on a DC 15 Charisma saving throw or be trapped, along with anything it is wearing or carrying, in one of the mirror's twelve extradimensional cells. This saving throw is made with advantage if the creature knows the mirror's nature, and constructs succeed on the saving throw automatically.\nAn extradimensional cell is an infinite expanse filled with thick fog that reduces visibility to 10 feet. Creatures trapped in the mirror's cells don't age, and they don't need to eat, drink, or sleep. A creature trapped within a cell can escape using magic that permits planar travel. Otherwise, the creature is confined to the cell until freed.\nIf the mirror traps a creature but its twelve extradimensional cells are already occupied, the mirror frees one trapped creature at random to accommodate the new prisoner. A freed creature appears in an unoccupied space within sight of the mirror but facing away from it. If the mirror is shattered, all creatures it contains are freed and appear in unoccupied spaces near it.\nWhile within 5 feet of the mirror, you can use an action to speak the name of one creature trapped in it or call out a particular cell by number. The creature named or contained in the named cell appears as an image on the mirror's surface. You and the creature can then communicate normally.\nIn a similar way, you can use an action to speak a second command word and free one creature trapped in the mirror. The freed creature appears, along with its possessions, in the unoccupied space nearest to the mirror and facing away from it.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Mithral Armor",
      type: "Armor",
      subtype: "Medium or heavy",
      description:
        "Mithral is a light, flexible metal. A mithral chain shirt or breastplate can be worn under normal clothes. If the armor normally imposes disadvantage on Dexterity (Stealth) checks or has a Strength requirement, the mithral version of the armor doesn't.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Necklace of Adaptation",
      type: "Wondrous item",
      description:
        "While wearing this necklace, you can breathe normally in any environment, and you have advantage on saving throws made against harmful gases and vapors (such as <i>cloudkill</i> and <i>stinking cloud</i> effects, inhaled poisons, and the breath weapons of some dragons).",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Necklace of Fireballs",
      type: "Wondrous item",
      description:
        "This necklace has 1d6 + 3 beads hanging from it. You can use an action to detach a bead and throw it up to 60 feet away. When it reaches the end of its trajectory, the bead detonates as a 3rd-level <i>fireball</i> spell (save DC 15).\nYou can hurl multiple beads, or even the whole necklace, as one action. When you do so, increase the level of the <i>fireball</i> by 1 for each bead beyond the first.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Necklace of Prayer Beads",
      type: "Wondrous item",
      description:
        "This necklace has [option] magic beads made from aquamarine, black pearl, or topaz. It also has many nonmagical beads made from stones such as amber, bloodstone, citrine, coral, jade, pearl, or quartz. If a magic bead is removed from the necklace, that bead loses its magic.\nSix types of magic beads exist. The GM decides the type of each bead on the necklace or determines it randomly. A necklace can have more than one bead of the same type. To use one, you must be wearing the necklace. Each bead contains a spell that you can cast from it as a bonus action (using your spell save DC if a save is necessary). Once a magic bead's spell is cast, that bead can't be used again until the next dawn.\n Roll a d20. 1-6: Blessing (<i>bless</i>); 7-12: Curing (<i>cure wounds</i> (2nd level) or <i>lesser restoration</i>); 13-16: Favor (<i>greater restoration</i>; 17-18: Smiting (<i>branding smite</i>); 19: Summons (<i>planar ally</i>), 20: Wind walking (<i>wind walk</i>)",
      rarity: "Rare",
      attunement: "Requires attunement by a cleric, druid, or paladin",
      optionName: "Beads:",
      options: [
        [
          { name: 3, value: 3 },
          { name: 4, value: 4 },
          { name: 5, value: 5 },
          { name: 6, value: 6 },
          { name: 7, value: 7 },
          { name: 8, value: 8 },
        ],
      ],
      source: "srd",
    },
    {
      name: "Nine Lives Stealer",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "You gain a +2 bonus to attack and damage rolls made with this magic weapon.\nThe sword has [option] charges. If you score a critical hit against a creature that has fewer than 100 hit points, it must succeed on a DC 15 Constitution saving throw or be slain instantly as the sword tears its life force from its body (a construct or an undead is immune). The sword loses 1 charge if the creature is slain. When the sword has no charges remaining, it loses this property.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      optionName: "Charges:",
      options: [
        [
          { name: 2, value: 2 },
          { name: 3, value: 3 },
          { name: 4, value: 4 },
          { name: 5, value: 5 },
          { name: 6, value: 6 },
          { name: 7, value: 7 },
          { name: 8, value: 8 },
          { name: 9, value: 9 },
        ],
      ],
      source: "srd",
    },
    {
      name: "Oathbow",
      type: "Weapon",
      subtype: "Longbow",
      description:
        '<p>When you nock an arrow on this bow, it whispers in Elvish, "Swift defeat to my enemies." When you use this weapon to make a ranged attack, you can, as a command phrase, say, "Swift death to you who have wronged me." The target of your attack becomes your sworn enemy until it dies or until dawn seven days later. You can have only one such sworn enemy at a time. When your sworn enemy dies, you can choose a new one after the next dawn.\nWhen you make a ranged attack roll with this weapon against your sworn enemy, you have advantage on the roll. In addition, your target gains no benefit from cover, other than total cover, and you suffer no disadvantage due to long range. If the attack hits, your sworn enemy takes an extra 3d6 piercing damage.\nWhile your sworn enemy lives, you have disadvantage on attack rolls with all other weapons.',
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Oil of Etherealness",
      type: "Potion",
      description:
        "Beads of this cloudy gray oil form on the outside of its container and quickly evaporate. The oil can cover a Medium or smaller creature, along with the equipment it's wearing and carrying (one additional vial is required for each size category above Medium). Applying the oil takes 10 minutes. The affected creature then gains the effect of the <i>etherealness</i> spell for 1 hour.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Oil of Sharpness",
      type: "Potion",
      description:
        "This clear, gelatinous oil sparkles with tiny, ultrathin silver shards. The oil can coat one slashing or piercing weapon or up to 5 pieces of slashing or piercing ammunition. Applying the oil takes 1 minute. For 1 hour, the coated item is magical and has a +3 bonus to attack and damage rolls.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Oil of Slipperiness",
      type: "Potion",
      description:
        "This sticky black unguent is thick and heavy in the container, but it flows quickly when poured. The oil can cover a Medium or smaller creature, along with the equipment it's wearing and carrying (one additional vial is required for each size category above Medium). Applying the oil takes 10 minutes. The affected creature then gains the effect of a <i>freedom of movement</i> spell for 8 hours.\nAlternatively, the oil can be poured on the ground as an action, where it covers a 10-foot square, duplicating the effect of the <i>grease</i> spell in that area for 8 hours.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Pearl of Power",
      type: "Wondrous item",
      description:
        "While this pearl is on your person, you can use an action to speak its command word and regain one expended spell slot. If the expended slot was of 4th level or higher, the new slot is 3rd level. Once you use the pearl, it can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Periapt of Health",
      type: "Wondrous item",
      description:
        "You are immune to contracting any disease while you wear this pendant. If you are already infected with a disease, the effects of the disease are suppressed you while you wear the pendant.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Periapt of Proof against Poison",
      type: "Wondrous item",
      description:
        "This delicate silver chain has a brilliant-cut black gem pendant. While you wear it, poisons have no effect on you. You are immune to the poisoned condition and have immunity to poison damage.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Periapt of Wound Closure",
      type: "Wondrous item",
      description:
        "While you wear this pendant, you stabilize whenever you are dying at the start of your turn. In addition, whenever you roll a Hit Die to regain hit points, double the number of hit points it restores.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Philter of Love",
      type: "Potion",
      description:
        "The next time you see a creature within 10 minutes after drinking this philter, you become charmed by that creature for 1 hour. If the creature is of a species and gender you are normally attracted to, you regard it as your true love while you are charmed. This potion's rose-hued, effervescent liquid contains one easy-to-miss bubble shaped like a heart.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Pipes of Haunting",
      type: "Wondrous item",
      description:
        "You must be proficient with wind instruments to use these pipes. They have 3 charges. You can use an action to play them and expend 1 charge to create an eerie, spellbinding tune. Each creature within 30 feet of you that hears you play must succeed on a DC 15 Wisdom saving throw or become frightened of you for 1 minute. If you wish, all creatures in the area that aren't hostile toward you automatically succeed on the saving throw. A creature that fails the saving throw can repeat it at the end of each of its turns, ending the effect on itself on a success. A creature that succeeds on its saving throw is immune to the effect of these pipes for 24 hours. The pipes regain 1d3 expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Pipes of the Sewers",
      type: "Wondrous item",
      description:
        "You must be proficient with wind instruments to use these pipes. While you are attuned to the pipes, ordinary rats and giant rats are indifferent toward you and will not attack you unless you threaten or harm them.\nThe pipes have 3 charges. If you play the pipes as an action, you can use a bonus action to expend 1 to 3 charges, calling forth one swarm of rats with each expended charge, provided that enough rats are within half a mile of you to be called in this fashion (as determined by the GM). If there aren't enough rats to form a swarm, the charge is wasted. Called swarms move toward the music by the shortest available route but aren't under your control otherwise. The pipes regain 1d3 expended charges daily at dawn.\nWhenever a swarm of rats that isn't under another creature's control comes within 30 feet of you while you are playing the pipes, you can make a Charisma check contested by the swarm's Wisdom check. If you lose the contest, the swarm behaves as it normally would and can't be swayed by the pipes' music for the next 24 hours. If you win the contest, the swarm is swayed by the pipes' music and becomes friendly to you and your companions for as long as you continue to play the pipes each round as an action. A friendly swarm obeys your commands. If you issue no commands to a friendly swarm, it defends itself but otherwise takes no actions. If a friendly swarm starts its turn and can't hear the pipes' music, your control over that swarm ends, and the swarm behaves as it normally would and can't be swayed by the pipes' music for the next 24 hours.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Plate of Etherealness",
      type: "Armor",
      subtype: "Plate",
      description:
        "While you're wearing this armor, you can speak its command word as an action to gain the effect of the <i>etherealness</i> spell, which last for 10 minutes or until you remove the armor or use an action to speak the command word again. This property of the armor can't be used again until the next dawn.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Portable Hole",
      type: "Wondrous item",
      description:
        "This fine black cloth, soft as silk, is folded up to the dimensions of a handkerchief. It unfolds into a circular sheet 6 feet in diameter.\nYou can use an action to unfold a <i>portable hole</i> and place it on or against a solid surface, whereupon the <i>portable hole</i> creates an extradimensional hole 10 feet deep. The cylindrical space within the hole exists on a different plane, so it can't be used to create open passages. Any creature inside an open <i>portable hole</i> can exit the hole by climbing out of it.\nYou can use an action to close a <i>portable hole</i> by taking hold of the edges of the cloth and folding it up. Folding the cloth closes the hole, and any creatures or objects within remain in the extradimensional space. No matter what's in it, the hole weighs next to nothing.\nIf the hole is folded up, a creature within the hole's extradimensional space can use an action to make a DC 10 Strength check. On a successful check, the creature forces its way out and appears within 5 feet of the <i>portable hole</i> or the creature carrying it. A breathing creature within a closed <i>portable hole</i> can survive for up to 10 minutes, after which time it begins to suffocate.\nPlacing a <i>portable hole</i> inside an extradimensional space created by a <i>bag of holding</i>, <i>handy haversack</i>, or similar item instantly destroys both items and opens a gate to the Astral Plane. The gate originates where the one item was placed inside the other. Any creature within 10 feet of the gate is sucked through it and deposited in a random location on the Astral Plane. The gate then closes. The gate is one-way only and can't be reopened.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Animal Friendship",
      type: "Potion",
      description:
        "When you drink this potion, you can cast the <i>animal friendship</i> spell (save DC 13) for 1 hour at will. Agitating this muddy liquid brings little bits into view: a fish scale, a hummingbird tongue, a cat claw, or a squirrel hair.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Clairvoyance",
      type: "Potion",
      description:
        "When you drink this potion, you gain the effect of the <i>clairvoyance</i> spell. An eyeball bobs in this yellowish liquid but vanishes when the potion is opened.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Climbing",
      type: "Potion",
      description:
        "When you drink this potion, you gain a climbing speed equal to your walking speed for 1 hour. During this time, you have advantage on Strength (Athletics) checks you make to climb. The potion is separated into brown, silver, and gray layers resembling bands of stone. Shaking the bottle fails to mix the colors.",
      rarity: "Common",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Diminution",
      type: "Potion",
      description:
        '<p>When you drink this potion, you gain the "reduce" effect of the <i>enlarge/reduce</i> spell for 1d4 hours (no concentration required). The red in the potion\'s liquid continuously contracts to a tiny bead and then expands to color the clear liquid around it. Shaking the bottle fails to interrupt this process.',
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Flying",
      type: "Potion",
      description:
        "When you drink this potion, you gain a flying speed equal to your walking speed for 1 hour and can hover. If you're in the air when the potion wears off, you fall unless you have some other means of staying aloft. This potion's clear liquid floats at the top of its container and has cloudy white impurities drifting in it.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Gaseous Form",
      type: "Potion",
      description:
        "When you drink this potion, you gain the effect of the <i>gaseous form</i> spell for 1 hour (no concentration required) or until you end the effect as a bonus action. This potion's container seems to hold fog that moves and pours like water.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Hill Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 21 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a hill giant.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Frost Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 23 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a frost giant.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Stone Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 23 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a stone giant.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Fire Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 25 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a fire giant.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Cloud Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 27 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a cloud giant.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Storm Giant Strength",
      type: "Potion",
      description:
        "When you drink this potion, your Strength score changes to 29 for 1 hour. The potion has no effect on you if your Strength is equal to or greater than that score.\nThis potion's transparent liquid has floating in it a sliver of fingernail from a storm giant.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Growth",
      type: "Potion",
      description:
        '<p>When you drink this potion, you gain the "enlarge" effect of the <i>enlarge/reduce</i> spell for 1d4 hours (no concentration required). The red in the potion\'s liquid continuously expands from a tiny bead to color the clear liquid around it and then contracts. Shaking the bottle fails to interrupt this process.',
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Healing",
      type: "Potion",
      description:
        "You regain 2d4 + 2 hit points when you drink this potion. The potion's red liquid glimmers when agitated.",
      rarity: "Common",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Greater Healing",
      type: "Potion",
      description:
        "You regain 4d4 + 4 hit points when you drink this potion. The potion's red liquid glimmers when agitated.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Superior Healing",
      type: "Potion",
      description:
        "You regain 8d4 + 8 hit points when you drink this potion. The potion's red liquid glimmers when agitated.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Supreme Healing",
      type: "Potion",
      description:
        "You regain 10d4 + 20 hit points when you drink this potion. The potion's red liquid glimmers when agitated.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Heroism",
      type: "Potion",
      description:
        "For 1 hour after drinking it, you gain 10 temporary hit points that last for 1 hour. For the same duration, you are under the effect of the <i>bless</i> spell (no concentration required). This blue potion bubbles and steams as if boiling.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Invisibility",
      type: "Potion",
      description:
        "This potion's container looks empty but feels as though it holds liquid. When you drink it, you become invisible for 1 hour. Anything you wear or carry is invisible with you. The effect ends early if you attack or cast a spell.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Mind Reading",
      type: "Potion",
      description:
        "When you drink this potion, you gain the effect of the <i>detect thoughts</i> spell (save DC 13). The potion's dense, purple liquid has an ovoid cloud of pink floating in it.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Poison",
      type: "Potion",
      description:
        "This concoction looks, smells, and tastes like a <i>potion of healing</i> or other beneficial potion. However, it is actually poison masked by illusion magic. An <i>identify</i> spell reveals its true nature.\nIf you drink it, you take 3d6 poison damage, and you must succeed on a DC 13 Constitution saving throw or be poisoned. At the start of each of your turns while you are poisoned in this way, you take 3d6 poison damage. At the end of each of your turns, you can repeat the saving throw. On a successful save, the poison damage you take on your subsequent turns decreases by 1d6. The poison ends when the damage decreases to 0.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Resistance",
      type: "Potion",
      description:
        "When you drink this potion, you gain resistance to [option] damage for 1 hour.",
      rarity: "Uncommon",
      attunement: "No",
      optionName: "Resistance:",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Potion of Speed",
      type: "Potion",
      description:
        "When you drink this potion, you gain the effect of the <i>haste</i> spell for 1 minute (no concentration required). The potion's yellow fluid is streaked with black and swirls on its own.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Potion of Water Breathing",
      type: "Potion",
      description:
        "You can breathe underwater for 1 hour after drinking this potion. Its cloudy green fluid smells of the sea and has a jellyfish-like bubble floating in it.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Restorative Ointment",
      type: "Wondrous item",
      description:
        "This glass jar, 3 inches in diameter, contains 1d4 + 1 doses of a thick mixture that smells faintly of aloe. The jar and its contents weigh 1/2 pound.\nAs an action, one dose of the ointment can be swallowed or applied to the skin. The creature that receives it regains 2d8 + 2 hit points, ceases to be poisoned, and is cured of any disease.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ring of Animal Influence",
      type: "Ring",
      description:
        "This ring has 3 charges, and it regains 1d3 expended charges daily at dawn. While wearing the ring, you can use an action to expend 1 of its charges to cast one of the following spells:<p>&#8226; <i>Animal friendship</i> (save DC 13)\n &#8226; <i>Fear</i> (save DC 13), targeting only beasts that have an Intelligence of 3 or lower\n&#8226;	<i>Speak with animals</i>",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ring of Djinni Summoning",
      type: "Ring",
      description:
        "While wearing this ring, you can speak its command word as an action to summon a particular djinni from the Elemental Plane of Air. The djinni appears in an unoccupied space you choose within 120 feet of you. It remains as long as you concentrate (as if concentrating on a spell), to a maximum of 1 hour, or until it drops to 0 hit points. It then returns to its home plane.\nWhile summoned, the djinni is friendly to you and your companions. It obeys any commands you give it, no matter what language you use. If you fail to command it, the djinni defends itself against attackers but takes no other actions.\nAfter the djinni departs, it can't be summoned again for 24 hours, and the ring becomes nonmagical if the djinni dies.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Elemental Command",
      type: "Ring",
      description: "[option]",
      rarity: "Legendary",
      attunement: "Requires attunement",
      optionName: "Element:",
      options: [
        [
          {
            name: "Air",
            value:
              "While wearing this ring, you have advantage on attack rolls against elementals from the air plane, and they have disadvantage on attack rolls against you.\nThe ring has 5 charges. It regains 1d4 + 1 expended charges daily at dawn. Spells cast from the ring have a save DC of 17.\n<b><i>Ring of Air Elemental Command</b></i>. You can expend 2 of the ring's charges to cast<i>dominate monster</i> on an air elemental. In addition, when you fall, you descend 60 feet per round and take no damage from falling. You can also speak and understand Auran.\nIf you help slay an air elemental while attuned to the ring, you gain access to the following additional properties:\n&#8226; You have resistance to lightning damage.\n&#8226; You have a flying speed equal to your walking speed and can hover.\n&#8226; You can cast the following spells from the ring, expending the necessary number of charges:<i>chain lightning</i> (3 charges),<i>gust of wind</i> (2 charges), or<i>wind wall</i> (1 charge).",
          },
          {
            name: "Earth",
            value:
              "While wearing this ring, you have advantage on attack rolls against elementals from the earth plane, and they have disadvantage on attack rolls against you.\nThe ring has 5 charges. It regains 1d4 + 1 expended charges daily at dawn. Spells cast from the ring have a save DC of 17.\n<b><i>Ring of Earth Elemental Command</b></i>. You can expend 2 of the ring's charges to cast<i>dominate monster</i> on an earth elemental. In addition, you can move in difficult terrain that is composed of rubble, rocks, or dirt as if it were normal terrain. You can also speak and understand Terran.\nIf you help slay an earth elemental while attuned to the ring, you gain access to the following additional properties:\n&#8226; You have resistance to acid damage.\n&#8226; You can move through solid earth or rock as if those areas were difficult terrain. If you end your turn there, you are shunted out to the nearest unoccupied space you last occupied.\n&#8226; You can cast the following spells from the ring, expending the necessary number of charges:<i>stone shape</i> (2 charges),<i>stoneskin</i> (3 charges), or<i>wall of stone</i> (3 charges).",
          },
          {
            name: "Fire",
            value:
              "While wearing this ring, you have advantage on attack rolls against elementals from the fire plane, and they have disadvantage on attack rolls against you.\nThe ring has 5 charges. It regains 1d4 + 1 expended charges daily at dawn. Spells cast from the ring have a save DC of 17.\n<b><i>Ring of Fire Elemental Command</b></i>. You can expend 2 of the ring's charges to cast<i>dominate monster</i> on a fire elemental. In addition, you have resistance to fire damage. You can also speak and understand Ignan.\nIf you help slay a fire elemental while attuned to the ring, you gain access to the following additional properties:\n&#8226; You are immune to fire damage.\n&#8226; You can cast the following spells from the ring, expending the necessary number of charges:<i>burning hands</i> (1 charge),<i>fireball</i> (2 charges), and<i>wall of fire</i> (3 charges).",
          },
          {
            name: "Water",
            value:
              "While wearing this ring, you have advantage on attack rolls against elementals from the water plane, and they have disadvantage on attack rolls against you.\nThe ring has 5 charges. It regains 1d4 + 1 expended charges daily at dawn. Spells cast from the ring have a save DC of 17.\n<b><i>Ring of Water Elemental Command</b></i>. You can expend 2 of the ring's charges to cast<i>dominate monster</i> on a water elemental. In addition, you can stand on and walk across liquid surfaces as if they were solid ground. You can also speak and understand Aquan.\nIf you help slay a water elemental while attuned to the ring, you gain access to the following additional properties:\n&#8226; You can breathe underwater and have a swimming speed equal to your walking speed.\n&#8226; You can cast the following spells from the ring, expending the necessary number of charges:<i>create or destroy water</i> (1 charge),<i>control water</i> (3 charges),<i>ice storm</i> (2 charges), or<i>wall of ice</i> (3 charges).",
          },
        ],
      ],
      source: "srd",
    },
    {
      name: "Ring of Evasion",
      type: "Ring",
      description:
        "This ring has 3 charges, and it regains 1d3 expended charges daily at dawn. When you fail a Dexterity saving throw while wearing it, you can use your reaction to expend 1 of its charges to succeed on that saving throw instead.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Feather Falling",
      type: "Ring",
      description:
        "When you fall while wearing this ring, you descend 60 feet per round and take no damage from falling.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Free Action",
      type: "Ring",
      description:
        "While you wear this ring, difficult terrain doesn't cost you extra movement. In addition, magic can neither reduce your speed nor cause you to be paralyzed or restrained.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Invisibility",
      type: "Ring",
      description:
        "While wearing this ring, you can turn invisible as an action. Anything you are wearing or carrying is invisible with you. You remain invisible until the ring is removed, until you attack or cast a spell, or until you use a bonus action to become visible again.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Jumping",
      type: "Ring",
      description:
        "While wearing this ring, you can cast the <i>jump</i> spell from it as a bonus action at will, but can target only yourself when you do so.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Mind Shielding",
      type: "Ring",
      description:
        "While wearing this ring, you are immune to magic that allows other creatures to read your thoughts, determine whether you are lying, know your alignment, or know your creature type. Creatures can telepathically communicate with you only if you allow it.\nYou can use an action to cause the ring to become invisible until you use another action to make it visible, until you remove the ring, or until you die.\nIf you die while wearing the ring, your soul enters it, unless it already houses a soul. You can remain in the ring or depart for the afterlife. As long as your soul is in the ring, you can telepathically communicate with any creature wearing it. A wearer can't prevent this telepathic communication.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Protection",
      type: "Ring",
      description:
        "You gain a +1 bonus to AC and saving throws while wearing this ring.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Regeneration",
      type: "Ring",
      description:
        "While wearing this ring, you regain 1d6 hit points every 10 minutes, provided that you have at least 1 hit point. If you lose a body part, the ring causes the missing part to regrow and return to full functionality after 1d6 + 1 days if you have at least 1 hit point the whole time.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Resistance",
      type: "Ring",
      description:
        "You have resistance to [option] damage while wearing this ring.",
      rarity: "Rare",
      attunement: "Requires attunement",
      optionName: "Resistance:",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Ring of Shooting Stars",
      type: "Ring",
      description:
        "While wearing this ring in dim light or darkness, you can cast <i>dancing lights</i> and <i>light</i> from the ring at will. Casting either spell from the ring requires an action.\nThe ring has 6 charges for the following other properties. The ring regains 1d6 expended charges daily at dawn.\n<b><i>Faerie Fire</i></b>. You can expend 1 charge as an action to cast <i>faerie fire</i> from the ring.\n<b><i>Ball Lightning</i></b>. You can expend 2 charges as an action to create one to four 3-foot-diameter spheres of lightning. The more spheres you create, the less powerful each sphere is individually.\nEach sphere appears in an unoccupied space you can see within 120 feet of you. The spheres last as long as you concentrate (as if concentrating on a spell), up to 1 minute. Each sphere sheds dim light in a 30-foot radius.\nAs a bonus action, you can move each sphere up to 30 feet, but no farther than 120 feet away from you. When a creature other than you comes within 5 feet of a sphere, the sphere discharges lightning at that creature and disappears. That creature must make a DC 15 Dexterity saving throw. On a failed save, the creature takes lightning damage based on the number of spheres you created (1: 412; 2: 5d4; 3: 2d6; 4: 2d4).\n<b><i>Shooting Stars</i></b>. You can expend 1 to 3 charges as an action. For every charge you expend, you launch a glowing mote of light from the ring at a point you can see within 60 feet of you. Each creature within a 15-foot cube originating from that point is showered in sparks and must make a DC 15 Dexterity saving throw, taking 5d4 fire damage on a failed save, or half as much damage on a successful one.",
      rarity: "Very Rare",
      attunement: "Requires attunement outdoors at night",
      source: "srd",
    },
    {
      name: "Ring of Spell Storing",
      type: "Ring",
      description:
        "This ring stores spells cast into it, holding them until the attuned wearer uses them. The ring can store up to 5 levels worth of spells at a time. When found, it contains 1d6 - 1 levels of stored spells chosen by the GM.\nAny creature can cast a spell of 1st through 5th level into the ring by touching the ring as the spell is cast. The spell has no effect, other than to be stored in the ring. If the ring can't hold the spell, the spell is expended without effect. The level of the slot used to cast the spell determines how much space it uses.\nWhile wearing this ring, you can cast any spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell cast from the ring is no longer stored in it, freeing up space.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Spell Turning",
      type: "Ring",
      description:
        "While wearing this ring, you have advantage on saving throws against any spell that targets only you (not in an area of effect). In addition, if you roll a 20 for the save and the spell is 7th level or lower, the spell has no effect on you and instead targets the caster, using the slot level, spell save DC, attack bonus, and spellcasting ability of the caster.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Swimming",
      type: "Ring",
      description:
        "You have a swimming speed of 40 feet while wearing this ring.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ring of Telekinesis",
      type: "Ring",
      description:
        "While wearing this ring, you can cast the <i>telekinesis</i> spell at will, but you can target only objects that aren't being worn or carried.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of the Ram",
      type: "Ring",
      description:
        "This ring has 3 charges, and it regains 1d3 expended charges daily at dawn. While wearing the ring, you can use an action to expend 1 to 3 of its charges to attack one creature you can see within 60 feet of you. The ring produces a spectral ram's head and makes its attack roll with a +7 bonus. On a hit, for each charge you spend, the target takes 2d10 force damage and is pushed 5 feet away from you.\nAlternatively, you can expend 1 to 3 of the ring's charges as an action to try to break an object you can see within 60 feet of you that isn't being worn or carried. The ring makes a Strength check with a +5 bonus for each charge you spend.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Three Wishes",
      type: "Ring",
      description:
        "While wearing this ring, you can use an action to expend 1 of its 3 charges to cast the <i>wish</i> spell from it. The ring becomes nonmagical when you use the last charge.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ring of Warmth",
      type: "Ring",
      description:
        "While wearing this ring, you have resistance to cold damage. In addition, you and everything you wear and carry are unharmed by temperatures as low as -50 degrees Fahrenheit.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Ring of Water Walking",
      type: "Ring",
      description:
        "While wearing this ring, you can stand on and move across any liquid surface as if it were solid ground.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Ring of X-ray Vision",
      type: "Ring",
      description:
        "While wearing this ring, you can use an action to speak its command word. When you do so, you can see into and through solid matter for 1 minute. This vision has a radius of 30 feet. To you, solid objects within that radius appear transparent and don't prevent light from passing through them. The vision can penetrate 1 foot of stone, 1 inch of common metal, or up to 3 feet of wood or dirt. Thicker substances block the vision, as does a thin sheet of lead.\nWhenever you use the ring again before taking a long rest, you must succeed on a DC 15 Constitution saving throw or gain one level of exhaustion.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Robe of Eyes",
      type: "Wondrous item",
      description:
        "This robe is adorned with eyelike patterns. While you wear the robe, you gain the following benefits:\n&#8226; The robe lets you see in all directions, and you have advantage on Wisdom (Perception) checks that rely on sight.\n&#8226; You have darkvision out to a range of 120 feet.\n&#8226; You can see invisible creatures and objects, as well as see into the Ethereal Plane, out to a range of 120 feet.</p>\nThe eyes on the robe can't be closed or averted. Although you can close or avert your own eyes, you are never considered to be doing so while wearing this robe.\nA <i>light</i> spell cast on the robe or a <i>daylight</i> spell cast within 5 feet of the robe causes you to be blinded for 1 minute. At the end of each of your turns, you can make a Constitution saving throw (DC 11 for <i>light</i> or DC 15 for <i>daylight</i>), ending the blindness on a success.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Robe of Scintillating Colors",
      type: "Wondrous item",
      description:
        "This robe has 3 charges, and it regains 1d3 expended charges daily at dawn. While you wear it, you can use an action and expend 1 charge to cause the garment to display a shifting pattern of dazzling hues until the end of your next turn. During this time, the robe sheds bright light in a 30-foot radius and dim light for an additional 30 feet. Creatures that can see you have disadvantage on attack rolls against you. In addition, any creature in the bright light that can see you when the robe's power is activated must succeed on a DC 15 Wisdom saving throw or become stunned until the effect ends.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Robe of Stars",
      type: "Wondrous item",
      description:
        "This black or dark blue robe is embroidered with small white or silver stars. You gain a +1 bonus to saving throws while you wear it.\nSix stars, located on the robe's upper front portion, are particularly large. While wearing this robe, you can use an action to pull off one of the stars and use it to cast <i>magic missile</i> as a 5th-level spell. Daily at dusk, 1d6 removed stars reappear on the robe.\nWhile you wear the robe, you can use an action to enter the Astral Plane along with everything you are wearing and carrying. You remain there until you use an action to return to the plane you were on. You reappear in the last space you occupied, or if that space is occupied, the nearest unoccupied space.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Robe of the Archmagi",
      type: "Wondrous item",
      description:
        "This elegant garment is made from exquisite cloth of white, gray, or black and adorned with silvery runes. The robe's color corresponds to the alignment for which the item was created. A white robe was made for good, gray for neutral, and black for evil. You can't attune to a <i>robe of the archmagi</i> that doesn't correspond to your alignment.\nYou gain these benefits while wearing the robe:\n&#8226; If you aren't wearing armor, your base Armor Class is 15 + your Dexterity modifier.\n&#8226; You have advantage on saving throws against spells and other magical effects.\n&#8226; Your spell save DC and spell attack bonus each increase by 2.</p>",
      rarity: "Legendary",
      attunement: "Requires attunement by a sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Robe of Useful Items",
      type: "Wondrous item",
      description:
        "This robe has cloth patches of various shapes and colors covering it. While wearing the robe, you can use an action to detach one of the patches, causing it to become the object or creature it represents. Once the last patch is removed, the robe becomes an ordinary garment.\nThe robe has two of each of the following patches: dagger, bullseye lantern (filled and lit), steel mirror, 10-foot pole, hempen rope (50 feet, coiled), and sack.\nIn addition, the robe has 4d4 other patches. The GM chooses the patches or determines them random (roll a d100). </p><li><span>01-08 \u2013 Bag of 100 gp</li><li><span>09-15 \u2013 Silver coffer (1 foot long, 6 inches wide and deep) worth 500 gp</li><li><span>16-22 \u2013 Iron door (up to 10 feet wide and 10 feet high, barred on one side of your choice), which you can place in an opening you can reach; it conforms to fit the opening, attaching and hinging itself </li><li><span>23-30   10 gems worth 100 gp each</li><li><span>31-44   Wooden ladder (24 feet long)</li><li><span>45-51 A riding horse with saddle bags</li><li><span>52-59 \u2013 Pit (a cube 10 feet on a side), which you can place on the ground within 10 feet of you</li><li><span>60-68 \u2013 4 potions of healing</li><li><span>69-75 \u2013 Rowboat (12 feet long)</li><li><span>76-83 \u2013 Spell scroll containing one spell of 1st to 3rd level</li><li><span>84-90 \u2013 2 mastiffs</li><li><span>91-96 \u2013 Window (2 feet by 4 feet, up to 2 feet deep), which you can place on a vertical surface you can reach</li><li><span>97-100 \u2013 Portable ram",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Rod of Absorption",
      type: "Rod",
      description:
        "While holding this rod, you can use your reaction to absorb a spell that is targeting only you and not with an area of effect. The absorbed spell's effect is canceled, and the spell's energy-not the spell itself-is stored in the rod. The energy has the same level as the spell when it was cast. The rod can absorb and store up to 50 levels of energy over the course of its existence. Once the rod absorbs 50 levels of energy, it can't absorb more. If you are targeted by a spell that the rod can't store, the rod has no effect on that spell.\nWhen you become attuned to the rod, you know how many levels of energy the rod has absorbed over the course of its existence, and how many levels of spell energy it currently has stored.\nIf you are a spellcaster holding the rod, you can convert energy stored in it into spell slots to cast spells you have prepared or know. You can create spell slots only of a level equal to or lower than your own spell slots, up to a maximum of 5th level. You use the stored levels in place of your slots, but otherwise cast the spell as normal. For example, you can use 3 levels stored in the rod as a 3rd-level spell slot.\nA newly found rod has 1d10 levels of spell energy stored in it already. A rod that can no longer absorb spell energy and has no energy remaining becomes nonmagical.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Rod of Alertness",
      type: "Rod",
      description:
        "This rod has a flanged head and the following properties.\n<b><i>Alertness</i></b>. While holding the rod, you have advantage on Wisdom (Perception) checks and on rolls for initiative.\n<b><i>Spells</i></b>. While holding the rod, you can use an action to cast one of the following spells from it: <i>detect evil and good</i>, <i>detect magic</i>, <i>detect poison and disease</i>, or <i>see invisibility</i>.\n<b><i>Protective Aura</i></b>. As an action, you can plant the haft end of the rod in the ground, whereupon the rod's head sheds bright light in a 60-foot radius and dim light for an additional 60 feet. While in that bright light, you and any creature that is friendly to you gain a +1 bonus to AC and saving throws and can sense the location of any invisible hostile creature that is also in the bright light.\nThe rod's head stops glowing and the effect ends after 10 minutes, or when a creature uses an action to pull the rod from the ground. This property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Rod of Lordly Might",
      type: "Rod",
      description:
        "This rod has a flanged head, and it functions as a magic mace that grants a +3 bonus to attack and damage rolls made with it. The rod has properties associated with six different buttons that are set in a row along the haft. It has three other properties as well. For a full description of the <i>rod of lordly might</i> see page 240 of the 5E SRD 5.1.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Rod of Rulership",
      type: "Rod",
      description:
        "You can use an action to present the rod and command obedience from each creature of your choice that you can see within 120 feet of you. Each target must succeed on a DC 15 Wisdom saving throw or be charmed by you for 8 hours. While charmed in this way, the creature regards you as its trusted leader. If harmed by you or your companions, or commanded to do something contrary to its nature, a target ceases to be charmed in this way. The rod can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Rod of Security",
      type: "Rod",
      description:
        "While holding this rod, you can use an action to activate it. The rod then instantly transports you and up to 199 other willing creatures you can see to a paradise that exists in an extraplanar space. You choose the form that the paradise takes. It could be a tranquil garden, lovely glade, cheery tavern, immense palace, tropical island, fantastic carnival, or whatever else you can imagine. Regardless of its nature, the paradise contains enough water and food to sustain its visitors. Everything else that can be interacted with inside the extraplanar space can exist only there. For example, a flower picked from a garden in the paradise disappears if it is taken outside the extraplanar space.\nFor each hour spent in the paradise, a visitor regains hit points as if it had spent 1 Hit Die. Also, creatures don't age while in the paradise, although time passes normally. Visitors can remain in the paradise for up to 200 days divided by the number of creatures present (round down).\nWhen the time runs out or you use an action to end it, all visitors reappear in the location they occupied when you activated the rod, or an unoccupied space nearest that location. The rod can't be used again until ten days have passed.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Rope of Climbing",
      type: "Wondrous item",
      description:
        "This 60-foot length of silk rope weighs 3 pounds and can hold up to 3,000 pounds. If you hold one end of the rope and use an action to speak the command word, the rope animates. As a bonus action, you can command the other end to move toward a destination you choose. That end moves 10 feet on your turn when you first command it and 10 feet on each of your turns until reaching its destination, up to its maximum length away, or until you tell it to stop. You can also tell the rope to fasten itself securely to an object or to unfasten itself, to knot or unknot itself, or to coil itself for carrying.\nIf you tell the rope to knot, large knots appear at 1 foot intervals along the rope. While knotted, the rope shortens to a 50-foot length and grants advantage on checks made to climb it.\nThe rope has AC 20 and 20 hit points. It regains 1 hit point every 5 minutes as long as it has at least 1 hit point. If the rope drops to 0 hit points, it is destroyed.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Rope of Entanglement",
      type: "Wondrous item",
      description:
        "This rope is 30 feet long and weighs 3 pounds. If you hold one end of the rope and use an action to speak its command word, the other end darts forward to entangle a creature you can see within 20 feet of you. The target must succeed on a DC 15 Dexterity saving throw or become restrained.\nYou can release the creature by using a bonus action to speak a second command word. A target restrained by the rope can use an action to make a DC 15 Strength or Dexterity check (target's choice). On a success, the creature is no longer restrained by the rope.\nThe rope has AC 20 and 20 hit points. It regains 1 hit point every 5 minutes as long as it has at least 1 hit point. If the rope drops to 0 hit points, it is destroyed.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Scarab of Protection",
      type: "Wondrous item",
      description:
        "If you hold this beetle-shaped medallion in your hand for 1 round, an inscription appears on its surface revealing its magical nature. It provides two benefits while it is on your person:\n&#8226; You have advantage on saving throws against spells.\n&#8226; The scarab has 12 charges. If you fail a saving throw against a necromancy spell or a harmful effect originating from an undead creature, you can use your reaction to expend 1 charge and turn the failed save into a successful one. The scarab crumbles into powder and is destroyed when its last charge is expended.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Scimitar of Speed",
      type: "Weapon",
      subtype: "Scimitar",
      description:
        "You gain a +2 bonus to attack and damage rolls made with this magic weapon. In addition, you can make one attack with it as a bonus action on each of your turns.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Shield of Missile Attraction",
      type: "Armor",
      subtype: "Shield",
      description:
        "While holding this shield, you have resistance to damage from ranged weapon attacks.\n<b><i>Curse</i></b>. This shield is cursed. Attuning to it curses you until you are targeted by the <i>remove curse</i> spell or similar magic. Removing the shield fails to end the curse on you. Whenever a ranged weapon attack is made against a target within 10 feet of you, the curse causes you to become the target instead.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Slippers of Spider Climbing",
      type: "Wondrous item",
      description:
        "While you wear these light shoes, you can move up, down, and across vertical surfaces and upside down along ceilings, while leaving your hands free. You have a climbing speed equal to your walking speed. However, the slippers don't allow you to move this way on a slippery surface, such as one covered by ice or oil.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sovereign Glue",
      type: "Wondrous item",
      description:
        "This viscous, milky-white substance can form a permanent adhesive bond between any two objects. It must be stored in a jar or flask that has been coated inside with <i>oil of slipperiness.</i> When found, a container contains [option] ounces.\nOne ounce of the glue can cover a 1-foot square surface. The glue takes 1 minute to set. Once it has done so, the bond it creates can be broken only by the application of <i>universal solvent</i> or <i>oil of etherealness</i>, or with a <i>wish</i> spell.",
      rarity: "Legendary",
      attunement: "No",
      optionName: "Ounces:",
      options: [
        [
          { name: 2, value: 2 },
          { name: 3, value: 3 },
          { name: 4, value: 4 },
          { name: 5, value: 5 },
          { name: 6, value: 6 },
          { name: 7, value: 7 },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (Cantrip)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 13, +5 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Common",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Acid Splash", value: "<i>acid splash</i>" },
          { name: "Chill Touch", value: "<i>chill touch</i>" },
          { name: "Dancing Lights", value: "<i>dancing lights</i>" },
          { name: "Druidcraft", value: "<i>druidcraft</i>" },
          { name: "Eldritch Blast", value: "<i>eldritch blast</i>" },
          { name: "Fire Bolt", value: "<i>fire bolt</i>" },
          { name: "Guidance", value: "<i>guidance</i>" },
          { name: "Light", value: "<i>light</i>" },
          { name: "Mage Hand", value: "<i>mage hand</i>" },
          { name: "Mending", value: "<i>mending</i>" },
          { name: "Message", value: "<i>message</i>" },
          { name: "Minor Illusion", value: "<i>minor illusion</i>" },
          { name: "Poison Spray", value: "<i>poison spray</i>" },
          { name: "Prestidigitation", value: "<i>prestidigitation</i>" },
          { name: "Produce Flame", value: "<i>produce flame</i>" },
          { name: "Ray of Frost", value: "<i>ray of frost</i>" },
          { name: "Resistance", value: "<i>resistance</i>" },
          { name: "Sacred Flame", value: "<i>sacred flame</i>" },
          { name: "Shillelagh", value: "<i>shillelagh</i>" },
          { name: "Shocking Grasp", value: "<i>shocking grasp</i>" },
          { name: "Spare the Dying", value: "<i>spare the dying</i>" },
          { name: "Thaumaturgy", value: "<i>thaumaturgy</i>" },
          { name: "True Strike", value: "<i>true strike</i>" },
          { name: "Vicious Mockery", value: "<i>vicious mockery</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (1st level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 13, +5 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Common",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Alarm", value: "<i>alarm</i>" },
          { name: "Animal Friendship", value: "<i>animal friendship</i>" },
          { name: "Bane", value: "<i>bane</i>" },
          { name: "Bless", value: "<i>bless</i>" },
          { name: "Burning Hands", value: "<i>burning hands</i>" },
          { name: "Charm Person", value: "<i>charm person</i>" },
          { name: "Color Spray", value: "<i>color spray</i>" },
          { name: "Command", value: "<i>command</i>" },
          {
            name: "Comprehend Languages",
            value: "<i>comprehend languages</i>",
          },
          {
            name: "Create or Destroy Water",
            value: "<i>create or destroy water</i>",
          },
          { name: "Cure Wounds", value: "<i>cure wounds</i>" },
          {
            name: "Detect Evil and Good",
            value: "<i>detect evil and good</i>",
          },
          { name: "Detect Magic", value: "<i>detect magic</i>" },
          {
            name: "Detect Poison and Disease",
            value: "<i>detect poison and disease</i>",
          },
          { name: "Disguise Self", value: "<i>disguise self</i>" },
          { name: "Divine Favor", value: "<i>divine favor</i>" },
          { name: "Entangle", value: "<i>entangle</i>" },
          { name: "Expeditious Retreat", value: "<i>expeditious retreat</i>" },
          { name: "Faerie Fire", value: "<i>faerie fire</i>" },
          { name: "False Life", value: "<i>false life</i>" },
          { name: "Feather Fall", value: "<i>feather fall</i>" },
          { name: "Find Familiar", value: "<i>find familiar</i>" },
          { name: "Floating Disk", value: "<i>floating disk</i>" },
          { name: "Fog Cloud", value: "<i>fog cloud</i>" },
          { name: "Goodberry", value: "<i>goodberry</i>" },
          { name: "Grease", value: "<i>grease</i>" },
          { name: "Guiding Bolt", value: "<i>guiding bolt</i>" },
          { name: "Healing Word", value: "<i>healing word</i>" },
          { name: "Hellish Rebuke", value: "<i>hellish rebuke</i>" },
          { name: "Heroism", value: "<i>heroism</i>" },
          { name: "Hideous Laughter", value: "<i>hideous laughter</i>" },
          { name: "Hunter's Mark", value: "<i>hunter's mark</i>" },
          { name: "Identify", value: "<i>identify</i>" },
          { name: "Illusory Script", value: "<i>illusory script</i>" },
          { name: "Inflict Wounds", value: "<i>inflict wounds</i>" },
          { name: "Jump", value: "<i>jump</i>" },
          { name: "Longstrider", value: "<i>longstrider</i>" },
          { name: "Mage Armor", value: "<i>mage armor</i>" },
          { name: "Magic Missile", value: "<i>magic missile</i>" },
          {
            name: "Protection from Evil and Good",
            value: "<i>protection from evil and good</i>",
          },
          {
            name: "Purify Food and Drink",
            value: "<i>purify food and drink</i>",
          },
          { name: "Sanctuary", value: "<i>sanctuary</i>" },
          { name: "Shield", value: "<i>shield</i>" },
          { name: "Shield of Faith", value: "<i>shield of faith</i>" },
          { name: "Silent Image", value: "<i>silent image</i>" },
          { name: "Sleep", value: "<i>sleep</i>" },
          { name: "Speak with Animals", value: "<i>speak with animals</i>" },
          { name: "Thunderwave", value: "<i>thunderwave</i>" },
          { name: "Unseen Servant", value: "<i>unseen servant</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (2nd level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 13, +5 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Uncommon",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Acid Arrow", value: "<i>acid arrow</i>" },
          { name: "Aid", value: "<i>aid</i>" },
          { name: "Alter Self", value: "<i>alter self</i>" },
          { name: "Animal Messenger", value: "<i>animal messenger</i>" },
          { name: "Arcane Lock", value: "<i>arcane lock</i>" },
          {
            name: "Arcanist's Magic Aura",
            value: "<i>arcanist's magic aura</i>",
          },
          { name: "Augury", value: "<i>augury</i>" },
          { name: "Barkskin", value: "<i>barkskin</i>" },
          { name: "Blindness/Deafness", value: "<i>blindness/deafness</i>" },
          { name: "Blur", value: "<i>blur</i>" },
          { name: "Branding Smite", value: "<i>branding smite</i>" },
          { name: "Calm Emotions", value: "<i>calm emotions</i>" },
          { name: "Continual Flame", value: "<i>continual flame</i>" },
          { name: "Darkness", value: "<i>darkness</i>" },
          { name: "Darkvision", value: "<i>darkvision</i>" },
          { name: "Detect Thoughts", value: "<i>detect thoughts</i>" },
          { name: "Enhance Ability", value: "<i>enhance ability</i>" },
          { name: "Enlarge/Reduce", value: "<i>enlarge/reduce</i>" },
          { name: "Enthrall", value: "<i>enthrall</i>" },
          { name: "Find Steed", value: "<i>find steed</i>" },
          { name: "Find Traps", value: "<i>find traps</i>" },
          { name: "Flame Blade", value: "<i>flame blade</i>" },
          { name: "Flaming Sphere", value: "<i>flaming sphere</i>" },
          { name: "Gentle Repose", value: "<i>gentle repose</i>" },
          { name: "Gust of Wind", value: "<i>gust of wind</i>" },
          { name: "Heat Metal", value: "<i>heat metal</i>" },
          { name: "Hold Person", value: "<i>hold person</i>" },
          { name: "Invisibility", value: "<i>invisibility</i>" },
          { name: "Knock", value: "<i>knock</i>" },
          { name: "Lesser Restoration", value: "<i>lesser restoration</i>" },
          { name: "Levitate", value: "<i>levitate</i>" },
          {
            name: "Locate Animals or Plants",
            value: "<i>locate animals or plants</i>",
          },
          { name: "Locate Object", value: "<i>locate object</i>" },
          { name: "Magic Mouth", value: "<i>magic mouth</i>" },
          { name: "Magic Weapon", value: "<i>magic weapon</i>" },
          { name: "Mirror Image", value: "<i>mirror image</i>" },
          { name: "Misty Step", value: "<i>misty step</i>" },
          { name: "Moonbeam", value: "<i>moonbeam</i>" },
          { name: "Pass without Trace", value: "<i>pass without trace</i>" },
          { name: "Prayer of Healing", value: "<i>prayer of healing</i>" },
          {
            name: "Protection from Poison",
            value: "<i>protection from poison</i>",
          },
          { name: "Ray of Enfeeblement", value: "<i>ray of enfeeblement</i>" },
          { name: "Rope Trick", value: "<i>rope trick</i>" },
          { name: "Scorching Ray", value: "<i>scorching ray</i>" },
          { name: "See Invisibility", value: "<i>see invisibility</i>" },
          { name: "Shatter", value: "<i>shatter</i>" },
          { name: "Silence", value: "<i>silence</i>" },
          { name: "Spider Climb", value: "<i>spider climb</i>" },
          { name: "Spike Growth", value: "<i>spike growth</i>" },
          { name: "Spiritual Weapon", value: "<i>spiritual weapon</i>" },
          { name: "Suggestion", value: "<i>suggestion</i>" },
          { name: "Warding Bond", value: "<i>warding bond</i>" },
          { name: "Web", value: "<i>web</i>" },
          { name: "Zone of Truth", value: "<i>zone of truth</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (3rd level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 15, +7 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Uncommon",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Animate Dead", value: "<i>animate dead</i>" },
          { name: "Beacon of Hope", value: "<i>beacon of hope</i>" },
          { name: "Bestow Curse", value: "<i>bestow curse</i>" },
          { name: "Blink", value: "<i>blink</i>" },
          { name: "Call Lightning", value: "<i>call lightning</i>" },
          { name: "Clairvoyance", value: "<i>clairvoyance</i>" },
          { name: "Conjure Animals", value: "<i>conjure animals</i>" },
          { name: "Counterspell", value: "<i>counterspell</i>" },
          {
            name: "Create Food and Water",
            value: "<i>create food and water</i>",
          },
          { name: "Daylight", value: "<i>daylight</i>" },
          { name: "Dispel Magic", value: "<i>dispel magic</i>" },
          { name: "Fear", value: "<i>fear</i>" },
          { name: "Fireball", value: "<i>fireball</i>" },
          { name: "Fly", value: "<i>fly</i>" },
          { name: "Gaseous Form", value: "<i>gaseous form</i>" },
          { name: "Glyph of Warding", value: "<i>glyph of warding</i>" },
          { name: "Haste", value: "<i>haste</i>" },
          { name: "Hypnotic Pattern", value: "<i>hypnotic pattern</i>" },
          { name: "Lightning Bolt", value: "<i>lightning bolt</i>" },
          { name: "Magic Circle", value: "<i>magic circle</i>" },
          { name: "Major Image", value: "<i>major image</i>" },
          { name: "Mass Healing Word", value: "<i>mass healing word</i>" },
          { name: "Meld into Stone", value: "<i>meld into stone</i>" },
          { name: "Nondetection", value: "<i>nondetection</i>" },
          { name: "Phantom Steed", value: "<i>phantom steed</i>" },
          { name: "Plant Growth", value: "<i>plant growth</i>" },
          {
            name: "Protection from Energy",
            value: "<i>protection from energy</i>",
          },
          { name: "Remove Curse", value: "<i>remove curse</i>" },
          { name: "Revivify", value: "<i>revivify</i>" },
          { name: "Sending", value: "<i>sending</i>" },
          { name: "Sleet Storm", value: "<i>sleet storm</i>" },
          { name: "Slow", value: "<i>slow</i>" },
          { name: "Speak with Dead", value: "<i>speak with dead</i>" },
          { name: "Speak with Plants", value: "<i>speak with plants</i>" },
          { name: "Spirit Guardians", value: "<i>spirit guardians</i>" },
          { name: "Stinking Cloud", value: "<i>stinking cloud</i>" },
          { name: "Tiny Hut", value: "<i>tiny hut</i>" },
          { name: "Tongues", value: "<i>tongues</i>" },
          { name: "Vampiric Touch", value: "<i>vampiric touch</i>" },
          { name: "Water Breathing", value: "<i>water breathing</i>" },
          { name: "Water Walk", value: "<i>water walk</i>" },
          { name: "Wind Wall", value: "<i>wind wall</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (4th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 15, +7 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Rare",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Arcane Eye", value: "<i>arcane eye</i>" },
          { name: "Banishment", value: "<i>banishment</i>" },
          { name: "Black Tentacles", value: "<i>black tentacles</i>" },
          { name: "Blight", value: "<i>blight</i>" },
          { name: "Compulsion", value: "<i>compulsion</i>" },
          { name: "Confusion", value: "<i>confusion</i>" },
          {
            name: "Conjure Minor Elementals",
            value: "<i>conjure minor elementals</i>",
          },
          {
            name: "Conjure Woodland Beings",
            value: "<i>conjure woodland beings</i>",
          },
          { name: "Control Water", value: "<i>control water</i>" },
          { name: "Death Ward", value: "<i>death ward</i>" },
          { name: "Dimension Door", value: "<i>dimension door</i>" },
          { name: "Divination", value: "<i>divination</i>" },
          { name: "Dominate Beast", value: "<i>dominate beast</i>" },
          { name: "Fabricate", value: "<i>fabricate</i>" },
          { name: "Faithful Hound", value: "<i>faithful hound</i>" },
          { name: "Fire Shield", value: "<i>fire shield</i>" },
          { name: "Freedom of Movement", value: "<i>freedom of movement</i>" },
          { name: "Giant Insect", value: "<i>giant insect</i>" },
          {
            name: "Greater Invisibility",
            value: "<i>greater invisibility</i>",
          },
          { name: "Guardian of Faith", value: "<i>guardian of faith</i>" },
          {
            name: "Hallucinatory Terrain",
            value: "<i>hallucinatory terrain</i>",
          },
          { name: "Ice Storm", value: "<i>ice storm</i>" },
          { name: "Locate Creature", value: "<i>locate creature</i>" },
          { name: "Phantasmal Killer", value: "<i>phantasmal killer</i>" },
          { name: "Polymorph", value: "<i>polymorph</i>" },
          { name: "Private Sanctum", value: "<i>private sanctum</i>" },
          { name: "Resilient Sphere", value: "<i>resilient sphere</i>" },
          { name: "Secret Chest", value: "<i>secret chest</i>" },
          { name: "Stone Shape", value: "<i>stone shape</i>" },
          { name: "Stoneskin", value: "<i>stoneskin</i>" },
          { name: "Wall of Fire", value: "<i>wall of fire</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (5th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 17, +9 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Rare",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Animate Objects", value: "<i>animate objects</i>" },
          { name: "Antilife Shell", value: "<i>antilife shell</i>" },
          { name: "Arcane Hand", value: "<i>arcane hand</i>" },
          { name: "Awaken", value: "<i>awaken</i>" },
          { name: "Cloudkill", value: "<i>cloudkill</i>" },
          { name: "Commune", value: "<i>commune</i>" },
          { name: "Commune with Nature", value: "<i>commune with nature</i>" },
          { name: "Cone of Cold", value: "<i>cone of cold</i>" },
          { name: "Conjure Elemental", value: "<i>conjure elemental</i>" },
          { name: "Contact Other Plane", value: "<i>contact other plane</i>" },
          { name: "Contagion", value: "<i>contagion</i>" },
          { name: "Creation", value: "<i>creation</i>" },
          {
            name: "Dispel Evil and Good",
            value: "<i>dispel evil and good</i>",
          },
          { name: "Dominate Person", value: "<i>dominate person</i>" },
          { name: "Dream", value: "<i>dream</i>" },
          { name: "Flame Strike", value: "<i>flame strike</i>" },
          { name: "Geas", value: "<i>geas</i>" },
          { name: "Greater Restoration", value: "<i>greater restoration</i>" },
          { name: "Hallow", value: "<i>hallow</i>" },
          { name: "Hold Monster", value: "<i>hold monster</i>" },
          { name: "Insect Plague", value: "<i>insect plague</i>" },
          { name: "Legend Lore", value: "<i>legend lore</i>" },
          { name: "Mass Cure Wounds", value: "<i>mass cure wounds</i>" },
          { name: "Mislead", value: "<i>mislead</i>" },
          { name: "Modify Memory", value: "<i>modify memory</i>" },
          { name: "Passwall", value: "<i>passwall</i>" },
          { name: "Planar Binding", value: "<i>planar binding</i>" },
          { name: "Raise Dead", value: "<i>raise dead</i>" },
          { name: "Reincarnate", value: "<i>reincarnate</i>" },
          { name: "Scrying", value: "<i>scrying</i>" },
          { name: "Seeming", value: "<i>seeming</i>" },
          { name: "Telekinesis", value: "<i>telekinesis</i>" },
          { name: "Telepathic Bond", value: "<i>telepathic bond</i>" },
          {
            name: "Teleportation Circle",
            value: "<i>teleportation circle</i>",
          },
          { name: "Tree Stride", value: "<i>tree stride</i>" },
          { name: "Wall of Force", value: "<i>wall of force</i>" },
          { name: "Wall of Stone", value: "<i>wall of stone</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (6th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 17, +9 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Very Rare",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Blade Barrier", value: "<i>blade barrier</i>" },
          { name: "Chain Lightning", value: "<i>chain lightning</i>" },
          { name: "Circle of Death", value: "<i>circle of death</i>" },
          { name: "Conjure Fey", value: "<i>conjure fey</i>" },
          { name: "Contingency", value: "<i>contingency</i>" },
          { name: "Create Undead", value: "<i>create undead</i>" },
          { name: "Disintegrate", value: "<i>disintegrate</i>" },
          { name: "Eyebite", value: "<i>eyebite</i>" },
          { name: "Find the Path", value: "<i>find the path</i>" },
          { name: "Flesh to Stone", value: "<i>flesh to stone</i>" },
          { name: "Forbiddance", value: "<i>forbiddance</i>" },
          { name: "Freezing Sphere", value: "<i>freezing sphere</i>" },
          {
            name: "Globe of Invulnerability",
            value: "<i>globe of invulnerability</i>",
          },
          { name: "Guards and Wards", value: "<i>guards and wards</i>" },
          { name: "Harm", value: "<i>harm</i>" },
          { name: "Heal", value: "<i>heal</i>" },
          { name: "Heroes' Feast", value: "<i>heroes' feast</i>" },
          { name: "Instant Summons", value: "<i>instant summons</i>" },
          { name: "Irresistible Dance", value: "<i>irresistible dance</i>" },
          { name: "Magic Jar", value: "<i>magic jar</i>" },
          { name: "Mass Suggestion", value: "<i>mass suggestion</i>" },
          { name: "Move Earth", value: "<i>move earth</i>" },
          { name: "Planar Ally", value: "<i>planar ally</i>" },
          { name: "Programmed Illusion", value: "<i>programmed illusion</i>" },
          { name: "Sunbeam", value: "<i>sunbeam</i>" },
          {
            name: "Transport via Plants",
            value: "<i>transport via plants</i>",
          },
          { name: "True Seeing", value: "<i>true seeing</i>" },
          { name: "Wall of Ice", value: "<i>wall of ice</i>" },
          { name: "Wall of Thorns", value: "<i>wall of thorns</i>" },
          { name: "Wind Walk", value: "<i>wind walk</i>" },
          { name: "Word of Recall", value: "<i>word of recall</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (7th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 18, +10 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Very Rare",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Arcane Sword", value: "<i>arcane sword</i>" },
          { name: "Conjure Celestial", value: "<i>conjure celestial</i>" },
          {
            name: "Delayed Blast Fireball",
            value: "<i>delayed blast fireball</i>",
          },
          { name: "Divine Word", value: "<i>divine word</i>" },
          { name: "Etherealness", value: "<i>etherealness</i>" },
          { name: "Finger of Death", value: "<i>finger of death</i>" },
          { name: "Fire Storm", value: "<i>fire storm</i>" },
          { name: "Forcecage", value: "<i>forcecage</i>" },
          { name: "Magnificent Mansion", value: "<i>magnificent mansion</i>" },
          { name: "Mirage Arcane", value: "<i>mirage arcane</i>" },
          { name: "Plane Shift", value: "<i>plane shift</i>" },
          { name: "Prismatic Spray", value: "<i>prismatic spray</i>" },
          { name: "Project Image", value: "<i>project image</i>" },
          { name: "Regenerate", value: "<i>regenerate</i>" },
          { name: "Resurrection", value: "<i>resurrection</i>" },
          { name: "Reverse Gravity", value: "<i>reverse gravity</i>" },
          { name: "Sequester", value: "<i>sequester</i>" },
          { name: "Simulacrum", value: "<i>simulacrum</i>" },
          { name: "Symbol", value: "<i>symbol</i>" },
          { name: "Teleport", value: "<i>teleport</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (8th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 18, +10 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Very Rare",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Animal Shapes", value: "<i>animal shapes</i>" },
          { name: "Antimagic Field", value: "<i>antimagic field</i>" },
          { name: "Antipathy/Sympathy", value: "<i>antipathy/sympathy</i>" },
          { name: "Clone", value: "<i>clone</i>" },
          { name: "Control Weather", value: "<i>control weather</i>" },
          { name: "Demiplane", value: "<i>demiplane</i>" },
          { name: "Dominate Monster", value: "<i>dominate monster</i>" },
          { name: "Earthquake", value: "<i>earthquake</i>" },
          { name: "Feeblemind", value: "<i>feeblemind</i>" },
          { name: "Glibness", value: "<i>glibness</i>" },
          { name: "Holy Aura", value: "<i>holy aura</i>" },
          { name: "Incendiary Cloud", value: "<i>incendiary cloud</i>" },
          { name: "Maze", value: "<i>maze</i>" },
          { name: "Mind Blank", value: "<i>mind blank</i>" },
          { name: "Power Word Stun", value: "<i>power word stun</i>" },
          { name: "Sunburst", value: "<i>sunburst</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spell Scroll (9th level)",
      type: "Scroll",
      description:
        "This scroll holds the [option] spell (save DC 19, +11 to hit). If the spell is on your class's spell list, you can use an action to read the scroll and cast its spell without having to provide any of the spell's components. Otherwise, the scroll is unintelligible.\nIf the spell is on your class's spell list but of a higher level than you can normally cast, you must make an ability check using your spellcasting ability to determine whether you cast it successfully. The DC equals 10 + the spell's level. On a failed check, the spell disappears from the scroll with no other effect. Once the spell is cast, the words on the scroll fade, and the scroll itself crumbles to dust.",
      rarity: "Legendary",
      attunement: "No",
      optionName: "Spell:",
      options: [
        [
          { name: "Astral Projection", value: "<i>astral projection</i>" },
          { name: "Foresight", value: "<i>foresight</i>" },
          { name: "Gate", value: "<i>gate</i>" },
          { name: "Imprisonment", value: "<i>imprisonment</i>" },
          { name: "Mass Heal", value: "<i>mass heal</i>" },
          { name: "Meteor Swarm", value: "<i>meteor swarm</i>" },
          { name: "Power Word Kill", value: "<i>power word kill</i>" },
          { name: "Prismatic Wall", value: "<i>prismatic wall</i>" },
          { name: "Shapechange", value: "<i>shapechange</i>" },
          { name: "Storm of Vengeance", value: "<i>storm of vengeance</i>" },
          { name: "Time Stop", value: "<i>time stop</i>" },
          { name: "True Polymorph", value: "<i>true polymorph</i>" },
          { name: "True Resurrection", value: "<i>true resurrection</i>" },
          { name: "Weird", value: "<i>weird</i>" },
          { name: "Wish", value: "<i>wish</i>" },
        ],
      ],
      source: "srd",
    },
    {
      name: "Spellguard Shield",
      type: "Armor",
      subtype: "Shield",
      description:
        "While holding this shield, you have advantage on saving throws against spells and other magical effects, and spell attacks have disadvantage against you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sphere of Annihilation",
      type: "Wondrous item",
      description:
        "This 2-foot-diameter black sphere is a hole in the multiverse, hovering in space and stabilized by a magical field surrounding it.\nThe sphere obliterates all matter it passes through and all matter that passes through it. Artifacts are the exception. Unless an artifact is susceptible to damage from a <i>sphere of annihilation</i>, it passes through the sphere unscathed. Anything else that touches the sphere but isn't wholly engulfed and obliterated by it takes 4d10 force damage.\nThe sphere is stationary until someone controls it. If you are within 60 feet of an uncontrolled sphere, you can use an action to make a DC 25 Intelligence (Arcana) check. On a success, the sphere levitates in one direction of your choice, up to a number of feet equal to 5 \u00D7 your Intelligence modifier (minimum 5 feet). On a failure, the sphere moves 10 feet toward you. A creature whose space the sphere enters must succeed on a DC 13 Dexterity saving throw or be touched by it, taking 4d10 force damage.\nIf you attempt to control a sphere that is under another creature's control, you make an Intelligence (Arcana) check contested by the other creature's Intelligence (Arcana) check. The winner of the contest gains control of the sphere and can levitate it as normal.\nIf the sphere comes into contact with a planar portal, such as that created by the <i>gate</i> spell, or an extradimensional space, such as that within a <i>portable hole</i>, the GM determines randomly what happens (roll a d100; 01-50: The sphere is destroyed; 51-85: The sphere moves through the portal or into the extradimensional space; 86-00: A spatial rift sends each creature and object within 180 feet of the sphere, including the sphere, to a random plane of existence.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Staff of Charming",
      type: "Staff",
      description:
        "While holding this staff, you can use an action to expend 1 of its 10 charges to cast <i>charm person</i>, <i>command</i>, <i>or comprehend languages</i> from it using your spell save DC. The staff can also be used as a magic quarterstaff.\nIf you are holding the staff and fail a saving throw against an enchantment spell that targets only you, you can turn your failed save into a successful one. You can't use this property of the staff again until the next dawn. If you succeed on a save against an enchantment spell that targets only you, with or without the staff's intervention, you can use your reaction to expend 1 charge from the staff and turn the spell back on its caster as if you had cast the spell.\nThe staff regains 1d8 + 2 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff becomes a nonmagical quarterstaff.",
      rarity: "Rare",
      attunement:
        "Requires attunement by a bard, cleric, druid, sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of Fire",
      type: "Staff",
      description:
        "You have resistance to fire damage while you hold this staff.\nThe staff has 10 charges. While holding it, you can use an action to expend 1 or more of its charges to cast one of the following spells from it, using your spell save DC: <i>burning hands</i> (1 charge), <i>fireball</i> (3 charges), or <i>wall of fire</i> (4 charges).\nThe staff regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff blackens, crumbles into cinders, and is destroyed.",
      rarity: "Very Rare",
      attunement:
        "Requires attunement by a druid, sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of Frost",
      type: "Staff",
      description:
        "You have resistance to cold damage while you hold this staff.\nThe staff has 10 charges. While holding it, you can use an action to expend 1 or more of its charges to cast one of the following spells from it, using your spell save DC: <i>cone of cold</i> (5 charges), <i>fog cloud</i> (1 charge), <i>ice storm</i> (4 charges), or <i>wall of ice</i> (4 charges).\nThe staff regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff turns to water and is destroyed.",
      rarity: "Very Rare",
      attunement:
        "Requires attunement by a druid, sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of Healing",
      type: "Staff",
      description:
        "This staff has 10 charges. While holding it, you can use an action to expend 1 or more of its charges to cast one of the following spells from it, using your spell save DC and spellcasting ability modifier: <i>cure wounds</i> (1 charge per spell level, up to 4th), <i>lesser restoration</i> (2 charges), or <i>mass cure wounds</i> (5 charges).\nThe staff regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff vanishes in a flash of light, lost forever.",
      rarity: "Rare",
      attunement: "Requires attunement by a bard, cleric, or druid",
      source: "srd",
    },
    {
      name: "Staff of Power",
      type: "Staff",
      description:
        "This staff can be wielded as a magic quarterstaff that grants a +2 bonus to attack and damage rolls made with it. While holding it, you gain a +2 bonus to Armor Class, saving throws, and spell attack rolls.\nThe staff has 20 charges for the following properties. The staff regains 2d8 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff retains its +2 bonus to attack and damage rolls but loses all other properties. On a 20, the staff regains 1d8 + 2 charges.\n<b><i>Power Strike</i></b>. When you hit with a melee attack using the staff, you can expend 1 charge to deal an extra 1d6 force damage to the target.\n<b><i>Spells</i></b>. While holding this staff, you can use an action to expend 1 or more of its charges to cast one of the following spells from it, using your spell save DC and spell attack bonus: <i>cone of cold</i> (5 charges), <i>fireball</i> (5th-level version, 5 charges), <i>globe of invulnerability</i> (6 charges), <i>hold monster</i> (5 charges), <i>levitate</i> (2 charges), <i>lightning bolt</i> (5th-level version, 5 charges), <i>magic missile</i> (1 charge), <i>ray of enfeeblement</i> (1 charge), or <i>wall of force</i> (5 charges).\n<b><i>Retributive Strike</i></b>. You can use an action to break the staff over your knee or against a solid surface, performing a retributive strike. The staff is destroyed and releases its remaining magic in an explosion that expands to fill a 30-foot-radius sphere centered on it.\nYou have a 50 percent chance to instantly travel to a random plane of existence, avoiding the explosion. If you fail to avoid the effect, you take force damage equal to 16 \u00D7 the number of charges in the staff. Every other creature in the area must make a DC 17 Dexterity saving throw. On a failed save, a creature takes 8 \u00D7 the number of charges in the staff if it is 10 ft. away or closer, 6 \u00D7 the number of charges in the staff if between 11 and 20 ft. away, or 4 \u00D7 the number of charges in the staff if between 21 and 30 ft. away. On a successful save, a creature takes half as much damage.",
      rarity: "Very Rare",
      attunement: "Requires attunement by a sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of Striking",
      type: "Staff",
      description:
        "This staff can be wielded as a magic quarterstaff that grants a +3 bonus to attack and damage rolls made with it.\nThe staff has 10 charges. When you hit with a melee attack using it, you can expend up to 3 of its charges. For each charge you expend, the target takes an extra 1d6 force damage. The staff regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff becomes a nonmagical quarterstaff.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Staff of Swarming Insects",
      type: "Staff",
      description:
        "This staff has 10 charges and regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, a swarm of insects consumes and destroys the staff, then disperses.\n<b><i>Spells</i></b>. While holding the staff, you can use an action to expend some of its charges to cast one of the following spells from it, using your spell save DC: <i>giant insect</i> (4 charges) or <i>insect plague</i> (5 charges).\n<b><i>Insect Cloud</i></b>. While holding the staff, you can use an action and expend 1 charge to cause a swarm of harmless flying insects to spread out in a 30-foot radius from you. The insects remain for 10 minutes, making the area heavily obscured for creatures other than you. The swarm moves with you, remaining centered on you. A wind of at least 10 miles per hour disperses the swarm and ends the effect.",
      rarity: "Very Rare",
      attunement:
        "Requires attunement by a bard, cleric, druid, sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of the Magi",
      type: "Staff",
      description:
        "This staff can be wielded as a magic quarterstaff that grants a +2 bonus to attack and damage rolls made with it. While you hold it, you gain a +2 bonus to spell attack rolls.\nThe staff has 50 charges for the following properties. It regains 4d6 + 2 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 20, the staff regains 1d12 + 1 charges.\n<b><i>Spell Absorption</i></b>. While holding the staff, you have advantage on saving throws against spells. In addition, you can use your reaction when another creature casts a spell that targets only you. If you do, the staff absorbs the magic of the spell, canceling its effect and gaining a number of charges equal to the absorbed spell's level. However, if doing so brings the staff's total number of charges above 50, the staff explodes as if you activated its retributive strike (see below).\n<b><i>Spells</i></b>. While holding the staff, you can use an action to expend some of its charges to cast one of the following spells from it, using your spell save DC and spellcasting ability: <i>conjure elemental</i> (7 charges), <i>dispel magic</i> (3 charges), <i>fireball</i> (7th-level version, 7 charges), <i>flaming sphere</i> (2 charges), <i>ice storm</i> (4 charges), <i>invisibility</i> (2 charges), <i>knock</i> (2 charges), <i>lightning bolt</i> (7th-level version, 7 charges), <i>passwall</i> (5 charges), <i>plane shift</i> (7 charges), <i>telekinesis</i> (5 charges), <i>wall of fire</i> (4 charges), or <i>web</i> (2 charges).\nYou can also use an action to cast one of the following spells from the staff without using any charges: <i>arcane lock</i>, <i>detect magic</i>, <i>enlarge/reduce</i>, <i>light</i>, <i>mage hand</i>, or <i>protection from evil and good</i>.\n<b><i>Retributive Strike</i></b>. You can use an action to break the staff over your knee or against a solid surface, performing a retributive strike. The staff is destroyed and releases its remaining magic in an explosion that expands to fill a 30-foot-radius sphere centered on it.\nYou have a 50 percent chance to instantly travel to a random plane of existence, avoiding the explosion. If you fail to avoid the effect, you take force damage equal to 16 \u00D7 the number of charges in the staff. Every other creature in the area must make a DC 17 Dexterity saving throw. On a failed save, a creature takes 8 \u00D7 the number of charges in the staff if it is 10 ft. away or closer, 6 \u00D7 the number of charges in the staff if between 11 and 20 ft. away, or 4 \u00D7 the number of charges in the staff if between 21 and 30 ft. away. On a successful save, a creature takes half as much damage.",
      rarity: "Legendary",
      attunement: "Requires attunement by a sorcerer, warlock, or wizard",
      source: "srd",
    },
    {
      name: "Staff of the Python",
      type: "Staff",
      description:
        "You can use an action to speak this staff's command word and throw the staff on the ground within 10 feet of you. The staff becomes a giant constrictor snake under your control and acts on its own initiative count. By using a bonus action to speak the command word again, you return the staff to its normal form in a space formerly occupied by the snake.\nOn your turn, you can mentally command the snake if it is within 60 feet of you and you aren't incapacitated. You decide what action the snake takes and where it moves during its next turn, or you can issue it a general command, such as to attack your enemies or guard a location.\nIf the snake is reduced to 0 hit points, it dies and reverts to its staff form. The staff then shatters and is destroyed. If the snake reverts to staff form before losing all its hit points, it regains all of them.",
      rarity: "Very Rare",
      attunement: "Requires attunement by a cleric, druid, or warlock",
      source: "srd",
    },
    {
      name: "Staff of the Woodlands",
      type: "Staff",
      description:
        "This staff can be wielded as a magic quarterstaff that grants a +2 bonus to attack and damage rolls made with it. While holding it, you have a +2 bonus to spell attack rolls.\nThe staff has 10 charges for the following properties. It regains 1d6 + 4 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 1, the staff loses its properties and becomes a nonmagical quarterstaff.\n<b><i>Spells</i></b>. You can use an action to expend 1 or more of the staff's charges to cast one of the following spells from it, using your spell save DC: <i>animal friendship</i> (1 charge), <i>awaken</i> (5 charges), <i>barkskin</i> (2 charges), <i>locate animals or plants</i> (2 charges), <i>speak with animals</i> (1 charge), <i>speak with plants</i> (3 charges), or <i>wall of thorns</i> (6 charges).\nYou can also use an action to cast the <i>pass without trace</i> spell from the staff without using any charges. \n<b><i>Tree Form</i></b>. You can use an action to plant one end of the staff in fertile earth and expend 1 charge to transform the staff into a healthy tree. The tree is 60 feet tall and has a 5-foot-diameter trunk, and its branches at the top spread out in a 20-foot radius.\nThe tree appears ordinary but radiates a faint aura of transmutation magic if targeted by <i>detect magic</i>. While touching the tree and using another action to speak its command word, you return the staff to its normal form. Any creature in the tree falls when it reverts to a staff.",
      rarity: "Rare",
      attunement: "Requires attunement by a druid",
      source: "srd",
    },
    {
      name: "Staff of Thunder and Lightning",
      type: "Staff",
      description:
        "This staff can be wielded as a magic quarterstaff that grants a +2 bonus to attack and damage rolls made with it. It also has the following additional properties. When one of these properties is used, it can't be used again until the next dawn.\n<b><i>Lightning</i></b>. When you hit with a melee attack using the staff, you can cause the target to take an extra 2d6 lightning damage.\n<b><i>Thunder</i></b>. When you hit with a melee attack using the staff, you can cause the staff to emit a crack of thunder, audible out to 300 feet. The target you hit must succeed on a DC 17 Constitution saving throw or become stunned until the end of your next turn.\n<b><i>Lightning Strike</i></b>. You can use an action to cause a bolt of lightning to leap from the staff's tip in a line that is 5 feet wide and 120 feet long. Each creature in that line must make a DC 17 Dexterity saving throw, taking 9d6 lightning damage on a failed save, or half as much damage on a successful one.\n<b><i>Thunderclap</i></b>. You can use an action to cause the staff to issue a deafening thunderclap, audible out to 600 feet. Each creature within 60 feet of you (not including you) must make a DC 17 Constitution saving throw. On a failed save, a creature takes 2d6 thunder damage and becomes deafened for 1 minute. On a successful save, a creature takes half damage and isn't deafened.\n<b><i>Thunder and Lightning</i></b>. You can use an action to use the Lightning Strike and Thunderclap properties at the same time. Doing so doesn't expend the daily use of those properties, only the use of this one.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Staff of Withering",
      type: "Staff",
      description:
        "This staff has 3 charges and regains 1d3 expended charges daily at dawn.\nThe staff can be wielded as a magic quarterstaff. On a hit, it deals damage as a normal quarterstaff, and you can expend 1 charge to deal an extra 2d10 necrotic damage to the target. In addition, the target must succeed on a DC 15 Constitution saving throw or have disadvantage for 1 hour on any ability check or saving throw that uses Strength or Constitution.",
      rarity: "Rare",
      attunement: "Requires attunement by a cleric, druid, or warlock",
      source: "srd",
    },
    {
      name: "Stone of Controlling Earth Elementals",
      type: "Wondrous item",
      description:
        "If the stone is touching the ground, you can use an action to speak its command word and summon an earth elemental, as if you had cast the <i>conjure elemental</i> spell. The stone can't be used this way again until the next dawn. The stone weighs 5 pounds.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Stone of Good Luck (Luckstone)",
      type: "Wondrous item",
      description:
        "While this polished agate is on your person, you gain a +1 bonus to ability checks and saving throws.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sun Blade",
      type: "Weapon",
      subtype: "Longsword",
      description:
        "This item appears to be a longsword hilt. While grasping the hilt, you can use a bonus action to cause a blade of pure radiance to spring into existence, or make the blade disappear. While the blade exists, this magic longsword has the finesse property. If you are proficient with shortswords or longswords, you are proficient with the <i>sun blade</i>.\nYou gain a +2 bonus to attack and damage rolls made with this weapon, which deals radiant damage instead of slashing damage. When you hit an undead with it, that target takes an extra 1d8 radiant damage.\nThe sword's luminous blade emits bright light in a 15-foot radius and dim light for an additional 15 feet. The light is sunlight. While the blade persists, you can use an action to expand or reduce its radius of bright and dim light by 5 feet each, to a maximum of 30 feet each or a minimum of 10 feet each.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sword of Life Stealing",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "When you attack a creature with this magic weapon and roll a 20 on the attack roll, that target takes an extra 3d6 necrotic damage, provided that the target isn't a construct or an undead. You gain temporary hit points equal to the extra damage dealt.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sword of Sharpness",
      type: "Weapon",
      subtype: "Any sword that deals slashing damage",
      description:
        "When you attack an object with this magic sword and hit, maximize your weapon damage dice against the target.\nWhen you attack a creature with this weapon and roll a 20 on the attack roll, that target takes an extra 4d6 slashing damage. Then roll another d20. If you roll a 20, you lop off one of the target's limbs, with the effect of such loss determined by the GM. If the creature has no limb to sever, you lop off a portion of its body instead.\nIn addition, you can speak the sword's command word to cause the blade to shed bright light in a 10 foot radius and dim light for an additional 10 feet. Speaking the command word again or sheathing the sword puts out the light.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Sword of Wounding",
      type: "Weapon",
      subtype: "Any sword",
      description:
        "Hit points lost to this weapon's damage can be regained only through a short or long rest, rather than by regeneration, magic, or any other means.\nOnce per turn, when you hit a creature with an attack using this magic weapon, you can wound the target. At the start of each of the wounded creature's turns, it takes 1d4 necrotic damage for each time you've wounded it, and it can then make a DC 15 Constitution saving throw, ending the effect of all such wounds on itself on a success. Alternatively, the wounded creature, or a creature within 5 feet of it, can use an action to make a DC 15 Wisdom (Medicine) check, ending the effect of such wounds on it on a success.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Talisman of Pure Good",
      type: "Wondrous item",
      description:
        "This talisman is a mighty symbol of goodness. A creature that is neither good nor evil in alignment takes 6d6 radiant damage upon touching the talisman. An evil creature takes 8d6 radiant damage upon touching the talisman. Either sort of creature takes the damage again each time it ends its turn holding or carrying the talisman.\nIf you are a good cleric or paladin, you can use the talisman as a holy symbol, and you gain a +2 bonus to spell attack rolls while you wear or hold it.\nThe talisman has 7 charges. If you are wearing or holding it, you can use an action to expend 1 charge from it and choose one creature you can see on the ground within 120 feet of you. If the target is of evil alignment, a flaming fissure opens under it. The target must succeed on a DC 20 Dexterity saving throw or fall into the fissure and be destroyed, leaving no remains. The fissure then closes, leaving no trace of its existence. When you expend the last charge, the talisman disperses into motes of golden light and is destroyed.",
      rarity: "Legendary",
      attunement: "Requires attunement by a creature of good alignment",
      source: "srd",
    },
    {
      name: "Talisman of the Sphere",
      type: "Wondrous item",
      description:
        "When you make an Intelligence (Arcana) check to control a <i>sphere of annihilation</i> while you are holding this talisman, you double your proficiency bonus on the check. In addition, when you start your turn with control over a <i>sphere of annihilation</i>, you can use an action to levitate it 10 feet plus a number of additional feet equal to 10 \u00D7 your Intelligence modifier.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Talisman of Ultimate Evil",
      type: "Wondrous item",
      description:
        "This item symbolizes unrepentant evil. A creature that is neither good nor evil in alignment takes 6d6 necrotic damage upon touching the talisman. A good creature takes 8d6 necrotic damage upon touching the talisman. Either sort of creature takes the damage again each time it ends its turn holding or carrying the talisman.\nIf you are an evil cleric or paladin, you can use the talisman as a holy symbol, and you gain a +2 bonus to spell attack rolls while you wear or hold it.\nThe talisman has 6 charges. If you are wearing or holding it, you can use an action to expend 1 charge from the talisman and choose one creature you can see on the ground within 120 feet of you. If the target is of good alignment, a flaming fissure opens under it. The target must succeed on a DC 20 Dexterity saving throw or fall into the fissure and be destroyed, leaving no remains. The fissure then closes, leaving no trace of its existence. When you expend the last charge, the talisman dissolves into foul-smelling slime and is destroyed.",
      rarity: "Legendary",
      attunement: "Requires attunement by a creature of evil alignment",
      source: "srd",
    },
    {
      name: "Tome of Clear Thought",
      type: "Wondrous item",
      description:
        "This book contains memory and logic exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Intelligence score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Tome of Leadership and Influence",
      type: "Wondrous item",
      description:
        "This book contains guidelines for influencing and charming others, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Charisma score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Tome of Understanding",
      type: "Wondrous item",
      description:
        "This book contains intuition and insight exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Wisdom score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Trident of Fish Command",
      type: "Weapon",
      subtype: "Trident",
      description:
        "This trident is a magic weapon. It has 3 charges. While you carry it, you can use an action and expend 1 charge to cast <i>dominate beast</i> (save DC 15) from it on a beast that has an innate swimming speed. The trident regains 1d3 expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Universal Solvent",
      type: "Wondrous item",
      description:
        "This tube holds milky liquid with a strong alcohol smell. You can use an action to pour the contents of the tube onto a surface within reach. The liquid instantly dissolves up to 1 square foot of adhesive it touches, including <i>sovereign glue.</i>",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Vicious Weapon",
      type: "Weapon",
      subtype: "Any",
      description:
        "When you roll a 20 on your attack roll with this magic weapon, your critical hit deals an extra 2d6 damage of the weapon's type.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Vorpal Sword",
      type: "Weapon",
      subtype: "Any sword that deals slashing damage",
      description:
        "You gain a +3 bonus to attack and damage rolls made with this magic weapon. In addition, the weapon ignores resistance to slashing damage.\nWhen you attack a creature that has at least one head with this weapon and roll a 20 on the attack roll, you cut off one of the creature's heads. The creature dies if it can't survive without the lost head. A creature is immune to this effect if it is immune to slashing damage, doesn't have or need a head, has legendary actions, or the GM decides that the creature is too big for its head to be cut off with this weapon. Such a creature instead takes an extra 6d8 slashing damage from the hit.",
      rarity: "Legendary",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Wand of Binding",
      type: "Wand",
      description:
        "This wand has 7 charges for the following properties. It regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.\n<b><i>Spells</i></b>. While holding the wand, you can use an action to expend some of its charges to cast one of the following spells (save DC 17): <i>hold monster</i> (5 charges) or <i>hold person</i> (2 charges).\n<b><i>Assisted Escape</i></b>. While holding the wand, you can use your reaction to expend 1 charge and gain advantage on a saving throw you make to avoid being paralyzed or restrained, or you can expend 1 charge and gain advantage on any check you make to escape a grapple.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Enemy Detection",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action and expend 1 charge to speak its command word. For the next minute, you know the direction of the nearest creature hostile to you within 60 feet, but not its distance from you. The wand can sense the presence of hostile creatures that are ethereal, invisible, disguised, or hidden, as well as those in plain sight. The effect ends if you stop holding the wand.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Wand of Fear",
      type: "Wand",
      description:
        "This wand has 7 charges for the following properties. It regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.\n<b><i>Command</i></b>. While holding the wand, you can use an action to expend 1 charge and command another creature to flee or grovel, as with the <i>command</i> spell (save DC 15).\n<b><i>Cone of Fear</i></b>. While holding the wand, you can use an action to expend 2 charges, causing the wand's tip to emit a 60-foot cone of amber light. Each creature in the cone must succeed on a DC 15 Wisdom saving throw or become frightened of you for 1 minute. While it is frightened in this way, a creature must spend its turns trying to move as far away from you as it can, and it can't willingly move to a space within 30 feet of you. It also can't take reactions. For its action, it can use only the Dash action or try to escape from an effect that prevents it from moving. If it has nowhere it can move, the creature can use the Dodge action. At the end of each of its turns, a creature can repeat the saving throw, ending the effect on itself on a success.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Wand of Fireballs",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 or more of its charges to cast the <i>fireball</i> spell (save DC 15) from it. For 1 charge, you cast the 3rd-level version of the spell. You can increase the spell slot level by one for each additional charge you expend.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Lightning Bolts",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 or more of its charges to cast the <i>lightning bolt</i> spell (save DC 15) from it. For 1 charge, you cast the 3rd-level version of the spell. You can increase the spell slot level by one for each additional charge you expend.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Magic Detection",
      type: "Wand",
      description:
        "This wand has 3 charges. While holding it, you can expend 1 charge as an action to cast the <i>detect magic</i> spell from it. The wand regains 1d3 expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Wand of Magic Missiles",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 or more of its charges to cast the <i>magic missile</i> spell from it. For 1 charge, you cast the 1st-level version of the spell. You can increase the spell slot level by one for each additional charge you expend.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Wand of Paralysis",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 of its charges to cause a thin blue ray to streak from the tip toward a creature you can see within 60 feet of you. The target must succeed on a DC 15 Constitution saving throw or be paralyzed for 1 minute. At the end of each of the target's turns, it can repeat the saving throw, ending the effect on itself on a success.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Polymorph",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 of its charges to cast the <i>polymorph</i> spell (save DC 15) from it.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Very Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Secrets",
      type: "Wand",
      description:
        "The wand has 3 charges. While holding it, you can use an action to expend 1 of its charges, and if a secret door or trap is within 30 feet of you, the wand pulses and points at the one nearest to you. The wand regains 1d3 expended charges daily at dawn.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Wand of the War Mage +1",
      type: "Wand",
      description:
        "While holding this wand, you gain a +1 bonus to spell attack rolls. In addition, you ignore half cover when making a spell attack.",
      rarity: "Uncommon",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of the War Mage +2",
      type: "Wand",
      description:
        "While holding this wand, you gain a +2 bonus to spell attack rolls. In addition, you ignore half cover when making a spell attack.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of the War Mage +3",
      type: "Wand",
      description:
        "While holding this wand, you gain a +3 bonus to spell attack rolls. In addition, you ignore half cover when making a spell attack.",
      rarity: "Very Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Web",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 of its charges to cast the <i>web</i> spell (save DC 15) from it.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into ashes and is destroyed.",
      rarity: "Uncommon",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Wand of Wonder",
      type: "Wand",
      description:
        "This wand has 7 charges. While holding it, you can use an action to expend 1 of its charges and choose a target within 120 feet of you. The target can be a creature, an object, or a point in space. Roll a d100 and consult the table on page 250 of the 5E SRD 5.1.\nIf the effect causes you to cast a spell from the wand, the spell's save DC is 15. If the spell normally has a range expressed in feet, its range becomes 120 feet if it isn't already.\nIf an effect covers an area, you must center the spell on and include the target. If an effect has multiple possible subjects, the GM randomly determines which ones are affected.\nThe wand regains 1d6 + 1 expended charges daily at dawn. If you expend the wand's last charge, roll a d20. On a 1, the wand crumbles into dust and is destroyed.",
      rarity: "Rare",
      attunement: "Requires attunement by a spellcaster",
      source: "srd",
    },
    {
      name: "Weapon +1",
      type: "Weapon",
      subtype: "Any",
      description:
        "You have a +1 bonus to attack and damage rolls made with this magic weapon.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Weapon +2",
      type: "Weapon",
      subtype: "Any",
      description:
        "You have a +2 bonus to attack and damage rolls made with this magic weapon.",
      rarity: "Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Weapon +3",
      type: "Weapon",
      subtype: "Any",
      description:
        "You have a +3 bonus to attack and damage rolls made with this magic weapon.",
      rarity: "Very Rare",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Well of Many Worlds",
      type: "Wondrous item",
      description:
        "This fine black cloth, soft as silk, is folded up to the dimensions of a handkerchief. It unfolds into a circular sheet 6 feet in diameter.\nYou can use an action to unfold and place the <i>well of many worlds</i> on a solid surface, whereupon it creates a two-way portal to another world or plane of existence. Each time the item opens a portal, the GM decides where it leads. You can use an action to close an open portal by taking hold of the edges of the cloth and folding it up. Once <i>well of many worlds</i> has opened a portal, it can't do so again for 1d8 hours.",
      rarity: "Legendary",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Wind Fan",
      type: "Wondrous item",
      description:
        "While holding this fan, you can use an action to cast the <i>gust of wind</i> spell (save DC 13) from it. Once used, the fan shouldn't be used again until the next dawn. Each time it is used again before then, it has a cumulative 20 percent chance of not working and tearing into useless, nonmagical tatters.",
      rarity: "Uncommon",
      attunement: "No",
      source: "srd",
    },
    {
      name: "Winged Boots",
      type: "Wondrous item",
      description:
        "While you wear these boots, you have a flying speed equal to your walking speed. You can use the boots to fly for up to 4 hours, all at once or in several shorter flights, each one using a minimum of 1 minute from the duration. If you are flying when the duration expires, you descend at a rate of 30 feet per round until you land.\nThe boots regain 2 hours of flying capability for every 12 hours they aren't in use.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "srd",
    },
    {
      name: "Wings of Flying",
      type: "Wondrous item",
      description:
        "While wearing this cloak, you can use an action to speak its command word. This turns the cloak into a pair of bat wings or bird wings on your back for 1 hour or until you repeat the command word as an action. The wings give you a flying speed of 60 feet. When they disappear, you can't use them again for 1d12 hours.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "srd",
    },
  ],
  itemsWGTMM: [
    {
      name: "Aegis of Dread",
      type: "Armor",
      subtype: "Shield",
      description:
        "When a creature misses you with a melee weapon attack while you are holding this shield, you can use your reaction to cause the shield to emanate a sense of dread. The attacker must succeed on a DC 13 Wisdom saving throw or become frightened of you until the end of its next turn. ",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "shield_5.png",
    },
    {
      name: "Amulet of Freshness",
      type: "Wondrous item",
      subtype: "",
      description:
        "This locket carries a faint scent of fresh herbs. As an action, you can open the locket to cause the scent to grow more intense. Until the end of your next turn, creatures within 10-foot of you have advantage on saving throws against poison. Once used, this property can't be used again until the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
      imageSRC: "amulet_2.png",
    },
    {
      name: "Angel's Heart",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic amulet has 7 charges and regains all expended charges daily at dawn. As an action, you can expend its charges to cast one of the following spells: <i>detect evil and good</i> (1 charge), <i>divination</i> (4 charges), <i>shield of faith</i> (1 charge), <i>tongues (3 charges)</i>, and <i>true seeing</i> (6 charges). \n <i><b>Angelic Ally</b></i>. As an action, you can speak the amulet's command word to summon a deva in an unoccupied space within 60 feet as if you had cast the <i>planar ally</i> spell. The deva performs one task for you without asking anything in return, though it refuses a request that would require it to hurt the innocent or act dishonorably. Once used, the amulet loses this property.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "amulet_1.png",
    },
    {
      name: "Animated Painting, Lesser",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic painting depicts a beast, a dragon, or a monstrosity with a CR of 4 or lower. When a command word is spoken, the creature springs to life, leaving the canvas blank as it appears in the nearest unoccupied space next to the painting. The creature understands your verbal commands, but can't speak, cast spells, or use legendary actions even if its statistics would normally allow it to do so. It regards you as its companion and obeys your commands as best as it can, taking its turn on your initiative. After 1 hour has passed, or if the creature dies before then, it returns to the canvas. Once this property has been used, it can't be used again until 7 days have passed. The GM chooses the depicted creature or determines it randomly.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Animated Painting, Greater",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic painting depicts a beast, a dragon, or a monstrosity with a CR of 7 or lower. When a command word is spoken, the creature springs to life, leaving the canvas blank as it appears in the nearest unoccupied space next to the painting. The creature understands your verbal commands, but can't speak, cast spells, or use legendary actions even if its statistics would normally allow it to do so. It regards you as its companion and obeys your commands as best as it can, taking its turn on your initiative. After 1 hour has passed, or if the creature dies before then, it returns to the canvas. Once this property has been used, it can't be used again until 7 days have passed. The GM chooses the depicted creature or determines it randomly.",
      rarity: "Very Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Animated Painting, Superior",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic painting depicts a beast, a dragon, or a monstrosity with a CR of 10 or lower. When a command word is spoken, the creature springs to life, leaving the canvas blank as it appears in the nearest unoccupied space next to the painting. The creature understands your verbal commands, but can't speak, cast spells, or use legendary actions even if its statistics would normally allow it to do so. It regards you as its companion and obeys your commands as best as it can, taking its turn on your initiative. After 1 hour has passed, or if the creature dies before then, it returns to the canvas. Once this property has been used, it can't be used again until 7 days have passed. The GM chooses the depicted creature or determines it randomly.",
      rarity: "Legendary",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Animator's Quill",
      type: "Wondrous item",
      subtype: "",
      description:
        "As an action, you can animate a tiny creature that you have drawn with this quill. The creature manifests as a three-dimensional representation of the drawing made out of a solid, purple substance. The creature uses a rat's statistics but has 6 Intelligence, +4 to Dexterity (Stealth) checks, and can cast invisibility (targeting only itself) at will. It can't speak but shares a telepathic bond with you and understands simple commands, which it follows as best as it can. As an action, you can see through the creature's eyes. There is no limit to how far away from you the creature can move, but it can't enter another plane of existence. After 1 hour it dissipates into thin air. Once used, this property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Arctic Ring",
      type: "Ring",
      subtype: "",
      description:
        "While wearing this magic ring, you have immunity to cold damage and difficult terrain composed of ice or snow doesn't cost you extra movement. \n <b><i>Winter Magic.</i></b> This magic ring has 3 charges and regains all expended charges daily at dawn. As an action, you can expend its charges to cast one of the following spells (spell save DC 17): <i>ice storm</i> (1 charge), <i>cone of cold</i> (2 charges), or <i>wall of ice</i> (3 charges). \n <b><i>Aura of Cold.</i></b> As an action, you can speak the ring's command word to cause the temperature to drop drastically around you for 1 minute. Any creature that starts its turn within 5 feet of you takes 1d6 cold damage. In addition, a sheen of slippery ice forms in any square you move through. The ice is difficult terrain and a creature that starts its turn there or enters the area for the first time on its turn must succeed on a DC 10 Dexterity saving throw or fall prone. The ice melts away after 1 minute. Once used, this property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Argh'yak Bow",
      type: "Weapon",
      subtype: "Shortbow",
      description:
        "When the string on this magic shortbow is drawn, the goblinoid face decorating the bow comes to life, muttering curses and spitting insults in Goblin. When you hit a creature with an attack roll using this bow, the target takes an extra 1d6 piercing damage if it has dealt damage to you since the end of your last turn. \n <b><i>Witch's Soul.</i></b> This bow has 3 charges and regains all expended charges daily at dawn. As an action, you can expend its charges to cast one of the following spells (spell save DC 15): <i>bane</i> (1 charge), <i>silence</i> (2 charges), or <i>bestow curse</i> (3 charges). ",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "bow_8.png",
    },
    {
      name: "Arrow of Seeking",
      type: "Weapon",
      subtype: "Arrow",
      description:
        "When you make a ranged attack with this arrow, you don't make an attack roll for the attack, but instead choose a target you have seen. If the target is within 600 feet of you, the arrow flies unerringly toward it, moving around obstacles and ignoring cover. If the arrow reaches the target, it must succeed on a DC 17 Dexterity saving throw or take damage as if it were hit by the arrow.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Assassin's Blade",
      type: "Weapon",
      subtype: "Shortsword",
      description:
        "When you hit with an attack roll using this magic shortsword, the creature takes an extra 1d6 necrotic damage and it can't regain hit points until the start of your next turn. \n <b><i>Life Drain.</i></b> When you hit a creature with this shortsword, you can force that creature to make a DC 15 Constitution saving throw. On a failure, the creature suffers 1 level of exhaustion and is paralyzed for 1 minute. The creature can repeat the saving throw at the end of each of its turns and whenever it takes damage, ending the effect on a success. While the target is paralyzed this way, you can use an action on each of your turns to cause it to suffer 1 level of exhaustion and you regain 4d6 hit points. The effect ends if the target dies, if you use your action to do anything else, or if you or the shortsword is ever more than 5 feet away from the target. Once used, this property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "dagger_4.png",
    },
    {
      name: "Bag of Cooling",
      type: "Wondrous item",
      subtype: "",
      description:
        "This leather bag is sealed with a large metal buckle resembling a snow crystal and can hold 2 cubic feet/60 pounds. The temperature inside the bag is always 40 degrees Fahrenheit (5 degrees Celsius).",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Bag of Monsters",
      type: "Wondrous item",
      subtype: "",
      description:
        "This sturdy and worn satchel is filled with 7 weirdly malformed gobbets of flesh. \n As an action, you can pull a gobbet of flesh from the bag and throw it up to 20 feet. When the gobbet lands, it transforms into a creature you determine by rolling a d8 (1: <b>ankheg</b>; 2: <b>basilisk</b>; 3: <b>darkmantle</b>; 4: <b>manticore</b>; 5: <b>mimic</b>; 6: <b>owlbear</b>; 7: <b>rust monster</b>; 8: your choice of the aforementioned creatures). When the creature drops to 0 hit points or when 1 hour has passed, it crumbles into dust and a new gobbet of flesh representing the creature reforms inside the bag. \n When the creature drops to 0 hit points or when 1 hour has passed it crumbles into dust and a new gobbet of flesh representing the creature reforms inside the bag. \n The creature is friendly to you and your companions. In combat, it shares your initiative count and takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don't issue any, it takes the Dodge action and uses its move to avoid danger. If you are unconscious at the start of your turn, you lose control of all creatures summoned from the bag. \n Whenever you use the bag to summon a creature, roll a d4. If the result is equal to or lower than the number of creatures currently summoned with the bag (including the creature you just summoned), you lose control of all creatures summoned from the bag. \n A creature no longer under your control acts at the GM's discretion, possibly attacking the creature closest to it or fleeing to find safety. The summoned creature no longer dissolves into dust when 1 hour has passed, but instead persists until it drops to 0 hit points. Still bound by the bag's magic, the creature will not stray far from whoever carries the bag and instead remains in the general area. If control over a creature is lost, that creature can't be summoned by the bag again until it is slain and its gobbet of flesh has reformed in the bag. \n Once three gobbets of flesh have been pulled from the bag, it can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Bag of Shared Holding",
      type: "Wondrous item",
      subtype: "",
      description:
        "This bag has an interior space considerably larger than its outside dimensions, roughly 1 foot in diameter at the mouth and 2 feet deep. The bag can hold up to 250 pounds, not exceeding a volume of 32 cubic feet. The bag weighs 5 pounds, regardless of its contents. It functions as a <i>bag of holding</i>, except as noted below. \n <b><i>Shared Holding.</i></b> Two creatures each holding one end of the drawstring at the bag's neck can use an action to tie it shut. As they do so, their names (the names most commonly used to refer to them) appear on the side of the bag, etched in gold thread and the bag can be reopened only by these two creatures pulling on its string together. Destroying the bag causes its contents to be scattered in the Astral Plane. Once reopened, the creatures' names disappear from the bag and it can be used freely until its string is tied again this way.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Baneful Weapon",
      type: "Weapon",
      subtype: "Any",
      description:
        "Once per turn, when you hit a creature with an attack roll using this magic weapon, you can force the target to make a DC 13 Charisma saving throw. On a failure, whenever the target makes an attack roll or saving throw until the end of your next turn, the target must roll a d4 and subtract the number rolled from the attack roll or saving throw.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "axe_5.png",
    },
    {
      name: "Basilisk's Blade",
      type: "Weapon",
      subtype: "Dagger",
      description:
        "This magic dagger has 5 charges and regains all expended charges daily at dawn. When you hit a creature with an attack roll using this dagger, you can expend 1 charge to deal an additional 2d6 poison damage to the target or 3 charges to turn the target into stone as if you had cast the <i>flesh to stone</i> spell (save DC 15) from the dagger.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "dagger_5.png",
    },
    {
      name: "Beacon Shuriken",
      type: "Weapon",
      subtype: "Dart",
      description:
        "When you hit with an attack roll using this magic dart, the target sheds dim light in a 10-foot radius until the end of your next turn. While the target is glowing this way, any attack roll against the target has advantage if the attacker can see it, and the target can't benefit from being invisible.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Beauty's Bane",
      type: "Wondrous item",
      subtype: "",
      description:
        "As an action, you can speak this magic handmirror's command word and hold it up before a creature within 5 feet of you. If the creature has an Intelligence score of 6 or higher and can see the mirror, it must succeed on a Wisdom saving throw against a DC equal to its Charisma score or become charmed by its own reflection. While charmed this way, the target is also stunned. The target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. The effect also ends for the target if it takes damage, if someone else uses an action to shake the creature out of its stupor, or it can no longer see itself in the mirror. Once used, this property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Bladesinger's Spear",
      type: "Weapon",
      subtype: "Spear",
      description:
        "You have a +1 bonus to attack and damage rolls made with this magic spear, which has the finesse property. The spear returns to your hand immediately after it is used to make a ranged weapon attack. You gain the following benefits while holding the spear:  \n&#8226; You can use the spear as a spellcasting focus for your wizard spells. \n&#8226; When you hit with an attack roll using the spear, you can unprepare one wizard spell you have prepared to deal extra force damage equal to 1d8 + the spell's level to the target.  \n When you unprepare a spell using this spear, you can't cast that spell again until you have finished a long rest and spent the requisite time preparing it again.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "spear_3.png",
    },
    {
      name: "Bone Merchant's Coin",
      type: "Wondrous item",
      subtype: "",
      description:
        "You have advantage on death saving throws while carrying this magic coin. In addition, you can flip the coin as an action to send a magical ping to an undead creature with which you are familiar. The creature recognizes you as the sender if it knows you and becomes aware of your precise position.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Brightmind Cap",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic cap has a lantern mounted on the top. When a candle is lit within the lantern, it casts bright light in a 5-foot radius and dim light for an additional 5 feet. As an action, you can speak the cap's command word to cause the candle to cast bright light in a 30-foot radius and dim light for an additional 30 feet. \n <b><i>Brightmind.</i></b> When you fail an Intelligence or Wisdom ability check or saving throw while wearing this cap, you can choose to reroll that ability check or saving throw. You must use the second roll. Once used, this property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Buckleshot Belt",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic belt, you can use a bonus action to shoot its metal buckle at a creature within 30 feet of you. Shooting the belt's buckle is a ranged weapon attack you are considered proficient with that deals 1d4 bludgeoning damage. If recovered, the buckle can be reattached to the belt as an action.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Caged Star",
      type: "Weapon",
      subtype: "Morningstar",
      description:
        "This magic morningstar has 3 charges and regains all expended charges daily at dawn. When an attacker that you can see hits you with an attack while you are holding it, you can expend 1 charge as a reaction to halve the attack's damage against you. When you do so, the morningstar's spiked ball glows with a fierce, radiant light until the end of your next turn. When you hit with an attack roll using the morningstar while it glows this way, the target takes an extra 1d8 radiant damage. ",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Cat's Eye Amulet",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic amulet, you have advantage on Dexterity saving throws and can comprehend and verbally communicate with beasts.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "amulet_6.png",
    },
    {
      name: "Champion's Shield",
      type: "Armor",
      subtype: "Shield",
      description:
        "When a creature you can see attacks a target within 30 feet of you while you are carrying this magic shield, you can use your reaction to magically swap places with the target of the attack, if it is willing. The attack is made against you instead.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "shield_6.png",
    },
    {
      name: "Charmer's Tambourine",
      type: "Wondrous item",
      subtype: "",
      description:
        "You have advantage on Charisma (Performance) checks while playing this magic tambourine. In addition, you can cast the <i>minor illusion</i> cantrip at will. \n <b><i>Enthralling Performance.</i></b> This magic tambourine has 3 charges and regains all expended charges daily at dawn. You can expend its charges to cast the spells <i>charm person</i> (1 charge) or <i>enthrall</i> (2 charges) from it. The spell save DC is 13 or your spell save DC, whichever is higher.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Chronomancer's Staff",
      type: "Staff",
      subtype: "",
      description:
        "While holding this magic staff, you can't be surprised and you have advantage on attack rolls, ability checks, and saving throws. Additionally, other creatures have disadvantage on attack rolls against you. \n <b><i>Time Control.</i></b> As an action, you can target a creature within 60 feet that you can see with one of the following magical effects, using your spell save DC: \n&#8226; The creature must succeed on a Constitution saving throw or be incapacitated and have a speed of 0 until the end of your next turn or until it takes damage. \n&#8226; The creature must succeed on an Intelligence saving throw or take 14 (4d6) psychic damage and until the end of your next turn, the target has disadvantage on saving throws, and attack rolls against it are made with advantage.",
      rarity: "Legendary",
      attunement: "Requires attunement by a Spellcaster",
      source: "wgtmm",
      imageSRC: "staff_4.png",
    },
    {
      name: "Clockwork Sword",
      type: "Longsword",
      subtype: "",
      description:
        "This magic item appears to be a sword hilt. While grasping the hilt, you can use a bonus action to cause a blade made from metal and gemstones to fold out from the hilt, or make the blade disappear. \n <b><i>Clockwork Strike.</i></b> Once per turn when you hit with an attack roll using this longsword, you can cause one of the following effects: \n&#8226; <b><i>Flash.</i></b> The target takes 1d8 radiant damage and must succeed on a DC 15 Constitution saving throw or be blinded until the end of your next turn. \n&#8226; <b><i>Propulsion.</i></b> The target and other creatures within 5 feet of it (except you) take 1d8 force damage and must succeed on a DC 15 Strength saving throw or be pushed up to 15 feet away from you. \n&#8226; <b><i>Shock.</i></b> The target takes 1d8 lightning damage and can't take reactions until the end of your next turn. \n Whenever you use this property, roll a d8. On a 1, the blade malfunctions and you suffer the same effect as the target. When the blade malfunctions, it folds in on itself and disappears, and can't be brought out again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "sword_15.png",
    },
    {
      name: "Commander's Helmet",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic helmet has 3 charges and regains all expended charges daily at dawn. When another creature within 30 feet that can hear you makes an attack roll, ability check, or saving throw, you can use your reaction and expend 1 charge to give that creature advantage on its roll. ",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Dancer's Boots",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing these boots, you have advantage on Charisma (Performance) checks while dancing. Additionally, when you walk, you can choose to leave tracks that look like three humanoids of your size were walking, instead of just one.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Death Petal Rose",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic rose has 3 charges. When you fail on a death saving throw while carrying this rose, you can expend 1 charge to succeed instead. Once all of its charges have been used, the rose withers and is destroyed.",
      rarity: "Common",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Deathgrasp Glove",
      type: "Wondrous item",
      subtype: "",
      description:
        "While you wear this magic glove, a creature grappled by you can't regain hit points and takes 1d8 necrotic damage at the start of each of its turns. \n <b><i>Death's Grasp.</i></b> As an action, you can speak the glove's command word and cause it to animate for 1 minute. The animated glove detaches from your hand, begins to hover, flies up to 30 feet, and attempts to grapple one creature of your choice within 5 feet of it, using your Strength (Athletics) check. A creature grappled this way is considered grappled by you. While the glove hovers, you can use a bonus action to cause it to fly up to 30 feet to another spot within 30 feet of you and grapple a creature within 5 feet of it. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Djinni's Bracers",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing these magic bracers, you gain a +1 bonus to AC and can speak and understand Auran. \n <b><i>Djinni's Magic.</i></b> These bracers have 7 charges and regain all expended charges daily at dawn. As an action, you can expend its charges to cast one of the following spells (save DC 17): <i>detect magic</i> (1 charge), <i>invisibility</i> (2 charges), <i>gaseous form</i> (3 charges), <i>major image</i> (3 charges), or <i>wind walk</i> (6 charges). \n <b><i>Curse of Servitude.</i></b>  Once you don these cursed bracers, you can't take them off until you are targeted by the remove curse spell or similar magic. While wearing the bracers, any request made directly to you that begins with the words “I wish...” is treated as if the speaker had cast a <i>suggestion</i> spell on you (which you automatically fail your saving throw against) and you must attempt to fulfill the request to the best of your ability. A creature can only make one such request of you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Dragon's Scepter",
      type: "Rod",
      subtype: "",
      description:
        "While holding this magic rod, you can use an action to attempt to imprison a dragon within 30 feet of you in the scepter as if you had used the “minimus containment” effect of the <i>imprisonment</i> spell (save DC 17). Only one dragon can be imprisoned in the scepter at a time, and if a dragon succeeds on the saving throw it is immune to this effect for the next 24 hours. \n The scepter has 3 charges for the following properties, which you can use while a dragon is imprisoned in the scepter. The scepter regains all expended charges daily at dawn. \n <b><i>Draconic Magic.</i></b> As an action, you can expend 1 charge to cast the spells <i>fear</i> (spell save DC 17) or <i>fly</i> from the scepter. \n <b><i>Dragon Breath.</i></b> As an action, you can expend 3 charges to make a breath weapon attack. Each creature in a 30-foot cone must make a DC 17 Dexterity saving throw, taking 10d6 damage on a failure, or half as much on a success. The type of damage dealt depends on which dragon is imprisoned in the scepter; acid (black/copper), cold (silver/white), fire (brass/gold/red), lightning (blue/bronze), or poison (green). \n <b><i>Draconic Release.</i></b> If you expend the scepter's last charge, roll a d20. On a 1, the dragon is released from the scepter and manifests in the nearest unoccupied space. It acts according to its nature. You can also choose to release the dragon from the scepter as an action.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Dragonskull Helmet",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic helmet, you have resistance to [option] damage. \n <b><i>Draconic Transformation.</i></b> While wearing the helmet, you can use an action to transform into a young dragon of the type the helmet is made from. The transformation functions as the <i>polymorph</i> spell and lasts for 1 minute or until your concentration ends (as if concentrating on a spell). Once used, this property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      optionName: "Color",
      options: [
        [
          { name: "Black", value: "acid" },
          { name: "Blue", value: "lightning" },
          { name: "Brass", value: "fire" },
          { name: "Bronze", value: "lightning" },
          { name: "Copper", value: "acid" },
          { name: "Gold", value: "fire" },
          { name: "Green", value: "poison" },
          { name: "Red", value: "fire" },
          { name: "Silver", value: "cold" },
          { name: "White", value: "cold" },
        ],
      ],
      source: "wgtmm",
    },
    {
      name: "Dreamwalker's Amulet",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic amulet, you don't need to sleep, but instead meditate deeply, remaining semiconscious. While in this trance, you can manifest your consciousness as a spirit on the Ethereal Plane as with the spell <i>etherealness</i>. The spirit resembles you and has your game statistics, except that it has AC 10, 1 hit point, has a fly speed of 10 ft. (hover), and can't take any other actions than moving. You can see and hear what the spirit sees and hears. The spirit can move no further than 1 mile away from where your physical body is and can't leave the Ethereal Plane. The spirit vanishes when reduced to 0 hit points, if it's forced to leave the Ethereal Plane, or when your trance ends. \n <b><i>Dreamwalker's Magic.</i></b> The amulet has 5 charges and regains all charges daily at dawn. While wearing it, you can expend its charges to cast <i>dream</i> (1 charge) or <i>sleep</i> (1 charge per spell level). ",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "amulet_4.png",
    },
    {
      name: "Envisioner's Compass",
      type: "Wondrous item",
      subtype: "",
      description:
        "While holding this compass, you can use your action to set a compass course to a location, object, or creature that is on the same plane of existence as you. The compass needle points in the direction of the target for 24 hours or until this property is used again. If the creature or object can't be targeted by divination magic or be perceived through magical scrying sensors, the attempt to set a course to it automatically fails. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
      imageSRC: "compass_1.png",
    },
    {
      name: "Extending Staff",
      type: "Staff",
      subtype: "",
      description:
        "While holding this staff, you can use a bonus action to cause it to magically become 5, 10, or 15 feet long. At 5 feet long, this staff can be wielded as a magic quarterstaff. At 10 feet long, the staff also adds 5 feet your reach when you attack with it, as well as when determining your reach for opportunity attacks, but you have disadvantage on attacks with it against a target within 5 feet of you. At 15 feet long, you can use it to add 10 feet to your running long jump or high jump. When you do so, you must succeed on a DC 10 Strength (Athletics) or Dexterity (Acrobatics) check or fall prone instead.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Flask of Cloning",
      type: "Wondrous item",
      subtype: "",
      description:
        "If a cubic inch of flesh from a living, Medium creature is squeezed into this flask, the flesh magically forms into a miniature clone of that creature. If a clone already exists within the flask it dissolves into the liquid, leaving only the new clone. The clone remains inert and endures indefinitely, as long as the flask remains undisturbed. \n If the original creature dies while its clone is in the flask, its soul transfers to the clone as long as the soul is free and willing to return. The clone then grows to the original creature's full size, shattering the flask. The clone is physically identical to the original and has the same personality, memories, and abilities, but none of the equipment belonging to the original. The original creature's physical remains, if they still exist, become inert and can't thereafter be restored to life by any means since the creature's soul is elsewhere.",
      rarity: "Very Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Furnace Flail",
      type: "Weapon",
      subtype: "Flail",
      description:
        "When you hit with an attack roll using this magic flail, the target takes an extra 1d8 fire damage. \n <b><i>Sparks.</i></b> This flail has 3 charges and regains all expended charges daily at dawn. When you hit a creature with an attack roll using this flail, you can expend 1 charge to shower the target in sparks. The target must succeed on a DC 15 Constitution saving throw or be blinded until the end of your next turn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "flail_1.png",
    },
    {
      name: "Gauntlets of Restoration",
      type: "Wondrous item",
      subtype: "",
      description:
        "These magic gauntlets have 7 charges and regain all expended charges daily at dawn. While wearing them, you can heal creatures and mend objects with your touch. Once per turn when you hit a non-Undead, non-Construct creature with an unarmed attack, you can expend the gauntlets' charges to have the target regain hit points equal to your Strength or Dexterity modifier (your choice) + 1d4 (1 charge), 1d8 (2 charges), or 2d6 (3 charges), instead of taking damage from your attack. If the target is a Construct or an object, you can have it be affected as by the spell <i>mending</i> instead (no charges expended).",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "gauntlets_4.png",
    },
    {
      name: "Ghost Shroud",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic cloak has 3 charges and regains all expended charges daily at dawn. As a bonus action while wearing it, you can expend 1 charge to become incorporeal until the end of your next turn, gaining the following benefits: \n&#8226; Your weapon attacks deal force damage instead of bludgeoning, piercing, or slashing damage. \n&#8226; You can't be grappled or restrained. \n&#8226; You have resistance to bludgeoning, piercing, and slashing damage from nonmagical attacks. \n&#8226; You can move through other creatures and objects as if they were difficult terrain. You take 1d10 force damage if you end your turn inside an object. If the effect ends while you are inside a solid object, you are pushed to the nearest unoccupied space, taking 1d10 force damage for every 5 feet traveled.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "cloak_4.png",
    },
    {
      name: "Glove of the Woodland",
      type: "Wondrous item",
      subtype: "",
      description:
        "While you are wearing this glove, any beast or plant creature that targets you with an attack or harmful spell must first make a DC 15 Wisdom saving throw. On a failed save, the creature must choose a new target or lose the attack or spell. On a success, the creature is immune to this effect for 24 hours. \n <b><i>Woodland Magic.</i></b> This magic glove has 7 charges and regains all expended charges daily at dawn. As an action, you can expend its charges to cast one of the following spells (spell save DC 15): <i>animal messenger</i> (2 charges), <i>commune with nature</i> (5 charges), <i>entangle</i> (1 charge), <i>freedom of movement</i> (4 charges), <i>gust of wind</i> (2 charges), <i>longstrider</i> (1 charge), <i>pass without trace</i> (2 charges), <i>plant growth</i> (3 charges), <i>speak with animals</i> (1 charge), <i>spike growth</i> (2 charges), <i>speak with plants</i> (3 charges), <i>tree stride</i> (5 charges), or <i>wall of thorns</i> (6 charges).",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Goblet of Confidence",
      type: "Wondrous item",
      subtype: "",
      description:
        "As an action, you can speak this magic goblet's command word and have it fill with liquid confidence, a syrupy mixture that tastes a bit like honey and fresh morning dew. When you drink from the cup, you can choose to gain advantage on one ability check using Charisma you make within the next 10 minutes. Once used, this property can't be used again before the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Goodberry Hat",
      type: "Wondrous item",
      subtype: "",
      description:
        "A single berry hangs on the stalk on this magical hat. A creature can pluck and eat the berry as an action. Eating the berry restores 1 hit point, and the berry provides enough nourishment to sustain a creature for one day. The berry loses its potency if it hasn't been consumed within 1 hour after being plucked. If the berry is plucked, a new berry grows on the stalk at the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
      imageSRC: "hat_2.png",
    },
    {
      name: "Grinsplitter Weapon",
      type: "Wondrous item",
      subtype: "Any Slashing",
      description:
        "When you roll a 20 on your attack roll using this magic weapon, the target must make a DC 13 Wisdom saving throw or burst into laughter if it is a creature with an Intelligence score of 4 or higher. On a failure, the target falls prone, becoming incapacitated and unable to stand up. The target can repeat the saving throw at the end of each of its turns and each time it takes damage, ending the effect on itself on a success.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
      imageSRC: "axe_4.png",
    },
    {
      name: "Hag's Delight",
      type: "Wondrous item",
      subtype: "",
      description:
        "If you spend at least 1 minute continually smoking this pipe, you can use the pipe to cast the <i>modify memory spell</i> (save DC 21) on any creatures of your choice who have remained within 20 feet of you for the past minute. The spell functions as usual, except that any memory you eliminate, change, or create must be shared by all creatures targeted by the spell, and must have happened within the last 10 minutes. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Hat of Naivety",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic hat, you have disadvantage on Wisdom (Insight) checks. \n <b><i>Fool's Charm.</i></b> When you roll a skill check using Charisma while wearing this hat, you can choose to gain advantage on the roll. Once used, this property can't be used again until the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",

      imageSRC: "hat_1.png",
    },
    {
      name: "Heartlock Armor",
      type: "Armor",
      subtype: "Studded Leather",
      description:
        "This magic studded leather armor comes with a golden key. While wearing it, you automatically succeed your saving throw against any spell or effect that would alter your form. \n <b><i>Heartlock.</i></b> This armor has 3 charges and regains all expended charges daily at dawn. As a bonus action, you can expend 1 charge and turn the armor's key to a specific position in the lock in the armor's centerpiece to cause one of the following effects: \n&#8226; You gain the “enlarge” effect of the <i>enlarge/reduce</i> spell for 1 minute (no concentration required). \n&#8226; You gain the “reduce” effect of the <i>enlarge/reduce</i> spell for 1 minute (no concentration required). \n&#8226; You cast the spell <i>knock</i>.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "light_armor_7.png",
    },
    {
      name: "Iceshard Whip",
      type: "Weapon",
      subtype: "Whip",
      description:
        "When you hit with an attack roll using this magic whip, the target takes an extra 1d6 cold damage and has disadvantage on the next weapon attack roll it makes before the end of its next turn. \n <b><i>Icy Restraints. </i></b> When you roll a 20 on your attack roll using this weapon, the target also becomes restrained (escape DC 15) in a block of ice for 1 minute. While restrained this way, the target takes 1d6 cold damage at the start of each of its turns.",
      rarity: "Very Rare",
      attunement: "",
      source: "wgtmm",

      imageSRC: "whip_1.png",
    },
    {
      name: "Incense of Erudition",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magical incense burns for 1 hour and produces a soothing scent of nutmeg and morning dew. A creature that inhales the incense during a short rest gains advantage on Wisdom, Intelligence, and Charisma ability checks and saving throws for 8 hours.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
      imageSRC: "incense_1.png",
    },
    {
      name: "Incense of Fortitude",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magical incense burns for 1 hour and produces an intoxicating scent of spices and myrrh. A creature that inhales the incense during a short rest gains temporary hit points equal to their character level and has advantage on Constitution saving throws for 8 hours.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
      imageSRC: "incense_1.png",
    },
    {
      name: "Incense of Restoration",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magical incense burns for 1 hour and produces a pleasant scent of lavender and aloe. Inhaling the incense during a short rest cures a creature of any temporary blindness, deafness, diseases, or reduction of their hit point maximum, and reduces their exhaustion level by one.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
      imageSRC: "incense_1.png",
    },
    {
      name: "Jug of Endless Wind",
      type: "Wondrous item",
      subtype: "",
      description:
        "This stoppered metal jug weighs 2 pounds. As an action, you can remove the stopper and speak one of three command words, whereupon wind pours out of the jug until the end of your next turn. Choose from the following options: \n&#8226; <b>“Gust”</b> produces a wind strong enough to move an object that is neither held nor carried and that weighs no more than 50 pounds up to 20 feet away from you, or push one Medium or smaller creature up to 10 feet away from you unless it succeeds on a DC 13 Strength saving throw. \n&#8226; <b>“Wall”</b> produces a whirling wind in a 10-foot radius around you that moves with you. Until the start of your next turn, the area is difficult terrain for creatures other than you, and arrows, bolts, and other ordinary projectiles launched at targets within the area automatically miss. \n&#8226; <b>“Leap”</b> produces a wind that allows you to immediately fly up to 30 feet without provoking opportunity attacks.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Katana of the Deathtouched",
      type: "Weapon",
      subtype: "Longsword",
      description:
        "You have a +1 bonus to attack and damage rolls made with this magic longsword. \n <b><i>Deathtouched.</i></b> When you reduce a creature to 0 hit points while holding this magic weapon, you can use your reaction to gain temporary hit points equal to your character level. \n <b><i>Death Ward.</i></b> Whenever you would drop to 0 hit points as a result of taking damage, you can choose to drop to 1 hit point instead. Once used, this property can't be used again until the next dawn. ",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "sword_14.png",
    },
    {
      name: "Key to Anywhere",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic key automatically adapts in size to fit any lock it is set into. When you turn this key in a door's keyhole, you can conjure a portal that links the door to another door on any plane that you select, allowing free passage between the two doors for 10 minutes, or until the link is severed by turning this key in either of the two doors. Once used, this property can't be used again until the next dawn. \n If you are familiar with the door, or if you have a precise picture of it, the key always opens the correct door. If you're less familiar with the door, there's a 25% (seen casually), 33% (seen once), or 75% (second-hand description) chance you'll arrive through a random door of the GM's choice. \n If a door is located in an area where teleportation or planar travel is prevented, such as by a deity, the ruler of said plane of existence, or a magical effect or a spell like <i>private sanctum</i>, the attempt to open the door automatically fails and the property can't be used until the next dawn.",
      rarity: "Very Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Liar's Stone",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic amulet, you can choose one false statement. Any effect that can read your thoughts or otherwise sense falsehoods perceives this statement as true for the next 24 hours. Once used, this property can't be used again until the next dawn.",
      rarity: "Common",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "amulet_5.png",
    },
    {
      name: "Living Spellbook",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic book holds hundreds of pages, half of which contain arcane scribblings in a neat handwriting. You can use this book as your spellbook and scribe new spells into it. Creatures that have advantage on saving throws against spells don't have advantage against wizard spells you cast while holding this spellbook. \n <b><i>Master Wizard.</i></b> The spellbook is sentient and has the personality of a master wizard. Its alignment is determined by the GM or by rolling a d4; 1: neutral good, 2: lawful neutral, 3: chaotic neutral, 4: neutral evil. The book has an Intelligence of 18, a Wisdom of 12, and a Charisma of 10. It speaks, reads, and understands Common, Draconic, Elvish, and Infernal, and can see and hear normally out to a range of 60 feet. While the wizard's sentience within remembers nothing of who it was in life, it still possesses a wealth of knowledge. If you spend at least 1 minute discussing an arcane topic, such as a mythical event, a spell, a creature, or a magic item, with the spellbook, you gain advantage on any Arcana, History, Nature, or Religion checks pertaining to that topic. \n <b><i>Impromptu Memorization.</i></b> As a bonus action, you can replace one of your prepared wizard spells with a different spell scribed in the book as the spellbook whispers the spell's incantation to you. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement by a Wizard",
      source: "wgtmm",
    },
    {
      name: "Lux's Teacup Holster",
      type: "Wondrous item",
      subtype: "",
      description:
        "This finely crafted leather teacup holster can be worn at the hip and contains an ornately decorated teacup and saucer, plus a small side pouch for tea. While holding the teacup, you can use an action to speak the holster's command word and have the cup magically fill with scalding hot (“Tea. Hot.”) or iced (“Tea. Cold.”) tea of the flavor of tea leaves contained in the side pouch. If the pouch is empty, the cup fills with flavorless water instead. Once the holster has produced 2 gallons of liquid, it can't produce more until the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Mage's Blood",
      type: "Potion",
      subtype: "",
      description:
        "This flask contains a viscous liquid that can be smeared on a weapon or up to 10 pieces of ammunition as an action. When you hit a creature with a weapon or piece of ammunition coated in the liquid, the target must succeed on a DC 15 Constitution saving throw or be poisoned for 1 minute. While poisoned this way, the creature has disadvantage on saving throws against spells and other magical effects.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Mage's Diadem",
      type: "Wondrous item",
      subtype: "",
      description:
        "When you cast a spell while wearing this magic diadem, you gain temporary hit points equal to the level of the spell (minimum of 1 hit point). \n <b><i>Contingency.</i></b> This diadem can store a single spell cast into it. During a process that takes 10 minutes, any creature can cast a spell of up to 5th level that has a casting time of 1 action, and that can target you, into the diadem by touching it as the spell is cast. The spell has no effect, but is stored in the diadem until a circumstance described by you occurs. The spell takes effect immediately after the circumstance is met for the first time, whether or not you want it to. The spell uses the spell slot level, spell save DC, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. The spell takes effect only on you, even if it can normally target others. Once the spell takes effect, it is gone from the diadem and a new spell can't be stored in the diadem until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "diadem_1.png",
    },
    {
      name: "Maiming Weapon",
      type: "Weapon",
      subtype: "Any",
      description:
        "When you roll a 20 on your attack roll using this magic weapon, the target's speed is halved, and it has disadvantage on Strength and Dexterity ability checks and saving throws until it finishes a short rest or receives magical healing.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Map of Many Places",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic map looks like a blank sheet of grungy parchment. As an action you can use the command phrase “where am I” to have the parchment magically show a topographical map of the area within a 5-mile radius, including all objects, structures, and terrain features larger than 20 cubic feet. The map remains for 1 hour or until you roll it up as an action. Once used, this property can't be used again until the next dawn. ",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Mithrandine Armor",
      type: "Armor ",
      subtype: "Medium or Heavy, but not Hide",
      description:
        "A unique mix of mithral reinforced with adamantine in vital sections, this armor doesn't impose disadvantage on Dexterity (Stealth) checks and has no Strength requirement. Additionally, while wearing this armor any critical hit against you becomes a normal hit.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Morphing Weapon",
      type: "Weapon",
      subtype: "Any",
      description:
        "While holding this magic weapon, you can use a bonus action to have it magically change its shape to that of another simple or martial weapon of your choice.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Nemesis Weapon",
      type: "Weapon",
      subtype: "Any",
      description:
        "Once per turn, when you hit with an attack roll using this magic weapon, you and the target both become cursed until the start of your next turn. Choose the nature of the curse from the following options: \n&#8226; You and the target can't regain hit points. \n&#8226; You and the target subtract 1d4 from the next saving throw you make. \n&#8226; Your attacks (including this attack) and spells deal an extra 1d8 necrotic damage to the target, and the target's attacks and spells deal an extra 1d8 necrotic damage to you.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Observer's Spyglass",
      type: "Wondrous item",
      subtype: "",
      description:
        "While looking through this magic spyglass you can see details of extremely distant creatures and objects up to 2,000 feet away but no closer than 100 feet. \n <b><i>Sailor's Sight.</i></b> This spyglass has 3 charges and regains all expended charges daily at dawn. As an action, you can expend 1 charge and speak its command word to activate its magic. For the next minute, while looking through the spyglass you gain advantage on Wisdom (Perception) checks that rely on sight. Additionally, you can see normally in darkness, both magical and nonmagical, and through any natural phenomena such as heavy rain, falling snow, or mist that would normally cause an area to be lightly or heavily obscured.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Orb of Spell Storing",
      type: "Wondrous item",
      subtype: "",
      description:
        "This orb can store a single cantrip or 1st level spell. Any creature can cast a spell into the orb by touching the orb as the spell is cast. The spell has no effect, other than to be stored in the orb. If the orb can't hold the spell, the spell is expended without effect. \n While holding the orb, you can cast the spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. Once used, the orb loses its magical properties.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Orb of Greater Spell Storing",
      type: "Wondrous item",
      subtype: "",
      description:
        "This orb can store a single spell of 3rd level or lower. Any creature can cast a spell into the orb by touching the orb as the spell is cast. The spell has no effect, other than to be stored in the orb. If the orb can't hold the spell, the spell is expended without effect. \n While holding the orb, you can cast the spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. Once used, the orb loses its magical properties.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Orb of Superior Spell Storing",
      type: "Wondrous item",
      subtype: "",
      description:
        "This orb can store a single spell of 5th level or lower. Any creature can cast a spell into the orb by touching the orb as the spell is cast. The spell has no effect, other than to be stored in the orb. If the orb can't hold the spell, the spell is expended without effect. \n While holding the orb, you can cast the spell stored in it. The spell uses the slot level, spell save DC, spell attack bonus, and spellcasting ability of the original caster, but is otherwise treated as if you cast the spell. Once used, the orb loses its magical properties.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Phasing Slippers",
      type: "Wondrous item",
      subtype: "",
      description:
        "When you take the Attack action while wearing these magic slippers, you can magically teleport up to 10 feet before each attack to an unoccupied space you can see.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "boots_11.png",
    },
    {
      name: "Potion of Empowerment",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you gain a +1 bonus to your spell attack rolls and to the saving throw DCs of your spells for 1 minute. ",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Greater Empowerment",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you gain a +2 bonus to your spell attack rolls and to the saving throw DCs of your spells for 1 minute. ",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Superior Empowerment",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you gain a +3 bonus to your spell attack rolls and to the saving throw DCs of your spells for 1 minute. ",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Expertise",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you gain proficiency in a skill of your choice for 1 hour. If you are already proficient in that skill, your proficiency bonus is doubled for any ability check you make using that skill.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Luck",
      type: "Potion",
      subtype: "",
      description:
        "When you drink the potion, you become blessed with extraordinary luck. Whenever you make an attack roll, an ability check, or a saving throw, or when an attack roll is made against you, you can choose to roll an additional d20. You can choose to do so after you roll the die, but before the outcome is determined. You choose which of the d20s is used for the attack roll, ability check, or saving throw. This effect lasts for 1 hour or until you have used your luck three times.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Magic Resistance",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you gain advantage on saving throws against spells and other magical effects for 1 hour.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Renewal",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you regain an expended 1st level spell slot.",
      rarity: "Varies",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Greater Renewal",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you regain an expended spell slot of up to 3rd level.",
      rarity: "Varies",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of Superior Renewal",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you regain an expended spell slot of up to 5th level.",
      rarity: "Varies",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Potion of the Phoenix",
      type: "Potion",
      subtype: "",
      description:
        "When you drink this potion, you become imbued with the latent energy of a phoenix for 1 year and 1 day or until the potion's magic is used to revive you. If you die while affected by this potion, you spring back to life with a burst of radiant energy at the start of your next turn. You regain hit points equal to half your hit point maximum and each creature of your choice that is within 30 feet of you takes 5d8 radiant damage and is blinded until the end of your next turn. \n The potion can also be administered to a creature that has died within the last minute as an action, immediately triggering its effect.",
      rarity: "Legendary",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Raven's Feathers",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing these magic bracers, you have advantage on Charisma (Deception) checks made to mimic simple sounds or voices you have heard. \n <b><i>Raven Form.</i></b> As an action, you can cast <i>polymorph</i> on yourself, transforming into a <b>raven</b>. While you are in the form of the raven, you retain your Intelligence, Wisdom, and Charisma scores. Once used, this property can't be used again until the next dawn. \n <b><i>Dark Omen.</i></b> When you touch a creature or hit it with an unarmed attack while wearing these bracers, you can curse the target. If you do, the next attack roll made against the target before the end of your next turn has advantage.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Ring of Alarm",
      type: "Ring",
      subtype: "",
      description:
        "While wearing this magic ring, you can use an action to speak its command word and specify a target creature (e.g., “Captain Yannis”) and a condition or set of conditions that involve you (e.g., “If I take damage or shout ‘Help'”). If at least one of the conditions is met, the ring sends a mental alarm to the target creature if it is on the same plane of existence, awakening it if it is sleeping. Once used, this property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Ring of Legendary Resistance",
      type: "Ring",
      subtype: "",
      description:
        "If you fail a saving throw while wearing this magic ring, you can choose to succeed instead. Once used, this property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "ring_5.png",
    },
    {
      name: "Ring of Shadows",
      type: "Ring",
      subtype: "",
      description:
        "While wearing this magic ring in dim light or darkness, you gain the following benefits: \n&#8226; You have resistance to bludgeoning, piercing, and slashing damage from nonmagical weapons. \n&#8226; You can use a bonus action to teleport up to 30 feet to an unoccupied space you can see that is also in dim light or darkness. \n&#8226; You can use an action to become invisible. You remain invisible until you make an attack, cast a spell, or are in an area of bright light.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "ring_6.png",
    },
    {
      name: "Ring of the Blood Pact",
      type: "Ring",
      subtype: "",
      description:
        "This magic ring can contain up to 3 charges. Whenever a creature dies within 30 feet of you, you can use your reaction to extract its remaining life essence and the ring gains 1 charge. Once per turn, when you make an attack roll, ability check, or saving throw, you can expend 1 charge to roll an additional d20 and use the higher of the two rolls. You can use this ability after the original roll, but before the outcome is revealed. \n <b><i>Curse.</i></b> Once you put on this cursed ring, you can't take it off unless you are targeted by the remove curse spell or similar magic. While you're wearing the ring and it doesn't hold 1 or more charges, you have one level of exhaustion that can't be removed.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Ring of Tranquility",
      type: "Ring",
      subtype: "",
      description:
        "While wearing this ring, you gain advantage on saving throws against being charmed or frightened. \n <b><i>Silence.</i></b> As an action, you can surround yourself with a 10-foot-radius aura of silence that functions as the spell <i>silence</i>. This effect lasts for 10 minutes or until you end it as a bonus action. Once used, this property can't be used again until the next dawn. ",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "ring_7.png",
    },
    {
      name: "Rod of Mimicry",
      type: "Rod",
      subtype: "",
      description:
        "This magic rod has 3 charges and regains all expended charges daily at dawn. While holding the rod, you can expend 1 charge as an action to cause a slobbering tongue to extend toward a creature you can see within 5 feet of you. The rod makes a melee attack roll with a +5 bonus. On a hit, the rod deals 1d6 bludgeoning damage and if the target is a Huge or smaller creature, it is also grappled by you. Ability checks made to escape this grapple have disadvantage and you have advantage on attack rolls against a creature you grapple this way. \n <b><i>Create Mimic.</i></b> As an action, you can expend 3 charges and touch an inanimate, nonmagical object no larger than 10 cubic feet and transform it into a mimic. The mimic is under your control and acts on its own initiative count. On your turn, you can mentally command the mimic if it is within 60 feet of you and you aren't incapacitated. You decide what action the mimic takes and where it moves during its next turn, or you can issue it a general command, such as to attack your enemies. The mimic reverts to an inanimate object after 1 hour or when reduced to 0 hit points.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Rod of Rimefrost",
      type: "Rod",
      subtype: "",
      description:
        "This magic rod has 7 charges and regains all expended charges daily at dawn. As an action, you can expend 1 charge to cause one of the following effects: \n&#8226; You create a nonliving object of ice that is no larger than a 5-foot cube within 30 feet of you. The object melts away after 1 hour. \n&#8226; The ground in a 10-foot square centered on a point within 30 feet becomes slippery ice. The ice is difficult terrain and a creature that starts its turn there or enters the area for the first time on its turn must succeed on a DC 10 Dexterity saving throw or fall prone. The ice melts away after 1 minute. \n&#8226; A Large or smaller creature within 30 feet you can see must make a DC 13 Dexterity saving throw or become encased in ice. The creature is restrained (escape DC 13) until the ice melts away after 1 minute.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Rope of Reaching",
      type: "Wondrous item",
      subtype: "",
      description:
        "When you grasp this 2-foot length of rope with both hands, you can use your action to create duplicates of your own hands made of magical energy at a point within 30 feet. Each hand is a tiny object with AC 12, 2 hit points, and immunity to poison and psychic damage. After 1 minute, or if a magical hand is reduced to 0 hit points, is more than 30 feet away from you, or you no longer grasp the rope with both your hands, both magical hands vanish. \n The magical hands function as your own and you can use them to manipulate objects, cast spells, shove or grapple other creatures, and even make weapon attacks. You use your own proficiencies and ability scores for any action you take using the hands.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Safety Shell",
      type: "Wondrous item",
      subtype: "",
      description:
        "Over the course of a short rest, you can choose one willing beast with a CR of 0 and pair the <i>safety shell</i> with the creature. When the creature drops to 0 hit points as a result of taking damage, the creature is absorbed into the <i>safety shell</i> and has the spell spare the dying cast on it. The creature remains in the shell for 24 hours or until you release it as a bonus action.  \n The <i>safety shell</i> can only be paired with one beast at a time.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Sands of Reminiscence",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic hourglass is empty but has a small hatch on the top, through which it can be filled with sand, dirt, dust, or liquid. When the hourglass is filled with a substance from an area and turned upside down, it projects colorless, ghostlike visions in an area up to 30 feet around it, showing an event that has transpired in the past in that area. \n The event shown is typically the most tragic, violent, or otherwise significant event that has occurred within a period of time, determined by how much matter is placed into the hourglass: a pinch shows up to a day; two pinches show up to a month; three pinches show up to a year, and if completely filled, the hourglass can show events that have transpired several centuries ago. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Scabbard of Sharpening",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic scabbard reshapes itself to fit any nonmagical dagger or sword that is placed into it. A weapon that has been kept in the scabbard for 1 hour or more becomes a magic weapon with a +1 bonus to attack and damage rolls. This effect lasts for 1 hour after the weapon has been drawn from the scabbard.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Scroll of Time Travel",
      type: "Scroll",
      subtype: "",
      description:
        "As an action, you can read the scroll to transport you and up to eight willing creatures within 10 feet of you back in time. You can specify a point in time in vague terms (“A hundred years ago”) or in detail (“The day before the High Mage freed the primordial”) and you appear at exactly that time, along with everything you are wearing or carrying. \n If you travel to a point in the past where you existed, you appear exactly where you were and as you were at that point in time, though you retain any objects, experiences, and knowledge you acquired in your future life. Otherwise, you appear in the exact same spot (or nearest unoccupied space) where you used the scroll, though in a different time. \n When you use the scroll, you must also specify how long your visit to the past will last, which can be anything from minutes to forever. When that much time has passed, you and up to eight willing creatures within 10 feet of you are transported back to the present, arriving only a moment after you used the scroll.",
      rarity: "Legendary",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Serpent's Maul",
      type: "Weapon",
      subtype: "Maul",
      description:
        "This magic maul has 3 charges and regains all expended charges daily at dawn. When you hit with an attack roll using it, you can expend 1 charge to force the target to make a DC 15 Wisdom saving throw. On a failure, the target is magically transformed into a <b>constrictor snake</b> until the end of your next turn as with the <i>polymorph</i> spell. ",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "maul_1.png",
    },
    {
      name: "Shapeshifter's Sickle",
      type: "Weapon",
      subtype: "Sickle",
      description:
        "You gain a +1 bonus to attack and damage rolls made with this magic sickle and attack and damage rolls you make while transformed by an effect that replaces your game statistics with those of another creature. In addition, your character level or level in a specific class of your choice is considered to be 2 levels higher than it actually is when determining which creatures you can transform into when using spells or features such as  <i>polymorph</i> or Wild Shape.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Silence Serum",
      type: "Potion",
      subtype: "",
      description:
        "A creature that drinks this potion must succeed on a DC 13 Constitution saving throw or become poisoned for 1 hour. While poisoned this way, the creature can't speak or cast spells that require verbal components.",
      rarity: "Rare",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Smothering Cape",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic cape has 33 hit points and regains all hit points daily at dawn. When an attacker that you can see hits you with an attack, you can use your reaction to halve the attack's damage against you and the cape takes the other half. If the cape is reduced to 0 hit points, you take any remaining damage. \n <b><i>Rug of Smothering.</i></b> As a bonus action, you can speak the cape's command word to cause it to animate. The animated cape has the statistics of a <b>rug of smothering</b>, except for its hit points, which remain the same in either form. The cape is under your control and acts on its own initiative count. On your turn, you can mentally command the cape if it is within 60 feet of you and you aren't incapacitated. You decide what action the cape takes and where it moves during its next turn, or you can issue it a general command, such as to attack your enemies. The cape reverts to its inanimate form after 1 minute or when it is reduced to 0 hit points. Once used, this property can't be used again until the next dawn.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "cloak_2.png",
    },
    {
      name: "Sojourner's Flute",
      type: "Wondrous item",
      subtype: "",
      description:
        "This slender flute has 3 charges and regains all expended charges daily at dawn. As an action, you can play a tune on the flute and expend 1 charge to cast the <i>teleport</i> spell from it. When you do so, you can teleport only to the exact spot where you last played that specific tune on the flute and you always arrive on target. If you play a tune you haven't played on the flute before, you aren't teleported, but instead designate where you return to the next time you use the flute to play that tune. ",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Spellbreaker's Axe",
      type: "Weapon",
      subtype: "Greataxe",
      description:
        "You have a +1 bonus to attack and damage rolls made with this magical greataxe. Once per turn, when you hit a creature with an attack roll using this weapon, you can force the target to make a DC 15 Charisma saving throw. On a failure, it can't cast spells other than cantrips and the magical properties of each non-artifact magic item it is carrying is suppressed until the end of its next turn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Spider's Kiss",
      type: "Weapon",
      subtype: "Longbow",
      description:
        "When you hit with an attack roll using this magic longbow, the target takes an extra 1d8 poison damage. In addition, while you are carrying the bow, you have immunity to poison damage and can't be poisoned. \n <b><i>Spider's Web.</i></b> The bow has 3 charges and regains all expended charges daily at dawn. When you hit a creature with an attack roll using this bow, you can expend 1 charge to have magical webbing envelop it. The target must succeed on a DC 15 Dexterity saving throw or be restrained (escape DC 15) until the end of its next turn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "bow_7.png",
    },
    {
      name: "Strongspirit Mug",
      type: "Wondrous item",
      subtype: "",
      description:
        "As an action, you can cause this magic mug to fill with strong spirits or convert any liquid within it to a strong, alcoholic beverage. A creature that drinks a full mug of this beverage must succeed on a DC 12 Constitution saving throw or become poisoned for 1 hour. A creature poisoned this way has advantage on saving throws against being frightened and gains 2d6 temporary hit points. Once used, this property can't be used again until the next dawn.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Sultan's Khanjar",
      type: "Weapon",
      subtype: "Dagger",
      description:
        "Once per turn, when you hit a hostile creature with an attack roll using this dagger, the dagger gains 1 charge. As an action, you can expend its charges to cast one of the following spells from it (spell save DC 15): <i>hold person</i> (2 charges), <i>invisibility</i> (2 charges) <i>lightning bolt</i> (3 charges), or thunderwave (1 charge). When you cast a spell this way, you can increase the spell's level by 1 for each additional charge you expend. \n If the dagger hasn't been used to make an attack against a hostile creature for 1 minute, it loses all its charges.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Survivor's Armor",
      type: "Armor",
      subtype: "Any",
      description:
        "When your current hit points are equal to or less than half your hit point maximum while wearing this magic armor, you have resistance to bludgeoning, piercing, and slashing damage from nonmagical weapons. \n <b><i>Last Stand.</i></b> When you drop to 0 hit points while wearing this armor, you can choose to remain conscious instead. If you do so, you gain immunity to all damage, have advantage on weapon attack rolls, and weapon attacks you make deal an additional 1d8 radiant damage until the end of your next turn. If you still have 0 hit points at the end of your next turn, you fall unconscious and are dying. Once used, this property can't be used again until the next dawn.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Absorption",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo has 10 hit points and wards against [option] damage. When you take damage of that type, the tattoo takes that damage instead. If this damage reduces the tattoo to 0 hit points, you take any remaining damage and the tattoo disappears.",
      rarity: "Common",
      attunement: "Requires attunement",
      optionName: "Damage Type:",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
      source: "wgtmm",
    },
    {
      name: "Tattoo of Greater Absorption",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo has 20 hit points and wards against [option] damage. When you take damage of that type, the tattoo takes that damage instead. If this damage reduces the tattoo to 0 hit points, you take any remaining damage and the tattoo disappears. ",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
      optionName: "Damage Type:",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
    },
    {
      name: "Tattoo of Superior Absorption",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo has 50 hit points and wards against [option] damage. When you take damage of that type, the tattoo takes that damage instead. If this damage reduces the tattoo to 0 hit points, you take any remaining damage and the tattoo disappears.",
      rarity: "Rare",
      attunement: "Requires attunement",
      optionName: "Damage Type:",
      source: "wgtmm",
      options: [
        [
          { name: "Acid", value: "acid" },
          { name: "Cold", value: "cold" },
          { name: "Fire", value: "fire" },
          { name: "Force", value: "force" },
          { name: "Lightning", value: "lightning" },
          { name: "Necrotic", value: "necrotic" },
          { name: "Poison", value: "poison" },
          { name: "Psychic", value: "psychic" },
          { name: "Radiant", value: "radiant" },
          { name: "Thunder", value: "thunder" },
        ],
      ],
    },
    {
      name: "Tattoo of Death Ward",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "The first time you would drop to 0 hit points as a result of taking damage, you instead drop to 1 hit point, and the tattoo disappears. If the tattoo is still in effect when you are subjected to an effect that would kill you instantaneously without dealing damage, that effect is instead negated against you, and the tattoo disappears.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Devastation",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "Before you make an attack, you can choose to make the attack roll with advantage, and the tattoo disappears. If you do, and the attack hits, it is a critical hit.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Freedom",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "When spells and other magical effects would reduce your speed to 0 or cause you to be paralyzed or restrained, this effect is negated against you, and the tattoo disappears. You can also speak the tattoo's command word as a bonus action to automatically escape from nonmagical restraints, such as manacles or a creature that has you grappled. Once you do so, the tattoo disappears.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Heroism",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "When you become frightened, or when you speak the tattoo's command word as a bonus action, you become imbued with bravery and the tattoo disappears. You gain temporary hit points equal to your character level and you are immune to being frightened for 1 minute.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Power",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "When you cast a spell, you can choose to amplify the effects of that spell in one of the following ways: \n&#8226; The spell takes effect as if it were cast using a spell slot one level higher than the one used to cast it. \n&#8226; One target of the spell has disadvantage on the first saving throw it makes against the spell. \n Once used, the tattoo disappears.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Speed",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo can be used on your turn to gain the following benefits until the start of your next turn, and the tattoo disappears: \n&#8226; Your speed is doubled. \n&#8226; You gain a +2 bonus to AC. \n&#8226; You have advantage on Dexterity saving throws. \n&#8226; You gain an additional action on your turn, that can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action.",
      rarity: "Common",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Greater Speed",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo has 3 charges. You can expend 1 charge on your turn to gain the following benefits until the start of your next turn: \n&#8226; Your speed is doubled. \n&#8226; You gain a +2 bonus to AC. \n&#8226; You have advantage on Dexterity saving throws. \n&#8226; You gain an additional action on your turn, that can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action. \n Once all its charges have been expended, the tattoo disappears.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Superior Speed",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "This magic tattoo has 7 charges. You can expend 1 charge on your turn to gain the following benefits until the start of your next turn: \n&#8226; Your speed is doubled. \n&#8226; You gain a +2 bonus to AC. \n&#8226; You have advantage on Dexterity saving throws. \n&#8226; You gain an additional action on your turn, that can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action. \n Once all its charges have been expended, the tattoo disappears.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tattoo of Spell Turning",
      type: "Wondrous item",
      subtype: "Tattoo",
      description:
        "When you are the target of a spell or spell attack that targets only you, you can choose either to make your saving throw against that spell with advantage, or that the spell attack has disadvantage against you, and the tattoo disappears. If you successfully save against the spell or the spell attack misses you, the spell has no effect on you and instead targets the caster, using the slot level, spell save DC, attack bonus, and spellcasting ability of the caster. If the spell requires concentration, it lasts until the end of the caster's next turn, even if they choose not to maintain their concentration on it.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Temperate Blanket",
      type: "Wondrous item",
      subtype: "",
      description:
        "One side of this 5 feet by 5 feet magic leather blanket is made from the hide of a polar bear while the other is made from salamander skin. While wearing the blanket you can tolerate temperatures as low as −50° Fahrenheit (-45 °C) and as high as 120° Fahrenheit (50 °C) without any additional protection.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Temporal Amulet",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic amulet has 3 charges and regains all expended charges daily at dawn. While wearing it, you can expend 1 charge as a reaction at the end of another creature's turn. You magically appear in the spot you were at the start of that creature's turn, regain any hit points you lost during the turn, and any conditions or effects that began on you since the start of that creature's turn no longer affect you.",
      rarity: "Very Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Thornbow",
      type: "Weapon",
      subtype: "Longbow",
      description:
        "This magic longbow has 3 charges and regains all expended charges daily at dawn. When you hit a creature with an attack roll using the bow, you can expend 1 charge to deal an additional 2d8 piercing damage to the target. If you do, you lose 1d8 hit points. \n <b><i>Hail of Thorns.</i></b> When you roll a 20 on your attack roll using this magic longbow, a rain of thorns sprays from the arrow. The target of the attack and each creature within 5 feet of it must make a DC 15 Dexterity saving throw. A creature takes 2d10 piercing damage on a failed save, or half as much on a successful one.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Thunderbolt Trident",
      type: "Weapon",
      subtype: "Trident",
      description:
        "You have +1 to attack and damage rolls made with this magic trident, which has the finesse property. \n <b><i>Chain Lightning.</i></b> This trident has 3 charges and regains all expended charges daily at dawn. When you hit a creature with an attack made with it, you can expend 1 charge to deal an extra 2d8 lightning damage to the target. Up to three bolts then leap from that target to as many as three other targets within 30 feet of it. A target must make a DC 15 Dexterity saving throw, taking 2d8 lightning damage on a failed save, or half as much damage on a successful one.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Tinker's Glasses",
      type: "Wondrous item",
      subtype: "",
      description:
        "These magic glasses have 3 charges and regain all expended charges daily at dawn. While wearing them, you can expend 1 charge as a bonus action to gain one of the following benefits for 10 minutes or until you take the glasses off: \n&#8226; You have advantage on Wisdom (Perception) checks that rely on sight. \n&#8226; You have advantage on Intelligence (Investigation) checks that rely on sight. \n&#8226; You can see magical auras around any visible creature or object out to a range of 30 feet that bears magic, and you learn its school of magic, if any.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Tonguelasher",
      type: "Weapon",
      subtype: "Rapier",
      description:
        "When you hit a creature with an attack roll using this magic rapier, the target takes an extra 1d8 psychic damage and has disadvantage on the next saving throw it makes before the end of your next turn.",
      rarity: "Very Rare",
      attunement: "",
      source: "wgtmm",
      imageSRC: "sword_12.png",
    },
    {
      name: "Transmuter's Robe",
      type: "Wondrous item",
      subtype: "",
      description:
        "When you fail a saving throw against an effect that would alter your form while wearing this magic robe, you can choose to succeed instead. \n <b><i>Transmuter's Boon.</i></b> The robe has 3 charges and regains all expended charges daily at dawn. As a bonus action, you can expend 1 charge to gain one of the following benefits for 1 minute or until you use this property again: \n&#8226; You gain 2d12 temporary hit points. \n&#8226; Your speed is doubled and your jump distance is tripled. \n&#8226; You gain advantage on Strength, Dexterity, and Constitution saving throw and ability checks. \n&#8226; You gain advantage on Intelligence, Wisdom, and Charisma saving throws and ability checks.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
      imageSRC: "cloak_3.png",
    },
    {
      name: "Transmuter's Stone",
      type: "Wondrous item",
      subtype: "",
      description:
        "While carrying this magic orb, you gain one of the following benefits: \n&#8226; Darkvision out to a range of 60 ft. \n&#8226; Proficiency in one saving throw of your choice. \n&#8226; Resistance to one damage type of your choice. \n You can change which benefit you gain from the stone whenever you finish a short or long rest.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Trekker's Helmet",
      type: "Wondrous item",
      subtype: "",
      description:
        "While wearing this magic helmet, your proficiency bonus is doubled for any ability check you make that uses the Survival skill. In addition, when you make a Strength or Dexterity ability check, you can choose to gain advantage on the roll. Once used, this property can't be used again until the next dawn.",
      rarity: "Uncommon",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Truestrike Crossbow",
      type: "Weapon",
      subtype: "Any Crossbow",
      description:
        "This magic crossbow has 3 charges and regains all expended charges daily at dawn. As a bonus action, you can expend 1 charge and set the crossbow's sight on a target you can see within 60 feet. For 1 minute or until you choose a new target, you have advantage on ranged attack rolls against it using this weapon. In addition, you ignore half cover and three-quarters cover when making ranged attacks against the target with this crossbow. If the target becomes invisible or heavily obscured, you can see it as if it was fully visible.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Vial of Spiders",
      type: "Wondrous item",
      subtype: "",
      description:
        "This palm-sized vial is filled with exactly 888 tiny spiders. The spiders magically obey the verbal commands of the last person to open the vial. Too small to harm Tiny or larger creatures, the spiders have little use in combat, but can be used as sentries, to creep people out, or to keep a small house clear of insects. New spiders grow in the bottle at night, so that 888 spiders always exist at a time.",
      rarity: "Common",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Wand of Quickness",
      type: "Wand",
      subtype: "",
      description:
        "This magic wand has 3 charges and regains all expended charges daily at dawn. When you cast a spell that has a casting time of 1 action while holding this wand, you can expend 1 charge to change the casting time to 1 bonus action for this casting.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Wand of the Director",
      type: "Wand",
      subtype: "",
      description:
        "This magic wand has 3 charges and regains all expended charges daily at dawn. As an action, you can expend 1 charge and point the wand at a creature you can see within 30 feet. That creature can immediately use its reaction to move up to its speed or make one weapon attack.",
      rarity: "Uncommon",
      attunement: "",
      source: "wgtmm",
    },
    {
      name: "Watcher's Visage",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic helmet has 3 charges and regains all expended charges daily at dawn. As an action, you can expend 1 charge to gain one of the following benefits for 1 hour or until you take the helmet off: \n&#8226; You have darkvision out to a range of 60 feet. \n&#8226; You can see invisible creatures and objects, as well as see into the Ethereal Plane, out to a range of 60 feet. \n&#8226; You can see magical auras around any visible creature or object out to a range of 30 feet that bears magic, and you learn its school of magic, if any.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    {
      name: "Wondrous Bestiary",
      type: "Wondrous item",
      subtype: "",
      description:
        "This magic book contains descriptions of a seemingly infinite assortment of creatures. You can reference the book whenever you make an Intelligence check to recall information about a type or subtype of creature (such as an Elf, a Dragon, or a Zombie). When you do so, double your proficiency bonus on that check. \n <b><i>Instant Recollection.</i></b> The book has 3 charges and regains all expended charges daily at dawn. As a bonus action, you can speak its command word to magically recall information about a creature you can see within 30 feet. Choose one of the following pieces of information to learn: \n&#8226; The creature's AC, maximum Hit Points, and Speed. \n&#8226; The creature's Ability Scores and Saving Throw proficiencies. \n&#8226; The creature's Damage Vulnerabilities, Damage Resistances, Damage Immunities, and Condition Immunities, if it has any. \n&#8226; Which actions the creature has, though not the exact details of those actions. \n&#8226; Any special qualities and defenses, such as Legendary Resistance or Magic Resistance. \n If the creature has statistics beyond what is typical for its race, type, or subtype (such as a Goblin with special actions and additional hit points), you may not able to learn these unique statistics, at the GM's discretion.",
      rarity: "Rare",
      attunement: "Requires attunement",
      source: "wgtmm",
    },
    
  ],
};
